// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/app-home/sec2/slick-prev.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/images/app-home/sec2/slick-next-2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/images/about/banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/images/blog/banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/images/admedia/banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/images/blog_read/Banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/images/Ellipse 1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../public/images/Active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../public/images/Polygon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../public/images/app-home/sec2/slick-next-3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../public/images/about/banner-tab.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../public/images/blog_read/1-md.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../public/images/blog_read/1-sm.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `li {
  font-size: 14px;
}
.banner-container{
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.home-sec-2 .title1, .home-sec-3 h1,.home-sec-4 h2,
  .row.sec-title .yellow-line, .blog-sec-2 h2, .blog-sec-4 h2,
  .contact-section-2 h1{
    font-size: 40px !important;
    line-height: 46px !important;
  }
.home-sec-1 .logo-video{
  padding-left: 2rem;
  width: 80%;
  height: auto;
}




.banner-logos{
  position: relative;
  top: 1rem;
}
.banner .banner-container {
  transition: opacity 3s ease-in-out;
}
.banner .slick-slide{
  opacity: 1;
}

/* .banner .slick-slide{
  transition: transform 0.5s ease !important; 
} */

.section{
  background: #FAEC24;
  margin-top: 9rem !important;
  /* border-radius: 75px; */
  border-bottom-left-radius: 70px;
  border-bottom-right-radius: 70px;

  background-repeat: no-repeat;
  width: 75%;
  margin: auto;
  background-position: center center;
  background-size: cover;
  backface-visibility: hidden;
  transform: translate3d(0,0,0) ;
  position: relative;
}
.hidden-lg{
  display: none !important;
}
.home-banner-container{
  background-size: cover;
  padding-bottom: 9rem;
}
.bold{
  font-weight: bold;
}
.timeline{
  /* margin-top: 18rem; */
  height:180px;
}
.timeline{
  display: flex; 
  flex-direction: column; 
  justify-content: baseline;
  position: relative;
  top: 2rem;
}
.background{
  background-image:linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);
}
.banner .slick-prev::before, .banner .slick-next::before{
  display: none !important;
}
.banner .slick-arrow.slick-next, .blog-sec-4 .slick-arrow.slick-next, .admedia-sec-4 .slick-arrow.slick-next{
  display: none !important;
}
.banner.slick-arrow.slick-prev, .blog-sec-4 .slick-arrow.slick-prev, .admedia-sec-4 .slick-arrow.slick-prev{
  display: none !important;
}
.banner{
  min-height: 100vh;
}
input .input-box:focus{border:2px solid #FAEC24 !important;}
.banner h1{
  color: #FFF;
  font-family: Poppins;
  font-size: 50px !important;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.8px;
  text-transform: uppercase;
  text-align: left;
  margin-bottom: 8px;
}

.home-sec-4 {
  padding-top: 6rem;
  padding-bottom: 6rem;
  padding-left: 0;
  padding-right: 0;
}

.banner .first-slide{
  color: #ffffff;
  font-weight: 700;
  /* font-size: 43px; */
  
}
.banner .first-slide svg{
  vertical-align: baseline;
  position: relative;
  left: 5px;
  top: 5px;
  height: 100%;
}

.banner .bold{
  font-weight: 500 !important;
}
.banner h1 span{
  color:#FFF;
  font-weight: 700;
}
.banner p{
  color: #FFF;
  font-family: Poppins;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  text-align: left;
  max-width: 82%;
}
.banner-timeline{
  margin-left: 4.4rem;
}
.line{
  border-top: 1px solid white;
  margin-top: 15px;
  width: 6rem;
  justify-content: end;
}
.banner-timeline .row h4{
  font-family: Bebas Neue;
  font-size: 25px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  color:#9F9F9F;
  justify-content: center;
}
.banner-timeline .row.active h4{
  color:#fff;
  font-size: 35px;
  line-height: 30px;
  width: 10px;
  height: 30px;
}
.yellow-line{
  position: relative;
  width: fit-content;
  text-transform: uppercase;
}

.home-sec-1{
  height: fit-content;
  /* margin-bottom: 3rem; */
}
.home-sec-1 h1{
  font-family: Poppins;
  font-weight: 400;
  font-size: 60px;
  text-align: center;
}

.home-sec-1 h1 span{
  color: #FFC700;
  ;
  font-size:100px;
}
/* .logo-arrow{
  position: fixed;
} */
/* .home-container{
  padding-left: 5rem;
} */
.home-sec-2{
  background-color: #fff;
  height: fit-content;
  padding-top: 3rem;
  padding-bottom: 3rem;
  /* padding-left: 5rem; */
  font-family: Poppins;
}

.home-sec-2 .yellowline {
  height: 4px;
  width: 130px;
  background-color: yellow;
  position: relative;
  top: 2rem;
}
.home-sec-2 .title1{
  position: relative;
  top: 3rem;
  font-size: 38px;
  padding: 0;
  padding-bottom: 1rem;
}

.home-sec-3{
  font-family: Poppins;
  color: #000;
}

.home-sec-3 h1{
  /* max-width: 60%; */
  line-height: 48px;
  font-size: 38px;
  font-weight: 700;
  font-family: Poppins;
  color: #000;
  
}
.home-sec-3 span{
  text-transform: uppercase;
  margin: 1rem 0;
  color: #000;
  
}
.home-sec-3 .theme{
  margin-top: 2rem ;
  margin-bottom: 2rem ;
}
.home-sec-3 .yellowline {
  height: 4px;
  width: 130px;
  background-color: yellow;
  position: relative;
  margin-bottom: 10px;
}


.contact-sec.form-section {
  margin-bottom: 8rem; 
}
.contact-row-line{
  width: 100%;
  border-bottom: 1px solid #fff4;  
  margin-bottom: 3rem;
}

.home-sec-3 .frame-icon{
  position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 64px;
    height: 64px;
    opacity: 90%;
}
.home-sec-3 .play-icon{
  margin-top: -7px;

}


/* ========= */
.yellow-line:before{
  content: "";
  width:100%;
  max-width: 130px;
  height: 4px;
  background-color: #FAEC24;
  position: absolute;
  top: -15px;
  left: 0;
}
/* .home-sec-2{
  background-color: #fff;
} */

.home-sec-2 .slick-list{
  height: 550px;
}
.home-sec-2 h4, .home-sec-2 p{
  color: #fff;
  margin-bottom: 0px;
}
.home-sec-2 h4{
  font-weight: 400;
  font-size: 22px;
  line-height: 32px;
}
.home-sec-2 p{
  font-size: 16px;
  font-weight: 300;
  line-height: 27px;
  color: #000;
  text-align: left;
  padding-left: 5px;
}
.home-sec-2 .contactus{
  font-weight: 600;
}
/* .home-sec-2 .slick-next::before,.home-sec-2 .slick-prev::before{
  margin: 0 6rem;
} */
/* .home-sec-2 .slick-next, .home-sec-2 .slick-prev{
  top: -11%;
} */
/* .home-sec-2 .slick-next{
  right: 12rem;
} */
.home-sec-2 .slick-prev{
  position: absolute;
  top: calc(-10% - 20px);
  left: calc( 100% - 6.5rem);
  transform: translateX(-50%); 
  font-size: 0;
}
.home-sec-2 .slick-next{
  position: absolute;
  top: calc(-10% - 20px);
  /* left:45%; */
  transform: translateX(-50%); 
  font-size: 0;
  right: 1rem;
}


/* .home-sec-2 .slick-prev{
  left: calc( 100vw - 380px);
} */
.home-sec-2 .slick-prev::before{
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.home-sec-2 .slick-next::before{
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.home-sec-2 .product-card-slider{
  width: 100%;
  padding-top: 0rem;
}

.home-sec-2 .card{
  width: 300px;
  height: 410px;
  background-size: cover;
  background-position: center;
  position: relative;
  border: none;
  border-radius: 0px;
  margin: 8px;
  margin-top: 46px;
  transition: all ease 0.5s;
  font-family: Poppins;
  text-transform: uppercase;
  color: #000;
  top: 0;
  transition: all 1s ease;
  overflow: hidden;
}


.home-sec-2 .card-body{
  position: absolute;
  bottom: 0;
  opacity: 0;
  width: 100%;
  height: fit-content;
  background-color: white;
  padding: 30px 28px 30px 28px; 
  box-sizing: border-box;
  text-align: left;
  transition: all 1s ease;
}

.home-sec-2 .card:hover{
  height: 450px;
  z-index: 2;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  top: -20px;
  
}

.home-sec-2 .card:hover .card-body{
  opacity: 1;
  /* height: fit-content; */
  /* padding: 30px 28px 30px 28px;  */
}
/* .home-sec-2 .card-body:hover{
  opacity: 1;
} */
/* .home-sec-2 .slick-slide:hover {
  width: 410px;
  transition: .7s ease;
} */

/* .home-sec-2 .slide{
  padding-right: 15px;
 
} */

.home-sec-2 .box{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  /* background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%); */
  align-items: flex-start;
  text-align: left;
  padding: 55px 25px;
  transition: all ease 0.3s;
}
.home-sec-2 .box:hover{
  transform: scale(1.02);
  z-index: 2;
}
.home-sec-2 h2{
  margin-bottom: 40px;
  color: #000;
  font-weight: 700;
}
.home-sec-3{
  height: fit-content;
  margin-top: 7rem;
}
.none{
  transition: all ease 0.3s;
}
/* .none:hover{
  transform: scale(2,1.5);
  z-index: 2;
} */
.home-sec-3 span {
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.02em;
  text-align: left;
  color:#000000;
}
.home-sec-3 p{
  font-family: Poppins;
  font-size: 16px;
  font-weight: 300;
  line-height: 27px;
  letter-spacing: -0.02em;
  text-align: left;
  color:#000000;
}
.home-sec-4 h2{
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 6px;
  font-size: 38px;
  font-weight: 700;
  font-family: Poppins;
}
.home-sec-4>div{
  display: flex;
  flex-wrap: wrap;
  height: fit-content;
  width: fit-content;
  justify-content: space-between; 
}
.home-sec-4 .card{
  height: 340px;
  width: calc(33.33% - 10px); 
  margin: 5px; 
  border: none;
  border-radius: 0;
  transition: all ease 0.8s;
  position: relative;
  overflow: hidden;

}

.home-sec-4 .image-container {
  position: relative;
  width: 101%;
  height: 100%;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-size: cover;
  transition: transform 0.8s ease;
  transform-origin: center center;
  
}

.home-sec-4 .card .image-container:hover {
  transform: scale(1.05);
}
.home-sec-4 .card:last-child .image-container:hover {
  transform: none;
}


.home-sec-4 .card .box{
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 30px 28px;
  transition: ease 0.4s;
  position: absolute;
  
  

}
/* .home-sec-4 .card:nth-child(8) .box{
  opacity: 0.83;
  background: linear-gradient(180deg, #FAEC24 0%, #000 100%);
} */
.home-sec-4 .yellow-line:before{
  content: "";
  width:100%;
  max-width: 125px;
  height: 4px;
  background-color: #FAEC24;
  position: absolute;
  top: -15px;
  left: calc( 50% - 62px );
}
.home-sec-4 h4{
  color: #FFF;
  margin: 0;
  font-size: 34px;
  line-height: 46px;
}
.home-sec-4 .card .line{
  position: absolute;
  top: 55%;
  left: 34%;
  width:0px;
  border-top: 5px #fff solid;
  transform: translateX( -50%, 50% );
  transition: width 0.5s ease;
  transform-origin:  left;
}

.home-sec-4 .card:last-child .box{
  background: linear-gradient(180deg, #00000070 0%, #00000060 100%);
  transition: all 0.5s ease;
}
.home-sec-4 .card:last-child .box:hover {
  
  background: linear-gradient(180deg, #0000009b 0%, #000000b6 100%);
}
.home-sec-4 .card:last-child .box:hover div{
  cursor: pointer;
}

.home-sec-4 .card:last-child .box:hover .line{
  width: 120px;
  
}


.home-sec-5{
min-height: fit-content;
background: #fff;
/* padding-left: 3rem; */
}
.home-sec-5 .scroller{
  height: 395px;
  overflow-y: scroll;
}
::-webkit-scrollbar {
  width: 3px;
  height: 5px;
  display: none;
}
::-webkit-scrollbar-track {
  background: black
  
}
::-webkit-scrollbar-thumb {
  background: #888888cb;

}
::-webkit-scrollbar-thumb:hover {
  display: contents;
}
.home-sec-5 .strip{
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 79px;
  transition: all 0.5s ease;

}
.home-sec-5 .seg1{
  width: 15%;
  text-align: left;
  transition: all 0.5s ease;
}
.home-sec-5 .seg2{
  width: 80%;
  line-height: 50px;
  transition: all 0.5s ease;
}
.home-sec-5 .seg3{
  width: 18%;
  transition: all 0.5s ease;
}
.home-sec-5 span{
  font-family: Poppins;
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #fff; 
  transition: all 0.5s ease;
}
.home-sec-5 button{
  font-family: Poppins;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: -0.02em;
  text-align: right;
  color: #FAEC24;
}
.home-sec-5 .strip.active span, .home-sec-5 .strip.active button{
  opacity: 100%;
}
.home-sec-5 .strip.active1 span, .home-sec-5 .strip.active1 button{
  opacity: 30%;
}
.home-sec-5 .strip.active2 span, .home-sec-5 .strip.active2 button{
  opacity: 15%;
}
.home-sec-5 button{
  font-family: Poppins;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: -0.02em;
  text-align: right;
  color: #FAEC24;
}
.home-sec-5 button:hover, .home-sec-5 button:focus {
  color: #a19705;
}
.home-sec-6 p {
  color: #f6f6f6;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  max-width: 60%;
}
.button{
  background-color: white;
  padding:10px 25px;
}
.home-sec-6 h1 span {
 color: #FAEC24;
}
.simple-slider {
  height: 350px;
}
.simple-slider .slide {
  padding: 40px 25px;
  border: 1px solid #191919;
  height: 250px;
}
.simple-slider h4 {
  font-weight: 700;
  width: 200px;
}
.home-sec-3 .box{
  width: 100%;
  height: 96%;
}

.frame-icon{
  position: relative;
  top: 50%;
  z-index: 10;
  left: 1%;
  opacity: 60%;
}
/* Thumbnail image  */

.about-banner-container, .blog-banner-container ,
.ad-media-banner-container,.blogRead-banner-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});

  /* Full height */
  height: 100vh; 
  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position:bottom;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  /* transition: background-size 0.3s ease; */
}
.banner h1{
  line-height: 62px;
  font-weight: 700;
  
}
.blog-banner-container .banner h1 span{
  color: #FAEC24;
}
.about-banner-container .banner{
  height: 100%;
  position: relative;
}

.blog-banner-container{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.ad-media-banner-container{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  padding: 0;
}
.blogRead-banner-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  height: 570px;
  background-attachment: fixed;
  background-position:bottom;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.ad-media-banner-container .parallax-img{
  margin-right:0;
  height: 100vh;
}
.ad-media-banner-container .banner{
  padding: 0;
  margin: 0;
  min-width: 100%;
}
.ad-media-banner-container .text-overlay {
  width: 75%;
  padding-left: 4rem;
}
.ad-media-banner-container .banner p {
  max-width: 77%;
}


.parallax-img{
  max-width: 100%;
  height:100%;
  margin-right: 20px;
  position: relative;
  align-self: flex-end
}

.blog-banner-container .text-overlay{
  width: 75%;
}

.text-overlay {
  position: absolute;
  top: 40%;
  left: 0%;
  width: 50%;
  text-align: center;
  color: white;
  z-index: 2;
}

.text-overlay h1 {
  font-size: 24px;
  /* margin: 0; */
  margin-bottom: 1rem;
}




.about-section-2{
  padding-top: 5rem;
  padding-bottom: 5rem;
  height: fit-content;
  background: #fff;
  text-align: left;
}


.thumbnail{
  border-radius: 0px;
}
.about-img{
  border-radius: 10px;
}

.destination-sec-5 .about-exp{
  padding-bottom: 30px;
}


.destination-banner-container{
  background-size: cover;
}
.destination-banner{
  min-height: 100vh;
}
  .destination-banner h1{
    color: #FFF;
    font-family: Poppins;
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
    letter-spacing: -0.8px;
    text-transform: uppercase;
    text-align: left;
  }
  .destination-banner h1 span{
    color:#FAEC24;
    font-size: 60px;
    font-weight: 500;
  }
  .asia .col-lg-7{
    width: 51%;
  }
  .africa .col-lg-7{
    width: 53%;
  }
  .europe .col-lg-7{
    width: 57%;
  }
  .p{
    max-width: 100% !important;
    margin-top: 0.25rem;
  }
  .destination-banner p{
    color: #FFF;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    text-align: left;
    max-width: 82%;
  }
  #dropdown-btn{
    padding: 6px 27px;
    font-family: Montserrat;
    font-size: 15px;
    font-style: italic;
    font-weight: 500;
    position: relative;
    display: inline-block;
    background: #FAEC24;
    color: #000;
    border: none;
    border-radius: 20px;
    cursor: pointer;
  }
  .dropdown-item{
    color: white;
    text-align: center;
    line-height: 30px;
    font-weight: 500;
  }
  .dropdown-item:hover{
    background: #000000;
    color: white;
  }
  .dropdown-menu{
    background-color:black;
    padding:5px 35px ;
   margin-left: 8px;
  }
.destination-banner .col-lg-5{
  width: 34.6667%;
  }
.destination-sec-2{
  height: 100vh;
}
.destination-sec-2 p{
  font-family: Poppins;
  font-size: 18px;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: -0.02em;
  text-align: left;
  color:#fff;
}
.destination-sec-2 h1{
  max-width: 48%;
  line-height: 2.9rem;
  text-align: center;
  font-size: 38px;
  font-weight: 400;
}
.destination-sec-2 .yellow-line:before{
  content: "";
  width:100%;
  max-width: 130px;
  height: 4px;
  background-color: #FAEC24;
  position: absolute;
  top: -12px;
  left: calc( 50% - 65px );
}
.destination-sec-3 p{
  font-family: Poppins;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.02em;
  text-align: left;
  color:#fff;
  margin-bottom: 3px;
}
.destination-sec-3 h1{
  line-height: 3rem;
  text-align: left;
  font-size: 38px;
  font-weight: 400;
}
.destination-sec-3 .yellow-line:before{
  content: "";
  width:100%;
  max-width: 130px;
  height: 4px;
  background-color: #FAEC24;
  position: absolute;
  top: -15px;
  left: 0%;
}
.destination-sec-3 .card{
  border: none;
  border-radius: 10px;
  position: relative;
  top: -38%;
  transition:all ease 0.3s;
}
/* .destination-sec-3 .card:hover{
  transform: scale(0.98);
  z-index: 2;
} */
/* .destination-sec-3 .card .box:hover{
  transform: scale(1);
  z-index: 2; */
/* } */

.destination-sec-3.discover .card:hover{
  height: 350px;
  transition: all ease 0.6s;
}



.destination-sec-3 .card .box{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: linear-gradient(182deg, rgba(0, 0, 0, 0.00) 20.68%, #000000 99%);
  align-items: flex-start;
  text-align: left;
  padding: 40px 18px;
  transition: all ease 0.3s;
  /* border-radius: 10px; */
}
.destination-sec-3 .card{
  height: 320px;
   width:280px;
   margin-top: 40%;
   transition: all ease 0.6s;
}
.destination-sec-3 .card-1{
  height: 320px;
  width:270px;
  margin-left:0px;
}
.destination-sec-3 .card:nth-child(8) .box{
  opacity: 0.83;
  background: linear-gradient(180deg, #FAEC24 0%, #000 100%);
}
.destination-sec-3 .disc-h4{
  margin-bottom: 0px;
}
.destination-sec-3 h4{
  color: #FFF;
  text-align: left;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 3px;
  letter-spacing: -0.5px;
  text-transform: uppercase;
}
.destination-sec-4 h1{
  line-height: 2.5rem;
  text-align: left;
  font-size: 28px;
  margin-left: 20px;
}
.destination-sec-4 p{
  font-family: Poppins;
  font-size: 18px;
  font-weight: 300;
  line-height: 25px;
  letter-spacing: -0.02em;
  text-align: center;
  color:#fff;
}
.destination-sec-5 h1{
  max-width: 55%;
  line-height: 2.9rem;
  text-align: center;
  font-weight: 400;
  font-size: 38px;
}
.destination-sec-5 .yellow-line:before{
  content: "";
  width:100%;
  max-width: 130px;
  height: 4px;
  background-color: #FAEC24;
  position: absolute;
  top: -15px;
  left: calc( 50% - 65px );
}
.destination-sec-5 h4{
  color: #fff;
  line-height: 24px;
  margin-bottom: 0px;
  font-size: 20px;
  font-weight: 400;
}
.destination-sec-5 p{
  color: #fff;
  margin-top: 3px;
}
.destination-sec-5 .card{
  border: none;
  margin: auto;
  border-radius: 10px;
  height: fit-content;
  width: 88%;
  transition: ease 0.5s;
  height: 468px;
}


/* .destination-sec-5 .slide:hover :not(:hover) .card{
  width: 80%;
  transform: scale(1);
} */

.destination-sec-5 .title-1{
  margin-bottom: 3rem;
}

.destination-sec-5 .me-title{
  margin-top: -4rem;
}




/* .destination-sec-5 .slide-container:hover .slick-slide{
  width: 800px;
} */
/* .transform-card-in:hover{
  transform: scale(.94);

} */


/* SLIDER */
/* .destination-sec-5 .slide{
  background-color: red;
  height: 240px;
  border: 2px solid #000;
  width: 200px !important;
}

.destination-sec-5 .slide:hover {
  background-color: yellow;
  width: 220px !important;

} */

.scroll-top span{
  color: #fff;
  font-size: 11px;
  font-weight: 300;
  font-family: Montserrat;
 }
 .scroll-top .scroll-top-btn{
  margin-bottom: -2.5rem ;
 }

.destination-sec-5 .slide-container1 .slick-current  {
  width: 500px !important;
}

.destination-sec-5 .slide-container1{
  border: 2px red;
}




.destination-sec-5 .slide-container{
  position: relative;
  overflow: hidden;
}
.destination-sec-5 .row{
  max-width: 92%;
  margin: auto;
}
.destination-sec-5 .slick-next::before,.destination-sec-5 .slick-prev::before{
  display: none;
}
.destination-sec-5 .box{
  height: 100%;
  width:100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000000 100%);
  align-items: flex-start;
  text-align: left;
  padding: 40px 28px;
  border: none;
  /* border-radius: 10px; */
  transition:ease 0.3s;
  font-size: 20px;
  font-weight: 400;
}

/* other button 01 */

.form-section  .other01-btn {
  font-size: 16px;
  font-weight: 600;
  border: 2px solid #000;
  transition: all ease .7s !important;
}

.form-section  .other01-btn:hover {
  background: #FAEC24;
  color: #000000;
  border-color: #FAEC24; 
  transition: all ease .5s;
}

.form-section .other01-btn:active {
  background: black;
  color: white;
  border-color: transparent; 
}

.form-section .other01-btn:disabled {
  background: #ECE9E9;
  color: #9F9F9F;
  border-color: transparent; 
}



.travel-btn, .button {
  font-family: Poppins;
  border-radius: 0px;
  font-size: 16px;
  margin-right: 10px !important;
  font-weight: 400;
  /* max-height: 42px; */
  border: 2px solid transparent;
  transition: all ease .7s !important;
  padding: 10px 65px 10px 65px;
}

.travel-btn:hover {
  background: #000000;
  color: #FAEC24;
  border-color: #FAEC24; 
  transition: all ease .5s;
}

.travel-btn:active {
  background-color: #FAEC24 !important;
  color: rgb(0, 0, 0) !important;
  border-color: #FAEC24;  
}

.travel-btn:disabled {
  background: #ECE9E9;
  color: #9F9F9F;
  border-color: transparent; 
}

button{
  font-weight: 100;
}
/* contact button */
.contact-btn {
  border-radius: 0px;
  font-family: Poppins;
  font-weight: 400;
  /* max-height: 42px; */
  font-size: 16px;
  background: #000000 !important;
  border: 2px solid white;
  color: #fff;
  padding: 10px 44px;
  transition: all ease .7s !important;
}
.contact-btn:hover{
  background: #FAEC24 !important;
  border-color: #FAEC24; 
  color: #000;
  }
.contact-btn:active{
  background: #000000 !important;
  color: #FAEC24 !important;
  border: 2px solid #FAEC24 !important;
  transition: all ease .5s;
} 
.contact-btn:disabled {
  background: #ECE9E9 !important;
  color: #9F9F9F !important;
  border-color: none !important;
  transition: all ease .5s !important;
}


 .home-sec-6 .button{
  padding: 10px 15px 10px 15px;
  font-weight: 600;
 }
.contact{
  padding: 8px 25px;
  color: #000;
  font-family: Montserrat;
  font-size: 16px;
  font-style: italic;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.36px;
}

/* .dest-contact{
  padding: 8px 25px;
  background-color: #CAC251  ;
  color: #000;
  font-family: Montserrat;
  font-size: 16px;
  font-style: italic;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.36px;
  border: none;
}
.dest-contact:hover{
  background-color: #CAC251  ;
  color: #000;
  border: none;
 
} */

/* detination-contact button */

.dest-contact {
  font-size: 16px;
  font-weight: 600;
  background-color: #CAC251;
  border: 2px solid transparent;
  transition: all ease .8s !important;
  padding-right: 3px;
  padding-left: 15px;
  padding-top: 5px;
  padding-bottom: 4px;
}
.dest-contact .arrow-icon{
  margin-left: 8px;
}

.dest-contact:hover {
  background: #000000;
  color: #CAC251 !important;
  border-color: #CAC251 !important; 
  transition: all ease .8s;
}

.dest-contact:hover svg path{
  stroke: #CAC251 !important;
  transition: all ease .5s;
}

.dest-contact:active {
  background: black !important;
  color: white !important;
  border-color: black !important;
}
.dest-contact:active svg path{
  stroke: #ffff !important;
  transition: all ease .5s;
}

.dest-contact:disabled {
  background: #ECE9E9;
  color: #9F9F9F;
  border-color: transparent; 
}

.dest-contact:disabled svg path{
  stroke: #9F9F9F !important;
  transition: all ease .5s;
}




/* Blog */

.blog,.shop{
  background-color: white;
}
.blog-banner-container{
  background-size: cover;
}
.blog-banner{
  min-height: 100vh;
}
  .blog-banner h1{
    color: #FFF;
    font-family: Poppins;
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
    letter-spacing: -0.8px;
    text-transform: uppercase;
    text-align: left;
  }
  .blog-banner h1 span{
    color:#FAEC24;
    font-size: 40px;
    font-weight: 500;
  }

  .blog-banner h1 span:after {
    content: '.';
    color: #FFF; 
    margin-left: 5px; 
}
  .blog-banner p{
    color: #FFF;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    text-align: left;
    max-width:84%;
  }
  .blog-banner .btn-primary{
    padding: 6px 30px;
    font-family: Montserrat;
    font-size: 17px;
    font-style: italic;
    font-weight: 500;
  }
  .blog-sec-2{
    background-color: white;
    
  }
  
.blog-sec-2 h2{
  color: #000000;
  text-transform: uppercase;
  font-weight: 700;
}
.blog-sec-2 h5{
  text-align: left;
  color: #D3C61A;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px;
}
 .blog-sec-2 span:hover{
  color:  #d3c61a;
  cursor: pointer;
}
.blog-sec-2 h5:hover{
  color: #495057;
  cursor: pointer;
}
.blog-sec-2 span{
  color: #495057;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
  text-align: left;
  margin: 20px;
}
.blog-sec-2 .card{
  border: none;
  transition: all ease 0.2s;
}
.blog-sec-2 .tag{
  position: absolute;
  top: 4%;
  left: 71%;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.20);
}
.blog-sec-2 .tag h2{
  color: #FFF;
  text-align: center;
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 2px;
  padding: 11px 12px 10px;
  margin-bottom: 0;
}
.blog-sec-2 .box{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  text-align: left;
  transition: all ease 0.2s;
}
.blog-sec-2 img{
  width: 400px;
  height: 350px;
}
.checkout-sec-3 .radio{
margin-top: 1.8rem;
}
.blog-sec-2 .card{
  height: 500px;
  margin-bottom: 3rem;
}
.blog-sec-2 h6{
  color: #6C757D;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 15px;
}
hr.solid-small {
  border-top: 2px solid white;
  width: 5%;
  opacity: 0.75;
  margin-left: 47.5%;
}
.blog-sec-2 h4{
  color: #000000;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
  height: 45px;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.blog-sec-2 p{
  color: #000000;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* .blog-sec-2 .text-container {
  width: 80%;
  margin: 50px auto;
  text-align: center;
} */
/* .blog-sec-2 .adventure-text {
  
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
} */

.blog-box { 
  position: relative;
}

.blog-box-img {
  transition: transform 0.5s ease;
  width: 400px;
  transform: scale(1.1);
}

.blog-content{
  padding: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  height: fit-content;
  overflow: hidden;
  transition: all 0.5s ease;
}
.blog-sec-2 .img-hover-zoom {
  overflow: hidden; 
  border-radius: 0px;
  width: 100%;
}

.blog-content:hover{
  box-shadow:none;
}

.blog-sec-2 .img-hover-zoom img {
  transition: transform 0.5s ease; 
}

.img-hover-zoom:hover img {
  transform: scale(1.2);
}



.blog-sec-3-banner-container{
  background-size: cover;
}
.blog-sec-3-banner{
  min-height: 100vh;
}
.blog-sec-3-banner h1{
  line-height: 48px;
  font-size: 40px;
  text-align: center;
  font-weight: 700;
  max-width: 60%;
  margin: auto;
}
.blog-sec-3-banner p{
  color: #E5E5E5;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
}
.blog-sec-4 .yellow-line:before{
  left: 12px;
}
.blog-sec-4 h2{
  color: #000000;
  text-transform: uppercase;
  font-weight: 700;
}
.blog-sec-4 h6{
  color: #E5E5E5;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.blog-sec-4 h4{
  color: white;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; 
  max-width: 70%;
  text-align: left;
  margin-bottom: 5px;
}
.blog-sec-3-banner-container{
  background-position:center;
}
.blog-sec-4 p{
  color: #E5E5E5;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; 
  max-width: 92%;
}
.blog-sec-4 .card{
  border: none;
  margin-right: 25px;
  width: 100%;
}
.blog-sec-4 .box{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  text-align: left;
  padding: 10px 28px;
}

/* Shop */

.shop-sec-2 h2{
  color: var(--font-color, #333);
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: center;
}
.shop-sec-2 h4{
  color: var(--font-color, #333);
  text-align: center;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.shop-sec-2 p{
  color: var(--font-color-1, #666);
  text-align: center;
  font-family: Poppins;
  font-size: 19px;
  font-style: normal;
  font-weight: 400;
  line-height: 0px;
}
.shop-sec-2 .card{
  border: none;
}
.shop-sec-2 .box{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 50px;
}
.shop-sec-2 img{
  height: 450px;
  border-radius: 10px;
  max-width: 100%;
}
.shop-sec-3 h2{
  color: var(--font-color, #333);
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: center;
}
.shop-sec-3 h6{
  color: var(--color-gray-1, #3A3A3A);
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; 
}
.shop-sec-3 h5{
  color: var(--color-gray-3, #898989);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; 
}
.shop-sec-3 p{
  color: var(--color-gray-1, #3A3A3A);
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
}
.shop-sec-3 .tag1{
  position: absolute;
  top: 3%;
  left: 73%;
  background: #E97171;
  border-radius: 60px;
}
.shop-sec-3 .tag1 h2{
  color: var(--color-white, #FFF);
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%; /* 13px */
  padding: 10px;
  width: 48px;
  margin-bottom: 0;
}
.shop-sec-3 .tag2{
  position: absolute;
  top: 3%;
  left: 73%;
  background: #FAEC24;
  border-radius: 70px;
}
.shop-sec-3 .tag2 h2{
  color: #000;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
  padding: 12px 8px;
  margin-bottom: 0;
}
.shop-sec-3 .overlay .btn-primary{
  color: #FFF;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
  border-radius: 0;
  padding: 20px 5px;
}
.shop-sec-3 .card{
  border: none;
  height: 477px;
  text-align:left ;
  transition:ease 0.2s;
  position: relative;
}
.shop-sec-3 .overlay{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 95%;
  height: 96%;
  background:#3a3a3abb ;
  opacity: 0;
  transition:all ease 0.3s;
}
.overlay p{
  color: var(--color-white, #FFF);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
  text-align: center;
  cursor: pointer;
}
.overlay .btn{
  color: #FFF;
  text-align: center;
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
  background: rgba(0, 0, 0, 0.767);
  border: 0.5px solid black;
  padding: 10px 35px;
  border-radius: 0;
}
.overlay .btn:hover{
  border: 0.5px solid white;
}
.shop-sec-3 .card:hover .overlay{
  opacity: 1;
}
.shop-sec-3 .card:hover{
  transform: scale(1.015);
  z-index: 2;
}
.shop-sec-3 .box{
 background-color: #F4F5F7;
 margin-right: 15px;
}
.shop-sec-3 .title-box{
  padding-left: 15px;
}
.shop-sec-3 .btn-primary{
  border: 2px solid #000;
  background: #FFF;
  color: #000;
  text-align: center;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  padding: 10px 60px;
  border-radius: 0; 
  margin-top: 5px;
}
.shop-sec-3 .btn-primary:hover{
  color: #FFF;
  background: #000;
}
.shop-sec-4{
  background-color: #F4F5F7;
}
.shop-sec-4 h1{
  color: var(--color-gray-1, #3A3A3A);
  font-family: Poppins;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}
.shop-sec-4 p{
  color: var(--color-gray-2, #616161);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  max-width: 80%;
  text-align: left;
}
.shop-sec-4 .btn-primary{
  border: 2px solid #000;
  color: #FFF;
  background: #000;
  text-align: center;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  padding: 10px 55px;
  border-radius: 0; 
}
.filter ,.sort{
  align-items: center !important;
  display: flex;
  margin-bottom: 0rem !important;
}
.shop-sec-4 .btn-primary:hover{
  background: #FFF;
  color: #000;
}
.shop-sec-4 .slick-prev::before{
  display: none;
}
.shop-sec-4 .slick-list{
  height: 470px;
}
.shop-sec-4 .slide{
  transition: ease 0.3s;
}
/* .shop-sec-4 .slide:hover{
  transform: scaleY(1.13) scaleX(1.07);
  z-index: 2;
  margin: 10px 0px 0px;
} */
.shop-sec-4 .slick-next, .shop-sec-4 .slick-prev{
  top: 45%;
}
.shop-sec-4 .slick-arrow.slick-next::before{
  /* content: url(../../public/images/right.svg) !important;
  opacity: 1; */
  display: none;
}
.shop-sec-4 .slick-next{
  left: calc( 100vw - 665px);
}
.shop-sec-4 .card{
  margin: 8px;
  border: none;
  height: 415px;
 transition:ease 0.2s;
 position: relative;
}
.shop-sec-4 .box{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  text-align: left;
  padding: 30px 18px;
}
.shop-sec-4 .slick-dots li {
  margin: -2px; 
  line-height: 30px;
}
.shop-sec-4 .slick-dots li button::before{
  line-height: 35px;
  opacity: 1;
}
.shop-sec-4 .slick-dots li button::before {
  content:url(${___CSS_LOADER_URL_REPLACEMENT_6___}) !important;
  margin-top: -2.6rem;
  margin-left: 5.9rem;
}
.shop-sec-4 .slick-dots li.slick-active button::before {
content: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) !important;
}
.shop-sec-4 h4{
  color: var(--color-gray-1, #3A3A3A);
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  max-width: 77%;
  font-weight: 600;
  line-height: 116%; /* 27.84px */
}
.shop-sec-4 .content-box{
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(1.5px);
  -webkit-backdrop-filter: blur(1.5px);
  padding: 10px 0px 0px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  position: absolute;
  top: 68%;
  left: 8%;
  width: 55%;
  height: 25%;
  opacity: 0;
  transition:all ease 0.3s;
}
.shop-sec-4 .slick-current .content-box{
  opacity: 1;
}
.shop-sec-4 .slick-current .card{
  height: 450px;
  width: 350px;
}
.shop-sec-4 .yellow-box{
  display: none;
}
.shop-sec-4 .slick-current .yellow-box{
  width: 35px;
  height: 33px;
  padding: 5px;
  position: absolute;
  top: 85.8%;
  left: 63%;
  background-color: yellow;
  display: block;
}
/* ShopSub */

.admedia-card .slidecard{
  width: 360px;
}
.admedia-card{
  overflow-x: 'auto';
}



.shopSub{
  background-color: white;
}
.shopSub-banner-container{
  background-size: cover;
  padding-top: 5rem;
}
.shopSub-banner-container{
  height: 80vh;
}
  .shopSub-banner h1{
    color: #FFF;
    font-family: Poppins;
    font-size: 42px;
    font-style: normal;
    font-weight: 400;
    line-height: 2.8rem;
    letter-spacing: -0.8px;
    text-transform: uppercase;
    text-align: center;
  }
  .shopSub-banner h1 span{
    color:#FAEC24;
    font-size: 42px;
    font-weight: 650;
  }
  .shopSub-banner p{
    color: #FFF;
    font-family: Poppins;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
  }
  .shopSub-sec-2, .shopSub-sec-4{
    background-color: #E5E5E5;
  }
  .shopSub-sec-2 .col-1{
    width: 3rem;
  }
  .shopSub-sec-2 .col-2{
    width: 5.5rem;
  }
  .shopSub-sec-2 .col-5{
    width: 43rem;
  }
  #dropdown-toggle1{
    background-color: white;
    padding: 2px;
    width: 7.8rem;
    height: 38px;
    color: #495057;
    border-radius: 0;
    border: transparent
  }
  #dropdown-menu{
    background: white;
    min-width: 5rem;
    color: black;
  }
  #dropdown-menu:hover{
    background:  #ECECEC ;
  }
  .shopSub-sec-2 .dropdown-menu{
    background-color: white;
    min-width: 7.8rem;
    margin-left: 0;
    padding: 5px;
  }
 
  .shopSub-sec-4 h6{
    color: #242424;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
  }
  .shopSub-sec-4 p{
    color: var(--color-gray-3, #898989);
    font-family: Poppins;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 6px; 
    text-align: left;
  }
  .shopSub-sec-4 .col-1{
    width: 3.6rem;
    padding: 0;
  }
  .shopSub-sec-4 .col-2{
    width: 14.2rem;
  }


/* ShopSub2 */


.shopSub2-sec-2{
  background-color: #E5E5E5;
  margin-top:7.5rem ;
}
.shopSub2-sec-2 p{
  color: #6C757D;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 3px;
}
.shopSub2-sec-2 h5{
  color: #000;
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  text-align: left;
  line-height: normal;
  margin-top: 5px;
}
.shopSub2-sec-2 .col-2{
  width: 8rem;
}
.shopSub2-sec-4{
  background-color: white;
}
.shopSub2-sec-4 .card{
  background-color: #D9D9D9;
  justify-content: center;
  border: none;
  transition:all ease 0.4s;
}
.shopSub2-sec-4 .card:hover{
  transform: scale(1.3);
  z-index: 2;
}
.shopSub2-sec-4 .col-lg-5{
  border-radius: 10px;
  background: #E5E5E5;
  width: 23rem;
  height: 25rem;
  margin-left: 2rem;
}
.shopSub2-sec-4 h2{
  color: #000;
  font-family: Poppins;
  font-size: 38px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  margin-bottom: 4px;
}
.sofa{
  margin-right: 4rem;
  transition:all ease 0.5s;
}
.sofa:hover{
  transform: scale(1.04);
  z-index: 2;
}
.shopSub2-sec-4 .col-6{
  margin-left: 2rem;
}
.shopSub2-sec-4 h4{
  color: #9F9F9F;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: left;
  margin-bottom: 4px;
}
.shopSub2-sec-4 .col-2{
  width: 7rem;
}
.shopSub2-sec-4 p{
  color: #000;
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height:21px;
  text-align: left;
}
.shopSub2-sec-4 .btn-primary{
  border: 2px solid #000;
  color: #FFF;
  background: #000;
  text-align: center;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  padding: 12px 75px;
  border-radius: 0; 
}
.shopSub2-sec-4 .btn-primary:hover{
  background: #FFF;
  color: #000;
}
.shopSub2-sec-4 .count {
  width: 100px;
  padding: 0;
  border: 1.5px solid black;
  margin-left: 16px;
  padding-top: 2px;
}
.count input{
  width: 40px;
  border-radius: 0;
  text-align: center;
  font-size: 18px;
  border: none !important;
}

.count button{
  background: white;
  border: none !important;
  font-size: 20px;
}
/* Cart */

.cart-1{
  background-color: white;
}
.cart-sec-2-row, .cart-sec-2 .col-lg-4{
  background-color: #E5E5E5;
}
.cart-sec-2 .col-lg-4{
  margin-left: 2.9rem;
  width: 20rem;
}
.cart-sec-2 h3{
  color: #000;
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-left: 4.6rem
}
.price{
  margin-left: 5rem !important;
}
.quantity{
  margin-left: 5.7rem !important;
}
.cart-sec-2 h2{
  color: #000;
  font-family: Poppins;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.cart-sec-2-img{
  border-radius: 10px;
  background: #D9D9D9;
}
.cart-sec-2 img{
  height: 50px;
  max-width: 140px;
  margin-top: 5px;
}
.cart-sec-2 h4{
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
}
.cart-sec-2 .count {
  width: 96px;
  padding: 0;
  border: 1.5px solid black;
  height: 49px;
}
.cart-sec-2 h5{
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
}
.cart-sec-3 h4{
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 2rem;
}
.cart-sec-3 h6{
  color: #495057;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  margin-bottom: 1.9rem;
  line-height: normal;
}
.cart-sec-3 h5{
  color: #000;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-left: 1rem;
}
.cart-sec-2 .btn-primary{
  border: 2px solid #000;
  color: #FFF;
  background: #000;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  padding: 10px 70px;
  border-radius: 0; 
}
.cart-sec-2 .btn-primary:hover{
  background: #FFF;
  color: #000;
}
.cart-sec-2 .col-1{
  height: 60px;
  width: 80px;
}
.cart-sec-2 .box-1 {
  width: 100px;
  padding-top: 6px;
  height: 38px;
  border: 1.5px solid black;
}


/* Checkout */
.checkout-sec-2 ,.checkout-sec-3{
  background-color: white;
}
.checkout-sec-2 h1{
  color: #000;
  font-family: Poppins;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.checkout-sec-3 .form {
  background-color: white;
  color: black;
  width: 455px;
  border-radius: 5px;
  text-align: left;
}
.checkout-sec-3 label {
  display: block;
  margin-bottom: 5px;
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: left;
  width: 97%;
}
.checkout-sec-3 .input-box {
  padding: 10px;
  width: 100%;
  height: 3.3rem;
  margin-bottom: 25px;
  border: 1px solid white;
  border-radius: 0px;
  margin-top: 5px;
}
.checkout-sec-3 h3{
  color: #000;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-left: 3.5rem;
  text-align: center;
}
.checkout-sec-3 h2{
  color: #000;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.checkout-sec-3 h5{
  color: #000;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 4.4rem;
  text-align: center;
  margin-left: 2.7rem;
}
.checkout-sec-3 h4{
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
} 
.checkout-sec-3 h6{
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height:9px;
  text-align: center;
  margin-top: 2rem;
  margin-left: 3rem;
} 
.checkout-sec-3 p{
  color: #9F9F9F;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  margin-top: 2rem;
  max-width: 99%;
}
.para{
  max-width: 88% !important;
}
.checkout-sec-3 .btn-primary{
  border: 2px solid #000;
  color: #FFF;
  background: #000;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  padding: 10px 70px;
  border-radius: 0; 
}
.checkout-sec-3 .btn-primary:hover{
  background: #FFF;
  color: #000;
}
.checkout-sec-3 span{
  color: #000;
  font-family: Poppins;
  font-size: 13.6px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
hr.solid {
  border-top: 2px solid #bbb;
  width: 90%;
}

.checkout-sec-3 h1{
  color: #6C757D;
  text-align: justify;
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.checkout-col{
  margin-left: 2rem;
}
.checkout-col-1{
  margin-left: 2rem;
}
.nopage h4 , .nopage h3{
  color: white;
}
.page-not-found{
  height: 105vh;
}

/* Ad&media */
.admedia-bg{
  background-color: white;
}
.admedia{
  margin-top: 138px;
}
.admedia .banner-container{
  margin-bottom: 0;
}
.admedia-sec-1 h1{
  color: #FFF;
font-family: Poppins;
font-size: 40px;
font-style: normal;
font-weight: 400;
line-height: 48px; 
letter-spacing: -0.8px;
text-transform: uppercase;
text-align: left !important;
margin-bottom: 5px;
}
.admedia-sec-1{
  min-height: 85vh;
}
.admedia-sec-1 h2{
  color: #FAEC24;
  font-family: Poppins;
  font-size: 70px;
  font-style: normal;
  font-weight: 500;
  line-height: 48px;
  text-align: left !important;
  letter-spacing: -1.6px;
  text-transform: uppercase;
}
.admedia-sec-1 p{
  color: #FFF;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: -0.36px;
  text-align: left;
  max-width: 80%;
}
.admedia-sec-2 h1{
  color: #000;
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 38px;
  letter-spacing: -1px;
  text-transform: uppercase;
  text-align: left;
  margin-bottom: 40px;
}
.admedia-sec-3 p{
  color: #000;
  font-family: Poppins;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: -0.36px;
  text-align: left;
}
.admedia-sec-3 .card{
  border: none;
  border-radius: 12px;
  position: relative;
}
.admedia-sec-3 .card .box{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: linear-gradient(182deg, rgba(0, 0, 0, 0.00) 20.68%, #000000e0 99%);
  align-items: flex-start;
  text-align: left;
  padding: 5px 20px;
  border-radius: 10px;
  transition: 0.2s;
}
.admedia-sec-3 .card{
  height: 340px;
  width:490px;
  margin-left:50px;
  transition:all ease 0.2s;
}
/* .admedia-sec-3 .card:hover{
  transform: scale(1.01);
  z-index: 2;
} */
.admedia-sec-3 h4{
  color: #FFF;
  text-align: left;
  font-family: Poppins;
  font-size: 25px;
  font-style: normal;
  font-weight: 700;
  line-height: 0px;
  letter-spacing: -0.5px;
  text-transform: uppercase;
}
.admedia-sec-3 .card p{
  font-family: Poppins;
  font-size: 18px;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: -0.02em;
  text-align: left;
  color:#fff;
}
.admedia-sec-4 .box{
  height:100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);
  align-items: flex-start;
  text-align: left;
  padding: 40px 28px;
  border: none;
  border-radius: 12px;
  transition:ease 0.4s;
}
.admedia-sec-4 h4, .admedia-sec-4 p{
  color: #fff;
  line-height: 0px;
  margin-top: -1.3rem;
  font-size: 20px;
  font-weight: 400;
}
.admedia-sec-4 .card{
  border: none;
  margin: auto;
  border-radius: 12px;
  height: fit-content;
  width: 88%;
  transition: ease 0.5s;
  height: 480px;
}
/* .admedia-sec-4 .slide:hover :not(:hover) .card{
  width: 80%;
} */

/* .admedia-sec-4 .slide-container:hover .card{
  width: 100%;
} */
.admedia-sec-4 .slide-container{
  position: relative;
  overflow: hidden;
}
.admedia-sec-4 .row{
  max-width: 89%;
  margin: auto;
}
.admedia-sec-4 .slick-next::before,.admedia-sec-4 .slick-prev::before{
  display: none;
}
.admedia-sec-4 .slick-arrow.slick-next,.admedia-sec-4 .slick-arrow.slick-prev{
  display: none;
}

/* Gallery */

.gallery{
  margin-top: 8rem;
}
.gallery-sec-1 h2{
  -webkit-text-decoration: 2.5px solid transparent underline;
          text-decoration: 2.5px solid transparent underline;
  color: #FFF;
  text-align: center;
  font-family: Montserrat;
  font-size: 11.375px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  text-underline-offset: 5px;
  transition:all ease 1s !important;
}
.gallery-sec-1 h2:hover{
  cursor: default;
  -webkit-text-decoration: 2.5px solid #FAEC24 underline;
          text-decoration: 2.5px solid #FAEC24 underline;
} 
hr.gallery-solid {
  border-top: 2px solid #bbb;
  width: 100%;
}
.gallery-sec-2{
  margin: auto;
}
 .gallery-sec-2 .row1 img{
  height: 320px;
  max-width: 100%;
}
.gallery-sec-2 .row2 img{
  height: 631px;
  max-width: 100%;
}
.gallery-sec-2 .row3 img{
  height: 302px;
  max-width: 100%;
}

/* dest-banner */
.dest-contact .contact-arrow{
  position: relative;
  bottom: 1px;
}

/* Contact */
.contact-sec .select-arrow{
  display: none;
}


.contact-sec-1 h1{
  color:#000;
  text-align: center;
  font-family: Poppins;
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 44px;
  letter-spacing: -1px;
  text-transform: uppercase;
  max-width: 60%;
  /* -webkit-animation: color-change 100s infinite alternate;
  animation: color-change 10s infinite; */
}
@keyframes color-change {
  0% { color: rgb(20, 11, 11); }
  50% { color: rgba(20, 11, 11, 0.603); }
  100% { color: rgba(20, 11, 11, 0.11); }
}
.contact-sec-1 .yellow-line:before{
  content: "";
  width:100%;
  max-width: 125px;
  height: 4px;
  background-color: #FAEC24;
  position: absolute;
  top: 106%;
  left:calc( 50% - 62px );
  margin-top: 10px;
}
.contact-sec-1 p{
  color:#000;
  text-align: center;
  font-family: Poppins;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  max-width: 80%;
  margin-bottom: 3.5rem !important;
  margin: auto;
}
.contact-sec-2 h1{
  color: #FFF;
  font-family: Poppins;
  font-size: 35px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  text-align: left !important;
}
.form-section h1{
  color: #FFF;
  font-family: Poppins;
  font-size: 1.9rem;
  font-style: normal;
  font-weight: 700;
  line-height: 10px;
  text-transform: capitalize;
  margin-right: 27%;
  margin-bottom: 3rem;
}
#enquiryForm{
  width: 60%;
  margin-top: 2%;
  color: #E5E5E5;
  font-family: Poppins;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: 175%; /* 2.1875rem */
}
.contact-form input::placeholder{
  color: #E5E5E5 !important;
}
.form-section label{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 175%;
}
.form-control:focus{
  background: rgb(255, 255, 255);
  outline: none;
  box-shadow: none !important;
  border: 1.2px solid  #E5E5E5 !important;
}
.form-select:focus{
  outline: none;
  box-shadow: none !important;
  border: 1.2px solid  #E5E5E5 !important;
}
.form-section input, .form-section textarea, .form-section select{
  display: flex;
  width: 100%;
  align-items: center;
  background-color: rgb(255, 255, 255);
  border-bottom: 1px solid #FFF;
  color: #070707 !important;
  font-family: Poppins;
  font-size: 1.1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; 
}
.form-section option,.form-section p {
  background: rgb(255, 255, 255);
  color: #000000;
  font-family: Poppins;
  font-size: 1.1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 200%; /* 2.1875rem */
  border-radius: 0px;
}
#exampleFormControlTextarea1{
  border-radius: 0.1rem !important;
}
.text-danger{
  display: none;
}
.form-section button{
  display: flex;
  width: 8.5rem;
  height: 2.6rem;
  padding: 0.5rem 0.5rem;
  justify-content: center;
  align-items: center;
  /* border-radius: 1.5625rem; */
  background: #FFF;
  /* box-shadow: 0px 0px 13px 4px rgba(126, 189, 190, 0.70); */
  color: #000;
  text-align: center;
  font-family: Poppins;
  font-size:17px;
  font-style: normal;
  font-weight: 500;
  line-height: 175%; 
}
.form-section button:hover{
  background: #FAEC24;
  /* box-shadow: 0px 0px 13px 4px rgba(126, 189, 190, 0.70); */
  color: #000;
}

/* About */

.about-sec-2 h1{
  color: #FFF;
  font-family: Poppins;
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 44px;
  letter-spacing: -1px;
  text-transform: uppercase;
}
.about-sec-2 .yellow-line:before{
  content: "";
  width:100%;
  max-width: 110px;
  height: 4px;
  background-color: #FAEC24;
  position: absolute;
  top: 108%;
  left: 1%;
}
.about-sec-2 p{
  color: #FFF;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  max-width: 106% !important;
  letter-spacing: -0.36px;
  text-align: left !important;
}
.about-sec-2 .col-lg-5{
  width: 44.8%;
}

.about-sec-2 .about-col-img{
  padding: 0;

}

.form-select{
  --bs-form-select-bg-img:url(${___CSS_LOADER_URL_REPLACEMENT_8___}) !important;
  
}
/* .form-select:focus{
  --bs-form-select-bg-img:url(../../public/images/Polygon.svg) !important;
} */

/* BlogRead */

.blogRead{
  background: white;
  /* margin-top: 130px; */
}
.blogRead-sec-1 .bRead{
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  flex-direction: column;

}

.blogRead-sec-1 h1{
  color:#000;
  text-align: left;
  font-family: Poppins;
  font-size: 52px;
  font-style: normal;
  font-weight: 700;
  line-height: 62px;
  letter-spacing: -1px;
  text-transform: uppercase;
  max-width: 95%;
}
.blogRead-sec-1 .yellow-line:before{
  content: "";
  width:100%;
  max-width: 125px;
  height: 4px;
  background-color: #FAEC24;
  position: absolute;
  top: 106%;
  left: 43.4%;
}
.blogRead-sec-1 h2{
  color: #9F9F9F;
  text-align: center;
  font-family: Poppins;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.blogRead-sec-1 h3{
  color: #000;
  font-family: Poppins;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 13px;
}
.blogRead-sec-1 span{
  text-decoration-line: underline;
  font-weight: 600 !important;
}
.blogRead-sec-1 p, .blogRead-sec-2 p{
  color:#000;
  text-align: left;
  font-family: Poppins;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  /* max-width: 80%; */
  margin: auto;
}
.blogRead-sec-2 h3{
  color:#000;
  text-align: left !important;
  font-family: Poppins;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 27px;
  letter-spacing: -1px;
  text-transform: uppercase;
}
.blogRead-sec-2 .yellow-line:before{
  content: "";
  width:100%;
  max-width: 105px;
  height: 4px;
  background-color: #FAEC24;
  position: absolute;
  top: 106%;
  left: calc( 50% - 55px);
}
  
@media (min-width:768px) and (max-width:992px) {
  .home-sec-2 .title1, .home-sec-3 h1,.home-sec-4 h2,
  .row.sec-title .yellow-line, .blog-sec-2 h2, .blog-sec-4 h2,
  .contact-section-2 h1{
    font-size: 40px !important;
    line-height: 46px !important;
  }
  .form-section .other01-btn ,.home-sec-6 .btn-primary,.home-sec-5 button {
    font-size: 15px !important;
  }
  .banner-content{
    /* margin-top: -40px; */
    width: 68%;
  }
  .banner-container {
    background-position: right center !important; /* Adjust as needed */
}
  .timeline{
    height: 210px;
      margin-top: -4rem;
  }
  /* .banner-container{
    margin-bottom: 100px;
  }  */
  /* .banner{
    min-height: 70vh;
  } */
  .blog-banner-container .banner{
    min-height: 100vh;
  }
  .banner-timeline .row h4 {
    margin-left:1.35rem
  }
    .banner h1{
        font-size: 52px !important; 
        line-height: 58px;
        width: 100%;
        margin-bottom: 10px;
    }
    .banner p{
        max-width: 100%;
    }

    .banner .first-slide svg{
      right: 5px;
      height: 70px;
      width: 100%;
      left: auto;
    }

    .home-sec-1 .logo-video{
      width: 112%;
    }
    .home-sec-1{
      height: fit-content;
      /* margin-bottom: 3rem; */
    }
    .home-sec-2 {
      padding-top: 3rem;
      /* padding-left: 2rem; */
      padding-bottom: 10rem;
    }
    .home-sec-2 h4{
      line-height: 30px;
  }
    .travel{
      display: none;
    }
    .page-down-btn img{
      max-width: 40px;
    }
    .home-sec-2 .card{
      height: 458px;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      
    }
    .home-sec-2 .card .card-body{
      opacity: 1;
    }
    .home-sec-2 .card:hover{
      top: none;
    }
    .home-sec-2 .card-title{
      font-size: 23px;
      line-height: 34px;
      margin-bottom: 0;
    }
    .home-sec-2 .box{
      padding: 8px 12px;
      max-width: 330px;
      max-height: 440px;
      border-radius: 10px;
      padding: 90px 28px 30px 28px;
    }
   .home-sec-2 p{
    font-size: 16px;
   }
   .home-sec-2 .slick-next::before,.home-sec-2 .slick-prev::before{
    display: block;
  }
  .home-sec-2 .slick-prev,.home-sec-2  .slick-next{
    top: calc(100% );
  }
  .home-sec-2 .slick-prev{
    left: 1rem;
  }
  .home-sec-2 .slick-next{
    left: 6rem;
  }



  .banner-timeline .row.active h4 {
   margin-left: 0rem;
}
  
  .home-sec-2 .col-4, .home-sec-2 .col-lg-4 {
    padding-left: 20px;
    padding-right: 20px;
  }
  .home-sec-2 .col-8, .home-sec-2 .col-lg-8 {
    padding-left: 0;
    padding-right: 0;
  }
  .home-sec-2 .col-8 div, .home-sec-2 .col-lg-8 div {
    height: unset
  }
  .home-sec-3{
    height: fit-content;
    margin-top: 6rem;
    padding: 1rem;
  }

.home-sec-3 h1{
  max-width: 100%;
  font-size: 32px;
  line-height: 34px;
  margin-bottom: 1rem;
    padding-top: 1rem;
}

.home-sec-3 .theme{
  margin-bottom: 2rem !important;
}
.home-sec-3 .thumb-img{
  margin-top: 3rem;
  justify-content: center !important;
}


.home-sec-3 span{
  text-transform: uppercase;
  margin: 1rem 0;
}
  .home-sec-3 .tabs-container .tab-btn {
    font-size: 20px;
    padding: 15px 10px;
    background-color: #fff;
    width: 100%;
    color: #1d1d1e;
    border: unset;
    border-bottom: 1px solid #000;
  }
  .br{
    white-space: pre;
  }
  .home-sec-5 h2{
    margin-top: 7rem !important;
  }
  /* .home-sec-4 h2{ */
    /* text-align:left; */
    /* padding-left:12.5rem; */
    /* margin-top: 5rem; */
  /* } */
  .home-sec-4 .yellow-line::before{
    /* left: calc( 68% - 57px ); */
    top: -1.2rem;

  }
  .home-sec-4 {
    padding-bottom: 10rem;
    padding-top: 6rem;
  }
  .home-sec-4 .card{
    width: 97%;
    height: 250px;
  }
  /* .home-sec-4 .slick-next::before,.home-sec-4 .slick-prev::before{
    margin: 0 -10px;
  } */
  .home-sec-4 .slick-next, .home-sec-4 .slick-prev{
    top: 115%;
  }
  .home-sec-4 .slick-next{
      position: absolute;
      left: 53%;
      transform: translateX(-50%); 
      font-size: 0;
      right: 14rem;
  }
  .home-sec-4 .slick-prev{
    position: absolute;
    left:42%;
    transform: translateX(-50%); 
    font-size: 0;
  }
  
  .home-sec-4 .slick-prev::before{
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  .home-sec-4 .slick-next::before{
    content: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  }
  .home-sec-5 span{
      font-size: 20px;
  }
  /* .home-sec-5 button{
    font-size: 20px !important;
  } */
  .home-sec-5 .seg1{
    width: 20%;
    margin-top: 1.4rem;
  }
  .home-sec-5 .seg1 span{
    font-size: 15px;
    line-height: 20px;
  }
  .home-sec-5 .seg2{
    text-align: left;
    width: 80%;
    line-height: 24px;
    font-size: 18px;
    margin-top: 1rem;
  }
  .home-sec-5 .seg2 span{
    line-height: 24px;
    font-size: 18px;
  }

  
  .home-sec-5 .scroller{
    padding-right: 3px;
    /* height: 350px; */
  }
  .home-sec-5 .seg3{
    text-align: left;
    width: 100%;
    margin-top: 0.5rem;

  }
  .home-sec-5 .seg3 .btn{
    padding: 0;
  }
  .home-sec-6 .plan-txt{
    margin-bottom: 2rem;
  }
  .home-sec-6 .footer-title{
    font-size: 40px;
  }


  .gallery-sec-1{
    margin-top: 2rem !important;
  }

  .simple-slider {
    height: 450px;
  }
  .home-sec-6 p{
    max-width: 75%;
    padding-bottom: 1rem;
    font-size: 14px !important;
  }
  .home-sec-6 .btn-primary{
    padding: 10px 55px;
    font-size: 17px;
  }
  .tail .media button img {
    height: 36px;
  }
  .button{
    background-color: white;
  }
  .hidden-lg{
    display: block !important;
  }
  .video, .video-2{
    margin-top: 0rem;
  }

  .home-sec-4>div{
    width: auto;
  }
  .home-sec-4>div .yellow-line{
    width: auto;
  }

  /* Destination tab */

    
  .destination-banner{
    min-height: 75vh;
  }
  .destination-banner h1{
    font-size: 38px;
    line-height: 3.2rem;
    margin-top: 10rem;
  }
  .destination-banner h1 span{
    font-size: 66px;
  }
  .destination-banner .col-lg-5 {
    width: 30%;
}
  .destination-banner p{
    font-size: 17px;
    max-width:100%
  }
  .dest-contact{
    /* padding: 6px 40px; */
    padding:9px 15px!important;
    margin-left: -1.5rem;

  }
  .destination-banner .btn-2{
    margin-left: -4rem;
  }
  .destination-sec-2{
    height: 75vh;
  }
  .destination-sec-2 h1{
    margin-bottom: 7%;
    max-width: 100%;
    font-size: 30px;
    /* line-height: 5rem; */
  }
  .destination-sec-2 .yellow-line:before{
    top: -10px;
    /* left: 280px; */
  }
  .dest-rw{
    margin-top: 6rem !important;
  }
  .destination-sec-2 .pt-4{
    padding-top: 0 !important;
  }
  .destination-sec-2 p{
    /* margin-top: 1rem; */
    text-align: center;

  }
  .destination-sec-3.discover{
    margin-bottom: 0 !important;
  }
  .destination-sec-5 .title-1 {
    margin-bottom: 1rem !important;
    margin-top: 1rem !important;
  }
  .destination-sec-2 .content-img-text{
    padding: 0;
  }
  .destination-sec-5-content{
    padding-top: 2rem;
  }
  .destination-sec-5 .sec-title{
    margin-top: 1rem;
    margin-bottom: 3rem;
  }
  .amer.destination-sec-4 p{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    margin-bottom: 2rem;
  }
  .destination-sec-2 .le {
    margin-top: 0 !important;
  }
  .home-sec-1 h1{
    font-size: 40px;
  }

  .asia-img {
    height: 246px;
    width: 120vw; 
    max-width: none;
  }
  .dest-sec-5-p{
    width: 91%;
    padding-left: 4rem;
  }
  .eu-dest-sec-5-p{
    width: 92%;
    padding-left: 4rem;
  }
  .me-dest-sec-5-p{
    width: 95%;
    padding-left: 2rem;
  }
  .middleEast{
    height: 83vh;
  }
  .destination-sec-5 .me-title{
    margin-top: 0;
  }
  .destination-sec-5 .sec5-title{
    max-width: 63% !important;
    margin-top: 4rem;
  }
  .destination-sec-3 .sec-3-title{
    font-size: 25px;
  }
  .destination-sec-3 .content-sec{ 
    margin-left: 1rem;
  }
  .middleEast .sec-title{
    margin-bottom: 0;
  }
  .destination-sec-3 .col-md-5{
    width: 38%;
  }
  .destination-banner-container{
    height: 83vh;
  }
  .destination-sec-3 p{
    font-size: 18px;
    line-height: 22px;
  }
  .destination-sec-3 h1{
    line-height: 2.3rem;
    font-size: 27px;
    margin-top: 26%;
  }
  .destination-sec-3 .yellow-line:before{
    top: -15px;
    left: 2px;
    }
  .destination-sec-3 .card{
    top: -33%;
  }
  .destination-sec-3 .card{
    top: -46px;
    height: 290px;
    width:210px;
    margin-left:0px;
  }
  .destination-sec-3 .card-1{
    height: 290px;
    margin-top: 5.3rem;
    width:190px;
    margin-left:0px;
  }
  .destination-sec-5 h4, .destination-sec-5 p{
    line-height: 14px;
  }
  .destination-sec-5 .card {
    width: 325px;
    margin: 5px;
}
  .destination-sec-3 .col-md-3 {
    padding: 0;
}
  .destination-sec-4 p{
    text-align: center;
  }
  .destination-sec-3 h4{
    font-size: 19px;
    line-height: 24px;
  }
  .destination-sec-3 .card .box{
    padding: 10px 9px;
  }
.destination-sec-5 h1{
  max-width: 60%;
  font-size: 30px;
  line-height: 36px;
}
/* .blogRead{
  margin-top: 100px;
} */
.content-america{
  margin-top: -0.5rem !important;
}
.destination-sec-5 .yellow-line:before{
  max-width: 140px;
  text-align: center;
  /* left:26%; */
} 
.destination-sec-5 .yellow-line:before{
  text-align: center;
  max-width: 140px;
  /* left:26%; */
}
.expl .yellow-line:before {
  max-width: 140px;
  left: 25.5%;
}
.home-sec-3 .box{
  width: 100%;
  height: 96%;
}
.padding-1{
  padding: 0;
}

p{
  font-size: 17px !important;
  line-height: 26px !important;
}
button{
  font-size: 15px;
}

.blogRead-sec-1 .cred{
  margin-top: 3rem !important;
}


/* add media */
.admedia-sec-3 p{
  text-align: justify;
}
.admedia-sec-3 .card{
  border-radius: 10px;
}  
/* Blog */
.destination-banner .w-50{
  width: 100% !important;
}

  .blog-banner{
    min-height: 70vh;
  }
  .none{
    display: none;
  }
  .blog-banner h1{
    font-size: 35px;
    line-height: 2.6rem;
    padding-top: 8rem;
  }
  .blog-banner h1 span{
    font-size: 35px;
  }
  .blog-banner p{
    font-size: 17px;
    max-width: 92%;
  }
  .blog-banner .btn-primary{
    padding: 6px 30px;
    font-size: 17px;
    }
    .blog-sec-2{
      padding-top: 3rem;
    }
  .blog-sec-2 h5{
    font-size: 16px;
    font-style: normal;
    line-height: 25px;  
  }
  .blog-sec-2 .tag {
    top: 6%;
    left: 82%;
}
  .blog-sec-2 span{
    font-size: 16px;
    line-height: 25px; 
    margin: 14px;
    margin-left: 2rem;
    }
  .blog-sec-2 .card{
    height: 500px;
    margin-right:0px;
    margin-bottom: 5rem;
    width: 50%;
  }
  .blog-sec-2 img{
    width: 700px;
    height: 320px;
    transform: scale(1.1);
  }
  .blog-sec-2 h4{
    font-size: 18px;
    line-height: 25px; 
    max-width: 90%;
    height: 50px;
  }
  .blog-content{
    padding-bottom: 30px;
  }
  .blog-sec-2 p{
    font-size: 14px;
    line-height: 20px; 
    margin-top: 0.4rem;
  }
  .blog-sec-3-banner{
    min-height: 58vh;
  }
  .blog-sec-3-banner h1{
    max-width: 100%;
    margin: auto;
    font-size: 36px;
  }
  
  .blog-sec-3-banner p{
    font-size: 14.7px;
    line-height: 20px;
  }
  .blog-sec-4 h6{
    font-size: 13px;
    line-height: normal;
    }
  .blog-sec-4 h4{
    max-width: 100%;
    margin-bottom: 5px;
  }
  .blog-sec-4 p{
    font-size: 13px;
    max-width: 100%;
  }
  .blog-sec-4 .card{
    margin-right: 10px;
    margin-bottom: 20px;
    width: 100%;
    }
  .blog-sec-4 .box{
    padding: 0px 0px 50px 50px ;
    width: 60%;
  }
  .blog-sec-4 .box h1{
    font-size: 18px;
  }
  .blog-sec-4 .box p{
    font-size: 12px !important;
    line-height: 20px !important;
  }

  .blogRead-sec-1 .yellow-line:before{
    left: 38%;
  }
  hr.solid-small {
    width: 10%;
    margin-left: 45%;
}
.shop-sec-4 .slick-dots li button::before {
  margin-top: 0.3rem;
  margin-left: 0.7rem;
}

.about-banner-container .text-overlay {
  width: 100%;
}
.about-banner-container .parallax-img{
  height: 80%;
  left: 6rem;
}
.about-section-2 {
  border-bottom: 1px #fff solid;
}
  /* .home-sec-2 .slick-list{
  height: 450px;
} */
.number img{
  max-width: 131% !important;
  position: relative;
  left: 4rem;
}
/* Shop */

  .shop-sec-2 h4{
    font-size: 20px;
  }
  .shop-sec-2 p{
    line-height: 23px;
    max-width: 75%;
    margin: auto;
  }
  .shop-sec-2 img{
    height: 460px;
    border-radius: 10px;
    max-width: 100%;
  }
  .shop-sec-3 h2{
    font-size: 32px;
  }
  .shop-sec-3 .card{
    height: 500px;
    width: 400px;
    margin-right:9px;
    margin-left: 10px;
  }
  .shop-sec-3 p{
    font-size: 20px;
    line-height: 40px;
  }
  .shop-sec-3 img{
    width: 345px;
  }
  .shop-sec-4 p{
    margin-bottom: 1.2rem;
    max-width: 100%;
  }
  .shop-sec-4 .card{
    margin: 20px 30px;
    margin-right:30px;
    height: 350px;
  }
  .overlay img {
    width: 22px;
}
  .shop-sec-4 h4{
    font-size: 24px;
    max-width: 77%;
    line-height: 116%;
  }
  .shop-sec-3 .overlay {
    width: 95%;
    height: 106%;
}
  .shop-sec-4 .content-box{
    padding: 10px 0px 0px 10px;
  }
   .shop-sec-3 .title-box{
    padding-left: 15px;
    padding-bottom: 25px;
    }
  .hidden-md{
    display: none !important;
  }
  .shop-sec-2 .box{
    width: 96%;
    margin: auto;
    margin-right: 7px;
  }
  .blogRead-sec-1 h1{
    font-size: 36px;
  }
  /* ShopSub */

  .shopSub-banner-container{
    padding-top: 10rem;
  }
  .shopSub-banner-container{
    height: 55vh;
  }
  .shopSub-banner h1{
    font-size: 35px;
    line-height: 2rem;
    text-align: left;
  }
  #dropdown-toggle1 {
  margin-bottom: 15px;
  }
  .para{
    max-width: 98% !important;
    margin-left: 0.8rem !important;
  }
  .sort{
    margin-top: 6px;
  }
  .shopSub-banner h1 span{
    font-size: 36px;
  }
  .shopSub-banner p{
    font-size: 17px;
  }
  .shopSub-sec-2 .col-1{
    width: 3rem;
  }
  .shopSub-sec-2 .col-2{
    width: 5.5rem;
  }
  .shopSub-sec-2 .col-5{
    width: 18rem;
  }
  .shopSub-sec-4 h6{
    font-size: 21px;
    line-height: 10px;
  }
  .shopSub-sec-4 p{
    font-size: 17px;
    line-height: 22px; 
  }
  .shopSub-sec-4 .col-1{
    width: 3.6rem;
    padding: 0;
  }
  .shopSub-sec-4 .col-2{
    width: 38rem;
    margin-bottom: 3rem;
  }
  .title-box img{
    max-width: 100px;
  }
/* ShopSub2 */

.shopSub2-sec-2{
  margin-top:9rem ;
}
.shopSub2-sec-2 p{
  font-size: 16px;
  margin-top: 3px;
}
.shopSub2-sec-4 .col-md-12{
  background-color: #E5E5E5;
  width: 60rem;
  margin: 0;
  padding-left: 3.5rem;
  border-radius: 0;
  height: 28rem;
}
.shopSub2-sec-2 h5{
  font-size: 15px;
  text-align: left;
  margin-top: 5px;
}
.shopSub2-sec-2 .col-2{
  width: 8rem;
}
.shopSub2-sec-4{
  background-color: white;
}
.sofa{
  margin-right: 0rem;
}
.shopSub2-sec-4 h6{
  color: #9F9F9F;
  text-align: right;
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height:30px;
  text-align: right;
}
.shopSub2-sec-4 .col-5{
  border-radius: 10px;
  background: #E5E5E5;
  width: 23rem;
  height: 25rem;
  margin-left: 2rem;
}
.shopSub2-sec-4 h2{
  font-size: 38px;
  text-align: left;
}
.shopSub2-sec-4 .col-6{
  margin-left: 3.5rem;
}
.shopSub2-sec-4 h4{
  font-size: 24px;
  text-align: right;
}
  .shopSub2-sec-4 .col-2{
    width: 7rem;
  }
  .shopSub2-sec-4 p{
    font-size: 14px;
    text-align: left;
  }
  .shopSub2-sec-4 .btn-primary{
    font-size: 18px;
    padding: 10px 70px;
  }
  .shopSub2-sec-4.box {
    border: 1px solid black;
    padding: 20px; 
    margin: 20px; 
  }

  .home-sec-4 .product-card-slider .slide:nth-child(8) > .box{
    opacity: 0.83;
    background: linear-gradient(180deg, #FAEC24 0%, #000 100%);
}
.popular-milestone h4{
  font-size: 18px;
  line-height: 30px;
}
.popular-milestone p{
  font-size: 16px !important;
  line-height: 27px !important;
}
.popular-milestone .box{
  padding-left: 14px !important; 
  padding-right: 14px !important;
}
.blog-sec-2 h4{
  max-width: 75%;
}

  /* Cart */

  .cart-sec-2-row, .cart-sec-2 .col-lg-4{
    background-color: #E5E5E5;
  }
  .cart-sec-2 .col-md-12{
    margin-left: 0rem;
    margin-top: 5rem;
    width: 50rem;
  }
  .cart-sec-2 h3{
    font-size: 15px;
  }
  .cart-sec-2 h2{
    font-size: 28px;
    text-align: center;
  }
  .cart-sec-2 h5{
    text-align: left;
  }
  .cart-sec-3 h4{
    margin-bottom: 2rem;
    text-align: center;
    margin-left: 2rem;
  }
  .cart-sec-3 h6{
    margin-bottom: 1.9rem;
    text-align: left;
    font-size: 18px;
    margin-left: 6rem;
  }
  .cart-sec-3 h5{
    margin-left: 6rem;
    margin-bottom: 3rem;
  }
  .cart-sec-2 .btn-primary{
    padding: 10px 75px;
  }
  .cart-sec-4 h4{
    font-size: 22px;
    line-height: 22px;
    margin-left: 45px;
  }
  .cart-sec-4 .row{
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    padding: 20px 8px;
    border-radius: 10px;
  }
  .cart-sec-4 h5{
    font-size: 19px;
    text-align: left;
    margin-left: 44px;
  }
  .cart .count {
    width: 120px;
    padding: 0;
    border: 1.5px solid black;
    margin-left: 40px;
    padding-top: 2px;
    margin-top: 20px;
    height: 53px;
  }
  .count input{
    width: 40px;
    border-radius: 0;
    text-align: center;
    font-size: 18px;
    border: none !important;
  }
  
  .count button{
    background: white;
    border: none !important;
    font-size: 20px;
  }
  .cart-sec-4-img img{
    height: 25px;
    margin-left: 20px;
  }
  .cart-sec-2-img img{
    height: 85px;
  }
  .cart-sec-4 .col-1 {
    height: 81px;
    width: 81px;
}
.shop-sec-4 .slick-arrow.slick-next::before{
 display: none;
}
.asia .col-lg-7{
  width: 42%;
}
.africa .col-lg-7{
  width: 43%;
}
.europe .col-lg-7{
  width: 46%;
}
  /* Checkout */

  .checkout-sec-2 h1{
    font-size: 36px;
  }
  .checkout-sec-3 .form {
    padding: 20px;
    width: 700px;
    border-radius: 5px;
    text-align: left;
    border: none;
  }
  .checkout-sec-3 label {
    display: block;
    margin-bottom: 5px;
    font-size: 18px;
    text-align: left;
  }
  .checkout-sec-3 .input-box {
    padding: 10px;
    width: 100%;
    height: 3.3rem;
    margin-bottom: 25px;
    margin-top: 5px;
  }
  .checkout-sec-3 h3{
    font-size: 24px;
    margin-left: 0rem;
    text-align:right;
    margin-right: 15px;
  }
  .checkout-sec-3 h2{
    font-size: 24px;
  }
  .checkout-sec-3 h5{
    font-size: 24px;
    line-height: 3rem;
    text-align: right;
    margin-right: 15px;
  }
  .checkout-sec-3 h4{
    font-size: 16px;
    text-align: left;
    line-height: 30px;
  } 
  .checkout-sec-3 h6{
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height:9px;
    text-align: right;
    margin-top: 2rem;
    margin-right: 17px;
  } 
  .checkout-sec-3 p{
    font-size: 17px;
    line-height: 25px;
    text-align: left;
    margin-bottom: 10px;
    margin-top: 1.5rem;
  }
  .checkout-sec-3 .btn-primary{
    font-size: 16px;
    padding: 10px 75px;
    margin-bottom: 3rem;
  }
  .checkout-sec-3 span{
    color: #000;
    font-family: Poppins;
    font-size: 13.6px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  hr.solid {
    border-top: 2px solid #bbb;
    width: 100% !important;
    margin-left: 0rem !important;
  }
  .checkout-sec-3 h1{
    color: #6C757D;
    text-align: justify;
    font-family: Poppins;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .checkout-col-1 {
    margin-left: 0rem;
}
.checkout-col {
  margin-left: 0rem;
}
.blog-sec-4{
  padding-top: 3rem;
  
}

.blog-sec-4-cards{
  flex-direction: column;
}

  /* Ad&media */
 
  .admedia{
    margin-top: 120px;
  }
  .admedia-sec-1 h1{
    font-size: 36px;
    line-height: 40px;
    margin-top: 9rem;
  }
  .admedia-sec-1 span{
    font-size: 80px;
  }
  .admedia-sec-1 p{
    font-size: 17px;
    line-height: 23px;
    /* max-width: 100%; */
  }
  .admedia-sec-2 h1{
    font-size: 40px;
    max-width: 100%;
  }
  .admedia-sec-3 p{
    font-size: 19px;
    max-width: 100%;
    line-height: 25px;
    margin-bottom: 25px;
  }
  .admedia-sec-3 .card{
    height: 400px;
    width:100%;
    margin-left:0px;
    margin-top: 30px;
  }
  .admedia-sec-3 h4{
    font-size: 25px;
  }
  .admedia-sec-3 .card p{
    font-family: Poppins;
    font-size: 18px;
    font-weight: 400;
    line-height: 33px;
  }
  .admedia-sec-4 .box{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);
    align-items: flex-start;
    text-align: left;
    padding: 40px 28px;
    border: none;
    border-radius: 12px;
  }
  .admedia-sec-4 h4, .admedia-sec-4 p{
    color: #fff;
    line-height: 14px;
  }
  .admedia-sec-4 .row{
    max-width: 100%;
    margin: 0;
  }
  .admedia-sec-4 .card{
    margin: 10px;
    height: 480px;
  }
  /* .enlarged .card {
    transform: scale(1);
} */
.shop-sec-4 .slick-current .card{
  height: 450px;
  width: 420px;
}
.about-sec-2 .col-lg-5{
  width: 100%;
}
/* .about-sec-2 .content-title{
  margin-left: -2rem;
} */

 
 .scroll-top span{
  color: #fff;
  font-size: 11px;
  font-weight: 300;
  font-family: Montserrat;
 }
 .scroll-top .scroll-top-btn{
  margin-bottom: -2.5rem ;
 }

 .about-banner-container{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
 }

  /* Gallery */

  .gallery{
    margin-top:120px;
  }
  .gallery-sec-1 h2{
    font-size: 13px;
  }
  .gallery-sec-2{
    margin: auto;
    /* margin-right: 0px;
    margin-left: 24px; */
  }
  .gallery-sec-2 img{
    margin-bottom: 30px;
  }
  .gallery-sec-1 .col-2 {
    width: 9.2rem;
}
  .equator{
    width: 720px;
  }
  .gallery-sec-2 .row1 img{
    height: unset;
    max-width: 100%;
  }
  .gallery-sec-2 .row2 img{
    height: unset;
    max-width: 100%;
  }
  .gallery-sec-2 .row3 img{
    height: unset;
    max-width: 100%;
  }
  .admedia-sec-1{
    min-height: 60vh;
  }

  .blogRead-banner-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    height: 570px;
  }


  #blog-scroller{
    height: 520px ;
  }
  #blog-scroller .product-card-slider .slick-slide{
    opacity: 30%;
    transition: all ease 1s;
  }
  #blog-scroller .product-card-slider .slick-active{
    opacity: 100%;
  }
  
  /* Contact */


  .contact-sec-1{
    padding-top: 2.5rem;
  }
  .contact-sec-1 p{
    max-width: 85%;
    margin: auto;
  }
  .contact-sec-2 h1{
    font-size: 35px;
    text-align: left !important;
  }
  .banner-timeline{
    margin-left: 0.4rem;
  }

  /* about */

  .about-sec-2 h1{
    font-size: 34px;
    line-height: 46px;
    margin-bottom: 2rem;
  }
  .about-sec-2 .yellow-line:before{
    top: 108%;
    left: 1%;
  }
  .about-sec-2 p{
    font-size: 17px;
    margin-left: 10px;
    max-width: 106% !important;
  }
  /* .about-img{
    margin-left: -30px;
    min-width: 730px;
  } */
  .contact-sec-1{
    padding-top: 1.5rem;
  }
.contact-sec-1 h1{
  font-size: 38px;
  line-height: 43px;
  margin-top: 0rem !important;
}
.contact-sec-1 .yellow-line:before{
  margin-top: 20px;
  left: 35%;
}
.contact-txt{
  margin-top: 5rem !important;
}
.contact-txt p{
  text-align: left;
}
.contact-sec-1 p{
  font-size: 16.5px;
  max-width: 75%;
  margin-bottom: 0rem !important;
  margin-top: -1.4rem !important;
}
.contact-sec-2 h1{
  font-size: 35px;
}
.form-section h1{
  line-height: 40px;
  max-width: 90%;
  margin-right: 23%;
  /* margin-top: -30 !important; */
  margin-top: 30px;
}
#enquiryForm{
  width: 80%;
  margin-top: 0%;
}
.form-section input, .form-section textarea, .form-section select{
margin-bottom: 0.6rem;
}
.section{
  margin-top: 10rem !important;
  border-bottom-left-radius: 70px;
  border-bottom-right-radius: 70px;
  padding: 45px 20px;
  width: 100%;
}

/* ad media */
.admedia-title{
  margin-bottom: 30%;
}
.contact-sec-1{
  background-color: black;
}
.home-sec-6 .contact-btn{
  padding: 10px 32px;
}
    
}







/* 
@media (max-width:768px) {
  section .row>*  {
    padding-left: 24px;
    padding-right: 24px;
  }
  h1,
  h2,h3 {
    
      font-size: 38px !important;
      line-height: 40px !important;
  }
  h3{
    text-align: left;
  }
  h4{
    font-size: 20px;
    margin-bottom: 5px;
  }

  h1 {
    width: 100% !important;
  }
  p{
    font-size: 16px !important;
    line-height: 28px !important;
  }

.banner-container{
  min-height: 100vh;
  margin-bottom: 90px;
}
 .banner{
  min-height: 100vh;
  
}
.banner{
padding: 30px 24px;
} 
.banner h1{
  font-size: 38px;
  line-height: 40px;
}
  .home-sec-1 {
    min-height: 750px;
  }
  .home-book-button {
    background: #26B2E3;
    font-size: 15px;
  }

  .home-book-button:hover{
    background: linear-gradient(180deg, #198bca 0%, #0f5789 100%);
  }
  .home-sec-2 .slick-list{
    height: 460px;
  }
  .home-sec-2 .slick-next, .home-sec-2 .slick-prev{
    top: 95%;
  }
  .home-sec-2 .slick-next{
    right: 30px;
    height: 10px;
  }
  .home-sec-2 .slick-prev{
    left: calc( 100vw - 300px);
  }
  p {
    width: 100% !important
  }
  .accordion-item{
    border: unset !important;
  }
  .accordion  .active{
    border-left: unset;
    border-bottom: 3px solid #F28B20 !important;
  }
  .tab-btn{
    font-size: 20px !important;
    font-weight: 700 !important;
    border: unset !important;
    width: fit-content !important;
    margin-bottom: 20px !important;
    padding: 1px 10px 1px 0 !important;
  }
  .home-sec-3 .tab-btn {
    width: 100% !important;
    padding: 10px 10px !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom: unset;
  }
  .home-sec-3 .active{
    border-left: unset;
    border-bottom: unset !important;
  }
  .tab-btn:after{
    display: none;
  }
  .home-sec-3 .tab-contents-container ul {
    column-count: 1;
  }
  .home-sec-3 .tab-contents-container ul li {
    font-size: 14px;
  }
  .home-sec-3 .tab-contents-container .tab-content{
    padding: 20px 10px;
  }
  .home-sec-3 .tab-contents-container .tab-content p {
    margin-bottom: 30px;
  }
  .home-sec-4 .card{
    width: 100%
  };

  .home-sec-5 span{
    font-size: 10px !important;
  }
  .home-sec-5 button{
    font-size: 10px !important;
  }
 .non-breaking-mob-container{
  width:100%;
  overflow-x: scroll;
}
.non-breaking-mob-container .row{
  width:1000px;
  flex-wrap: nowrap;
}
.grey-bg{
  width: 100%;
 height: calc(inherit + 50px);
 background: linear-gradient(174.7deg, #F4F4F2 88.97%, rgba(244, 244, 242, 0) 100%);
}
.de-banner .row {
  position: relative;
}
.de-banner .row .col-lg-6{
  position: absolute;
  top: 200px;
  z-index: 1;
  color: #f6f6f6;
  }
  .de-banner .row .col-lg-6:last-child{
    padding: 0;
    z-index: 0;
    top: 0;
  }

  .de-banner .row .col-lg-6 h3{
  
    color: #f6f6f6;
  }
      .de-banner .row .col-lg-6 .responsive-col-gap{
        width: 100%;
        overflow-x: hidden;
      }
.de-banner img{

 height: 569px;
 width: 100%;
}
}
@media (min-width:992px) {

  .home-sec-1, .home-sec-3{
    padding-left: 23px;
    padding-right: 100px;
  }
  .home-sec-5 .col-lg-4 .box {
    height: 560px;
  }
  .home-sec-5 .col-lg-4:first-child .box {
    height:1120px;
  }

} */
@media (max-width:576px){
  .banner-container {
    background-position: center !important; /* Adjust as needed */
}
.banner .first-slide{
  font-size: 38px !important;
  line-height: 24px;
}
.home.banner h1{
  font-size: 32px !important;
  line-height: 38px;
}

.home-sec-2 .title1, .home-sec-3 h1,.home-sec-4 h2,
  .row.sec-title .yellow-line, .blog-sec-2 h2, .blog-sec-4 h2,
  .contact-section-2 h1{
    font-size: 32px !important;
    line-height: 38px !important;
  }

  .home-sec-2 .card{
    height: 458px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    
  }
  .home-sec-2 .card .card-body{
    opacity: 1;
  }
.home-sec-1{
  height: fit-content;
  /* margin-bottom: 2rem; */
}
.home-sec-1 .logo-video{
  padding-left: 0;
  width: 100%;
}
  .timeline{
    /* margin-top: 8rem; */
    height: 320px;
    top: -1rem;
  }
  h1,h3 {
    font-size: 35px ;
    line-height: 40px;
  }
  .banner h1{
    font-size: 38px !important;
    line-height: 44px;
    margin-top: 2rem;
    margin-bottom: 20px;
  }
  h1 {
    width: 100% ;
  }

  p{
    font-size: 16px ;
    line-height: 24px ;
  }
  .banner p {
    max-width: 97%;
    font-size: 16px ;
    line-height: 24px ;
}
  .home-sec-2 {
    padding-top: 1rem;
    padding-bottom: 8rem;
    /* padding-left: 1rem; */
  }
  .home-sec-2 .card{
    height: 360px;
    width: 230px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    
  }
  .home-sec-2 .card-img-top {
    height: 79%;
  }
  /* .home-sec-2 .card-body{
    padding: 10px;
    height: 20%;
  } */
  .home-sec-2 .card:hover{
    height: 360px;
    top: -0;
  }
  
.home-voyage{
  margin-top: 4rem;
}
.home-sec-4 .card{
  width: 100%;
  margin: 0;
}
.home-sec-4 .slick-next::before,.home-sec-4 .slick-prev::before{
  margin: 0 -10px;
}
.home-sec-4 .slick-next, .home-sec-4 .slick-prev{
  top: 120%;
  position:absolute;
}
.home-sec-4 .slick-next{
  /* right: 16rem; */
  left: 25%;
}
.home-sec-4 .slick-prev{
  left: 2rem;
}
.home-sec-4 .slick-prev::before{
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.home-sec-4 .slick-next::before{
  content: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
  
  .banner-timeline .row h4{
    line-height: 17px;
    font-size: 25px;
    margin-left: 17.8rem;
  }
  .banner-timeline .row.active h4{
    color:#fff;
    font-size: 30px;
    margin-left: 16rem;
  }
  .banner h1 span{
    font-weight: 700;
  }
  .banner-timeline .row.active p{
    margin-left: 16.8rem;
  }
  .banner-timeline span{
    display: none;
  }
  .banner .first-slide svg{
    /* right: 35px; */
    height: 52px;
    left: auto;
  }
  .banner .first-slide{
    color: #ffffff;
    font-weight: 700;
  }

  .travel{
    display: none;
  }
  .line{
    width: 1.9rem;
    margin-left: 16.56rem;
  }
  .btn-borderless{
    width: 50px;
    padding: 0;
    margin-right: 0px !important;
    margin-top: 5px !important;
  }
  .home-sec-1 h1{
    font-size: 35px;
    line-height: 30px;
    text-align: center;
  }

  .dest-contact{
    padding-right: 12px;
  }
  .home-sec-2 .title1{
    font-size: 32px;
    line-height: 38px;
  }
  .home-sec-2 h4 {
    line-height: 39px;
    font-size: 23px;
}
  .home-sec-2 p{
    font-size: 17px;
  }
  .home-sec-2 .yellow-line{
    margin-left: 0.5rem;
    max-width: 100%;
    line-height: 36px;
    margin-bottom: 0rem;
  }
  .home-sec-2 .slick-list {
    height: 520px;
  }
  .home-sec-2 .slick-prev::before{
    display: block;
    /* content: url(../../public/images/app-home/sec2/slick-next-3.svg); */
  }  
  .home-sec-2 .slick-next::before{
    display: block;
    /* position: relative; */
    /* right: -7rem; */
    /* content: url(../../public/images/app-home/sec2/slick-next-3.svg); */

  }
  .home-sec-2 .product-card-slider{
    padding-top: 0;
  }
  .home-sec-2 .product-card-slider .slick-slide .slide{
    margin-left: -7px;
  }
  .home-sec-2 .slick-next, .home-sec-2 .slick-prev{
    top: 85%;
    position:absolute;
  }
  .home-sec-2 .slick-next{
    /* right: 14rem; */
    left: 25%;
  }
  .home-sec-2 .slick-prev{
    left: 1rem;
    z-index: 1;
  }
  
  /* .home-sec-5 .slick-arrow.slick-next,.home-sec-5 .slick-arrow.slick-prev{
    display: none !important;
  }  
  .home-sec-5 .slick-next::before,.home-sec-5 .slick-prev::before{
    display: none !important;
  }   */

  .home-sec-5 .slick-prev{
    left: 2rem !important;
  }
  .home-sec-5 .slick-next{
    left: 25% !important;
  }
  .home-sec-3 .thumb-img{
    margin-top: 3rem;
    justify-content: center;
  }

  .home-sec-3 h1{
    max-width: 100%;
    line-height: 38px;
    font-size: 32px;
  }
  .home-sec-3{
    margin-top: 3rem;
  }
  .home-sec-3 p{
    font-size: 19px;
    line-height: 25px;
  }
  .home-sec-4 h2{
    text-align: left;
    width: 93%;
    /* margin-left: 0.3rem; */
    font-size: 32px;
    line-height: 36px;
  }
  .home-sec-4 h4{
    font-size: 20px;
  }
  .home-sec-4 .yellow-line:before{
    left: 0;
  }
  .home-sec-4 .yellow-line{
    margin-top: 3rem;
    left: 1rem;
  }
  .video{
    justify-content: center !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .frame-icon{
    top:50%;
  }
  .home-sec-5 .yellow-line{
    margin-left: 1rem;
    margin-top: 3.5rem !important;
    font-size: 32px;
    line-height: 36px;
  }
  .home-sec-5 .strip{
    width: 100%;
    display:block;
    justify-content: center;
    height: unset;
  }
  .home-sec-5 .scroller{
    height: 620px;
    width: 100%;
    overflow-y: unset;
    margin-left: 0.7rem;
  }
  .home-sec-5 .slider{
    opacity: 100%;
  }
  .home-sec-5 .slick-active {
    display: block;
    opacity: 100%;
}
  .home-sec-5 .row{
    width: 100%;
    margin-bottom: 0 !important;
  }
  .button-travel{
    margin-left: 0.45rem;
  }
  .le {
    margin-top: 5rem !important;
    margin-bottom: -7rem !important;
   }
   .le .sm-yellow{
    margin-left: 0;
    margin-bottom: 0;
   }
   .destination-sec-2 .content{
    padding: none !important;
   }
  ::-webkit-scrollbar {
    width: 3px;
    height: 5px;
    display: none;
  }
  ::-webkit-scrollbar-track {
    background: black
  }
  ::-webkit-scrollbar-thumb {
    background: #888888cb;
  }
  ::-webkit-scrollbar-thumb:hover {
    display: none;
  }

  .home-sec-5{
    padding-top: 2rem !important;
    padding-bottom: 1rem !important;
    margin-top: -1rem;
  }
  .home-sec-5 .seg1{
    width: 100% ;
    margin-top: 1.3rem;
  }
  .home-sec-5 .seg2{
    width: 90%;
    margin-left: 0rem;
    margin-top: 0.7rem;
    line-height: 20px;
    text-align: left;
  }
  .home-sec-5 .seg2 .text{
    font-size: 18px !important;
    line-height: 24px !important;
  }
  .home-sec-5 .seg1 {
    font-size: 15px !important;
    line-height: 20px !important;
  }

  .home-sec-5 #inner{
    height: 600px;
    overflow: hidden;
  }
  .home-sec-5 .seg3{
    width: 100%;
    margin-top: 0.7rem;
  }
  .home-sec-5 span{
    font-size: 21px;
    line-height: 22px;
    text-align: left;
    width: 10% !important;
  }
  .home-sec-5 button {
    font-size: 18px;
    padding: 0px;
}
  .home-sec-6 h1 {
    text-align: left;
    margin-left: 0.6rem;
    font-size: 45px !important;
    line-height: 50px;
    max-width: 40%;
  }
  .dest-exp{
    margin-left: 0.3rem !important;
  }
  .le-exp{
    margin-left: -0.8rem !important;
  }
  .abt-exp{
    margin-left: -9rem !important;
  }
  .home-sec-6 p {
    font-size: 14px !important;
    line-height: 22px !important;
    margin-left: 0.6rem;
    text-align: left;
    max-width: 100%;
    margin-bottom: 0.8rem;
  }
  .home-sec-6 .btn-primary{
    padding: 10px 35px;
    font-size: 15px;
  }
  .button{
    background-color: white;
  }
  .h2{
    font-weight: 400!important;
    font-size: 32px!important;
    line-height: 36px!important;
  }
  .h1{
    font-weight: 400!important;
    font-size: 32px!important;
    line-height: 36px!important;
  }
  .travel-btn{
    margin-left: 0.5rem;
    margin-right: 0.3rem !important;
  }
  .home-sec-4 {
    padding-bottom: 10rem;
    padding-top: 2rem;
}
.home-voyage{
  margin-bottom: 0rem !important;
}

.about-banner-container .banner h1{
  font-size: 38px !important;
  line-height: 44px;
  padding-left: 0.5rem;
}

.about-banner-container .text-overlay {
  width: 80%;
  top:48%;
}
.about-banner-container .parallax-img{
  height: 520px;
  max-width: 100vh;
  left: 6rem;
}
.about-section-2 {
  border-bottom: 1px #fff solid;
}
.ad-media-banner-container .parallax-img{
  height: 80vh;
  object-fit: cover;
}

.blog-sec-4{
  background-color: #fff;
}
.blog-banner-container .text-overlay {
  width: 90%;
}
.blogRead-banner-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  height: 360px;
  background-size: cover;
}
.blogRead-sec-2 img{
  width: 100%;
}

  /* Destination mobile */

  .destination-banner{
    min-height: 105vh;
  }
  .destination-banner-container{
  height: 110vh;
  }
  .destination-europe{
    height: fit-content;
  }
  .destination-asia{
    height: fit-content;
  }
  .destination-africa{
    height: fit-content;
  }
  .destination-middleEast{
    height: fit-content;
  }
  .destination-america{
    height: fit-content;
  }
  .destination-banner h1{
    font-size: 34px;
    line-height: 2.7rem;
    margin-top: 12rem;
  }
  .destination-banner h1 span{
    font-size: 48px;
  }
  .destination-row{
    padding: 0;
  }
  .destination-banner p{
    max-width: 95%;
  }
  .sec-5{
    margin-top: 5rem;
  }
  .content{
    margin-top: -1.5rem !important;
  }
  .margin{
    height: 5rem !important;
  }
  .none{
    display: none;
  }
  .destination-banner .btn-primary{
    margin-top:15px;
  }
  .destination-sec-2{
    height: fit-content;
    }
  .destination-sec-2 p{
    font-size: 18px;
    line-height: 22px;
    margin-top: 0rem;
    padding: 10px;
    }
  .destination-sec-2 h1{
    max-width: 100%;
    font-size: 32px;
    line-height: 36px;
    text-align: left;
    margin-bottom: 2rem;
    /* margin-left: -4rem; */
    padding: 10px;

    
    }
    .destination-sec-5 .title-1{
      margin-top: 0px !important;
    }
    .des-sec-3{
      justify-content: left !important;
    }
    .des-sec{
      justify-content: left !important;
    }
    .des-sec-3{
      position: relative;
      top: 3rem;
    }
  .eu .dest-yellow-sm{
    margin-left: -2rem;
    font-size: 30px;
  }
  .destination-sec-5-content{
    margin-top: 2rem;
  }
  .destination-sec-2 .yellow-line:before{
    left: 5%;
    width: 100px;
    top: -1rem;
    }
  .destination-sec-3 p{
    font-size: 14px !important;
    font-weight: 400 !important;
  }
  .destination-sec-3 h1{
    font-size: 32px;
    line-height: 36px;
    text-align: left;
    max-width: 100%;
    /* margin-bottom: 2rem; */
    margin-left: 0.4rem;
    }
  .destination-sec-3 .yellow-line:before{
    left: 3px;
    }
  .destination-sec-3 .card{
    top: 2%;
    }
  .destination-sec-3 .card .box{
    padding: 55px 25px;
  }
  /* .content{
    padding: 0;
  } */
  .africa-sec2-content{
    margin-left: none !important;
  }
  .destination-sec-3 .card{
    height: 350px;
    width:288px;
    margin-left:0px;
  }
  .dest-sec-2{
    justify-content: left !important;
  }
  .sm-yellow{
    padding-left: 1rem !important;
  }
  .amer-ft{
    margin-top: 8rem;
  }
  .amer-sec5{
    padding-left: 0;
  }
  .sm-p {
    padding-left: 1rem !important;
    /* padding: 0 !important; */
    margin-top: -1rem !important;
  }
  .dest-yellow-sm{
    left: 3% !important;
  }
  .dest-yellow-sm::before{
    left: 3% !important;
  }
  .dest-p-sm{
    padding-left: 10px;
  }
  .dest-rw{
    justify-content: left !important;
  }
  .blog-sec-2 img{
    width: 100%;
    /* height: 350px; */
    margin-top: 1rem;
  }
  .destination-sec-3 .card-1{
    display: none;
    }
  .destination-sec-3 h4{
    font-size: 20px;
    line-height: 24px;
  }
  .destination-sec-5 h4{
    font-size: 20px !important;
    line-height: 24px !important;
  }
  .destination-sec-4{
    margin-top: 3.5rem;
  }
  .destination-sec-4 p{
    max-width: 88%;
    text-align: center;
    margin: auto;
  }
  .destination-sec-5 h1{
    max-width: 100%;
    font-size: 32px;
    line-height: 36px;
    text-align: left;
    margin-left: -0.8rem;
    margin-top: 1rem;
  }
  .content-america .sm-p{
    margin-bottom: 2px !important;
  }
  .destination-sec-5 .yellow-line:before{
    left: 2px;
  }
  .asia-sec-3{
    margin-top: 1rem;
  }
  .destination-sec-4 img{
    margin-left: 1px;
    width: 600px !important;
  }
  .asia-image{
    max-width: 600px !important;

  }
  .destination-sec-5 .row{
    max-width: 100%;
  }
  .destination-sec-5 .card{
    /* margin: 0px; */
    margin-left: 20px;
    width: 230px;
    height: 298px;
  }
  .content-sec{
    justify-content: center !important;
  }
  .destination-sec-5 .afr-expl{
    margin-left: 0.5rem;
  }
  /* .home-sec-3 p{
    font-size: 16px !important;
  } */
  .blog-banner p{
    font-size: 16px;
    line-height: 24px;
  }

  .common-section p{
    font-size: 16px ;
    line-height: 24px;
  }
  .home-sec-2 .sec2-desc{
    font-size: 14px;
    line-height: 24px;
  }
  .destination-sec-5 .exp-content{
    margin-left: 0.5rem;
  }
  .destination-sec-3 .card p{
    font-size: 14px !important;
  }
  .destination-sec-3 .card h4{
    line-height: 24px !important;
  }
  .destination-sec-5 .card h4{
    line-height: 24px !important;
    margin-bottom: 0;
  }
  .destination-sec-5 .card p{
    font-size: 14px !important;
    line-height: 17px !important;
    
  }
  .amer-scrolltop{
    margin-top: 8rem;
    /* margin-bottom: -5rem; */
  }
 
/* Blog */
.blog-sec-2 .box{
  display: block;
}
.timeline .col-2 img{
  max-width: unset;
  height: 150px;
  overflow-x: hidden;
}
.banner-timeline{
  margin-left: 0rem;
}
  .blog-banner{
    min-height: 109vh;
  }
  .blog-banner h1{
    font-size: 32px;
    line-height: 36px;
    margin-top: 8rem;
    margin-bottom: 20px;
  }
  .blog-banner h1 span{
    font-size: 39px;
  }
  .blog-banner p{
    max-width:96%;
  }
  .blog-sec-2 h2{
    margin-top: 0.15rem;
    font-size: 32px;
    line-height: 36px;
  }
  .blog-sec-4 h2{
    font-size: 32px;
    line-height: 36px;
  }
  .blog-sec-2 .card{
    margin-right:0px;
    margin-bottom: 13px;
  }
  .blog-sec-2 h6{
    font-size: 16px;
    margin-top: 15px;
  }
  .blog-sec-2 h4{
    font-size: 18px;
    line-height: 22px; 
    max-width: 70%;
  }
  .blog-sec-2 p{
    font-size: 14px;
    line-height: 20px; 
  }
  .blog-sec-2 .tag {
    top: 4%;
}
  .blog-sec-3-banner-container{
    background-position:0;
  }
  .blog-sec-3-banner h1{
    max-width: 100%;
    font-size: 30px;
  }
  .blog-sec-2 span {
    margin:10px;
    margin-left: 35px;
}
.blog-sec-2 .card {
  margin-bottom: 2rem;
  width: 100%;
  padding: 0;
  height: fit-content;
}
.blog-sec-2 h4 {
  height: 40px;
}
.blog-content {
  height: 200px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}
  .blog-sec-3-banner p{
    max-width: 84%;
    font-size: 16px;
    margin: auto;
  }
  .hidden-lg{
    display: block !important;
  }
  .blog-sec-3-banner {
    min-height: 105vh;
  }
  .blog-sec-4 h6{
    font-size: 13px;
    padding-bottom: 1rem;
  }
  .blog-sec-4 h4{
    font-size: 20px;
    max-width: 100%;
    margin-bottom: 1rem;
  }
  .blog-sec-4 p{
    font-size: 15px;
    max-width: 100%;
    margin-top: 0.5rem;
  }
  .blog-sec-4 .card{
    margin-right: 0px;
    margin-bottom: 15px;
  }
  .blog-sec-4 .box{
    padding:20px;
  }
  hr.solid-small {
    border-top: 2px solid white;
    width: 22.6%;
    opacity: 0.75;
    margin-left: 39%;
  }
  
.blog-sec-4 .slick-list{
  height: 400px;
  margin-top: 40px;

}
.blog-sec-4 .slick-next::before,.blog-sec-4 .slick-prev::before{
  display: none;
}
.blog-sec-4 .card{
  border: none;
  margin: 0px;
  height: 400px;
  border-radius: 0;
  margin-bottom: 2rem;
}
.blog-sec-4 .box{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);
  align-items: flex-start;
  text-align: left;
  padding: 42px 18px;
  transition: all ease 0.3s;
}


.destination-sec-3 .slick-slide{
  width: 310px !important;
  padding-left: 20px;
}


.home-sec-3 .thumb-img{
  justify-content: center !important;
}

.home-sec-3 .thumbnail-container, .home-sec-3 .thumbnail-container img{
  width: 100%;
}

  
/* Shop */

  .shop-sec-2 h4{
    margin-bottom: 2rem;
  }
  .shop-sec-2 p{
    font-size: 19px;
    line-height: 24px;
  }
  .shop-sec-2 .card{
    margin-right: 0px;
  }
  .shop-sec-3 p{
    margin-top: 8px;
  }
  .shop-sec-3 img{
    width: 350px;
  }
  .shop-sec-3 .card{
    height: 497px;
    margin-right:0px;
    margin: 0px 0px 75px 12px;
  }
  .shop-sec-3 .tag1 , .shop-sec-3 .tag2{
    top: 4%;
    left: 77%;
}
  .star {
    max-width: 100px;
  }
  .shop-sec-3 .title-box{
    padding-left: 15px;
    padding-bottom: 25px;
    }
  .shop-sec-3 .btn-primary{
    margin-top: 2rem;
  }
  .shop-sec-4 p{
    max-width: 90%;
    font-size: 18px;
    margin-bottom: 2rem;
  }
  .shop-sec-4 .card{
    margin: 0px;
    margin-top: 2rem;
    border: none;
    height: 400px;
  }
  .shop-sec-4 .box{
  margin-bottom: 2rem;
  }
  .shop-sec-4 .slick-dots li {
    margin: -15px 10px; 
  }

  .reduced .box {
    height: 450px;
    width: 358px;
}
/* .destination-sec-5 .slick-arrow.slick-next{
  display: none !important;
} */
.destination-sec-5 .box{
  padding: 55px 25px;
}
.shop-sec-4 .slick-dots li button::before {
 display: none;
}


/* ShopSub */

  .shopSub2-sec-2{
    margin-top:8.6rem ;
  }
  .shopSub-banner-container{
    height: 80vh;
  }
  .shopSub-banner h1{
    font-size: 32px;
    line-height: 2.3rem;
    text-align: left;
    margin-top: 9rem;
  }
  .shopSub-banner h1 span{
    font-size: 32px;
  }
  .shopSub-banner p{
    font-size: 17px;
  }
  .shopSub-sec-2 p{
    font-size: 20px;
    line-height: 30px;
    margin-left: 4rem;
  }
  .filter{
    margin-left: -5.3rem !important;
  }
  .shopSub-sec-2 .col-1{
    width: 3rem;
    margin-left: 7rem;
    margin-bottom: 0.8rem;
  }
  .shopSub-sec-2 .col-2{
    width: 11rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding-left: 0;
  }
  #dropdown-toggle1 {
    width: 10rem;
    font-size: 15px;
}
.shopSub-sec-2 .dropdown-menu {
  min-width: 9rem;
}
.shop-sec-3 .overlay{
  height: 108%;
  width: 96%;
}
.overlay img{
  width: 22px;
}
  .shopSub-sec-2 .col-5{
    width: 43rem;
  }
  .dropdown-toggle{
    padding: 7px;
    width: 11rem;
    height: 40px;
    align-items: center;
  }
  .shopSub-sec-4 h6{
    font-size: 21px;
    line-height: 20px;
  }
  .shopSub-sec-4 p{
    font-size: 17px;
    line-height: 15px; 
  }
  .shopSub-sec-4 .col-1{
    margin-left: 1rem;
    margin-top: 5px;
  }
  .shopSub-sec-4 .col-2{
    width: 17rem;
    margin-bottom: 3.9rem;
  }
  .hidden{
    display: none !important;
  }

  
  
/* ShopSub2 */


  .shopSub2-sec-4 .col-5{
    border-radius: 0px;
    width: 23.8rem;
    height: 30rem;
    margin-left: 0rem;
  }
  .shopSub2-sec-4 h2{
    font-size: 28px;
    max-width: 50%;
    margin-left: 5px;
  }
  .shopSub2-sec-4 .col-6{
    margin-left: 0rem;
  }
  .shopSub2-sec-4 h3{
    color: #9F9F9F;
    font-family: Poppins;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 0.3rem;
    text-align: right;
  }
  .shopSub2-sec-4 .col-lg-5{
    border-radius: 0px;
    width: 100%;
    height: 28rem;
    margin-left: 0rem;
    margin-top: 8.15rem;
  }
  .star1{
    max-width: 100%;
  }
 
  .sofa img{
    height:  23rem;
    max-width: 21.8rem;
    margin-left: 0;
  }
  .shopSub2-sec-4 h4{
    font-size: 28px;
    margin-top: 10px;
    line-height: 29px;
    text-align: right;

  }
  .sofa{
    margin-right: 0;
  }
  .shopSub2-sec-4 .col-2{
    width: 7rem;
  }
  .shopSub2-sec-4 p{
    font-size: 15px;
    line-height:19px;
    margin-left: 5px;
  }
  .sh-sec-5 .col-5{
    width: auto !important;
    height: auto !important;
  }
  .shopSub2-sec-4 .btn-primary{
    font-size: 18px;
    padding: 12px 122px;
    margin-left: 4px;
  }
  .shopSub2-sec-4.box {
    padding: 20px; 
    margin: 60px; 
  }
  .shopSub2-sec-4 .count {
    margin-left: 6px;
}
  .shopSub2-sec-4 h6{
    color: #9F9F9F;
  font-family: Poppins;
  font-size: 15.2px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 10px;
  }

/* Cart */

  .cart-sec-2 .col-4{
    margin-left: 0rem;
    width: 20rem;
  }
  .cart-sec-2 h3{
    font-size: 15px;
  }
  .cart-sec-2 h2{
    font-size: 28px;
  }
  .cart-sec-2 h4{
    font-size: 16px;
  }
  .cart-sec-2 h5{
    font-size: 20px;
    text-align: center;
  }
  .cart-sec-3 h4{
    font-size: 19px;
    margin-bottom: 2.8rem;
  }
  .cart-sec-3 h6{
    font-size: 19px;
    margin-bottom: 2.6rem;
  }
  .cart-sec-3 h5{
    font-size: 24px;
    margin-left: 0.5rem;
  }
  .cart-sec-2 .btn-primary{
    font-size: 17px;
    padding: 18px 95px; 
    margin-top: 1rem;
  }
  .bg{
    background-color: #E5E5E5;
  }
  .cart-sec-2 .col-lg-4{
    margin-left: 0rem;
    width: 25rem;
    margin-top: 1rem;
    padding-top: 1rem;
  }
  .cart-sec-4 h4{
    color: #000;
    font-family: Poppins;
    font-size: 19px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin-left: 10px;
  }
  .cart-sec-4 h5{
    color: #000;
    font-family: Poppins;
    font-size: 19px;
    font-style: normal;
    font-weight: 400;
    text-align: left;
    line-height: normal;
    margin-left: 10px;

  }
  .cart-sec-4 .box-1 {
    width: 100px;
    border: 2px solid black;
    margin-left: 10px;
    margin-bottom: 30px;
  }
  .cart-sec-4-img img{
    height: 25px;
    margin-left: 20px;
  }
  .cart-sec-4 .col-1 {
    height: 81px;
    width: 81px;
}
.cart-sec-4 .row-1{
  border-radius: 10px;
  border-color: #000;
}
.blog-banner-container .text-overlay {
  top: 30%;
}

  
/* Checkout */

  .checkout-sec-2 h1{
    font-size: 36px;
  }
  .checkout-sec-3 .form {
    padding: 7px;
    width: 350px;
  }
  .checkout-sec-3 label {
    font-size: 19px;
  }
  .checkout-sec-3 .input-box {
    padding: 10px;
    width: 100%;
    height: 3.6rem;
    margin-bottom: 30px;
    margin-top: 5px;
  }
  .checkout-sec-3 h3{
    font-size: 24px;
    margin-left: 2.6rem;
  }
  .checkout-sec-3 h2{
    font-size: 24px;
  }
  .checkout-sec-3 h5{
    font-size: 24px;
    line-height: 1rem;
    margin-top: 1.9rem;
    text-align: right;
    margin-right: 0.8rem;
  }
  .checkout-col-1 {
    margin-left: 0rem;
}
  .checkout-sec-3 h4{
    font-size: 16px;
    margin-top: 15px;
  } 
  .checkout-col {
    margin-left: 0rem;
}

  .checkout-sec-3 h6{
    font-size: 16px;
    line-height:9px;
    margin-top: 2rem;
    text-align: right;
    margin-right: 0.9rem;
  } 
  .checkout-sec-3 p{
    font-size: 16px;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
  .para{
    max-width: 95% !important;
    margin-left: 0.8rem !important;
  }
  .checkout-sec-3 .btn-primary{
    font-size: 17px;
    padding: 15px 95px;
    margin-bottom: 4rem;
  }
  .checkout-sec-3 span{
    font-size: 13.6px;
  }
  hr.solid {
    width: 98%;
  }
  .checkout-sec-3 h1{
    font-size: 15px;
  }
  .cart-sec-4 .row{
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    padding: 14px 0px;
    border-radius: 10px;
    margin-bottom: 2rem;
  }
  .p.know-more{
    font-size: 15px;
  }
  
  .admedia-sec-1 h2{
    margin-bottom: 20px;
  }
  .blog-sec-2{
    padding-top: 2rem;
  }
  .ad-media-banner-container .text-overlay {
    width: 90%;
    padding-left: 1rem;
    top: 38%;
}
.ad-media-banner-container .banner p{
  max-width: 100%;
}
.blog-banner-container .parallax-img{
  margin-right: -25px;
}  

  /* .home.banner h1{
    font-size: 31px;
  } */
  /* Ad&media */
  .admedia-sec-1{
    min-height: 62vh;
  }
  .admedia{
    margin-top: 120px;
  }
  .admedia-sec-1 h1{
    font-size: 32px;
    line-height: 38px;
    letter-spacing: -0.5px;
    margin-top: 0rem;
    margin-bottom: 0rem;
  }
  .admedia-sec-4 .box{
    padding: 55px 25px;
  }
  .admedia-sec-1 span{
    font-size: 75px;
    letter-spacing: -0.1px;
    line-height: 100%;
    margin-top: 0rem;
    text-align: left !important;
    margin-left: -33px;
    margin-right: auto;
  }
  .admedia-sec-1 p{
    font-size: 17.8px;
    margin-top: 5px;
    max-width: 95%;
  }
  .admedia-sec-2 h1{
    font-size: 32px;
    line-height: 36px;
    margin-left: 0.2rem;
    margin-bottom: 0.5rem !important;
    margin-top: 0rem;
  }
  .admedia-sec-3 p{
    font-size: 17px;
    margin-left: 0.2rem;
  }
  .tab{
  justify-content: center !important;
  }
  .admedia-sec-3 .card{
    height: 340px;
    width:330px;
    margin-left:0px;
    margin-top: 3rem;
  }
  .admedia-sec-3 h4{
    font-size: 25px;
    line-height: 16px;
  }
  .admedia-sec-3 .card p{
    font-size: 18px;
    line-height: 25px;
  }
  .admedia-sec-4 h4, .admedia-sec-4 p,   .destination-sec-5 h4, .destination-sec-5 p {
    color: #fff;
    line-height: 15px;
    margin-bottom: 10px;
  }
  .destination-sec-5 h4{
    margin-bottom: 0px;
  }
  .admedia-sec-4 h4{
    font-size: 20px;
    line-height: 20px;
  }
  .admedia-sec-4 .row{
    max-width: 100%;
    margin: 0;
  }
  .admedia-sec-4 .card{
    margin: 0px;
    width: 90%;
    /* width: 203px; */
    /* height: 299px; */
  }
  /* .reduced .card {
    transform: scale(1);
} */
.admedia-sec-3 .card .box {
  padding: 20px 20px;
}
.home-sec-4>div{
  flex-wrap: unset;
  height: unset;
  width: unset;
}

.contact-sec-1{
  background-color: black;
}
  /* Gallery */

  
  .gallery{
    margin-top: 115px;
  }
  .gallery-sec-1 h2{
    font-size: 14px;
  } 
  .gallery-sec-1 .col-2{
    width: 4.5rem;
  }
  .gallery-sec-2{
    margin-right: 0px;
  }
  .gallery-sec-2 img{
    width: 500px;
    margin-bottom: 15px;
  }
  .gallery-sec-2 .row1 img{
    height: unset;
    max-width: 100%;
  }
  .gallery-sec-2 .row2 img{
    height: unset;
    max-width: 100%;
  }
  .gallery-sec-2 .row3 img{
    height: unset;
    max-width: 100%;
  }
  /* Contact */

  .contact-sec-1{
    padding-top: 1.5rem;
  }
.contact-sec-1 h1{
  font-size: 24px;
  line-height: 30px;
  margin-top: 0rem !important;
  max-width: 100%;
}
.contact-sec-1 .yellow-line:before{
  left: 26%;
}
.contact-sec-1 p{
  font-size: 16.5px;
  max-width: 99%;
  margin-bottom: 0rem !important;
  margin-top: -1.1rem;
}
.contact-sec-2 h1{
  font-size: 35px;
}
.form-section h1{
  font-size: 32px;
  line-height: 36px;
  max-width: 100%;
  text-align: left;
  margin-right: 0%;
  margin-top: 0px !important;
}
#enquiryForm{
  width: 100%;
  margin-top: 0%;
  padding: 2rem;
}
.form-section input, .form-section textarea, .form-section select{
  /* margin-bottom: 1.5rem !important; */
  margin-top: 2rem;
  font-size: 16px;
  }

    /* about */

    .about-sec-2 h1{
      font-size: 30px;
      line-height: 36px;
      margin-bottom: 3rem;
    }
    .about-sec-2 .yellow-line:before{
      top: 108%;
      left: 1%;
    }
    .about-sec-2 p{
      max-width: 100% !important;
      margin-top: 1.5rem;
    }
    .padding{
      padding: 0;
    }
    .about-sec-2 .col-lg-5{
      width: 100%;
    }
.destination-sec-4 .col-12{
  padding: 0;
}
.yellow-btn{
  margin-top: 2.3rem !important;
}
.blogRead-sec-1 h1{
  line-height: 39px;
  font-size: 28px;
  max-width: 100%;
}
.blogRead-sec-1 p, .blogRead-sec-2 p{
  max-width: 100%;
  margin-top: -1.5rem;
}
.blogRead-sec-1 .yellow-line:before{
  left: 33%;
  top:100%;
}
/* .blogRead{
  margin-top: 7.5rem;
} */
.bRead{
  padding: 0 !important;
}
.blogRead-sec-1 h3{
  font-size: 20px;
}
.blogRead-sec-1 h2{
  font-size: 18px;
}
.p-image{
  padding: 0;
}
.p-image img{
  width: 500px !important;
}
.form-section label{
  font-size: 16px;
  line-height: 150%;
}
.section{
  margin-top: 9rem !important;
   border-bottom-left-radius: 70px;
   border-bottom-right-radius: 70px;
  padding: 36px 22px;
  width: 100%;
}
.scroll-top .col-auto{
  margin-right: 1rem;
}
.scroll-top span{
  font-size: 7px ;
}
.scroll-top .scroll-top-btn{
  margin-bottom: -3rem;
}

.home-sec-6 .footer-desc {
  font-size: 14px !important;
}
.home-sec-6 .plan-txt{
  margin-bottom: 17px;
  justify-content: space-between !important;
}
.home-sec-2 .product-card-slider .sec2-title{
  line-height: 24px !important;
  /* font-size: ; */
}
.eu.destination-sec-2 .dest-yellow-sm{
  margin-bottom: 0px;
}

.blog-sec-2 .blog-box .date{
  font-size: 14px;
  margin-bottom: 1.2rem;
}
.blog-sec-2 .blog-box .descr1{
  margin-bottom: 10px;
  font-size: 18px;
  line-height: 20px;
}
.blog-sec-2 .blog-box .adventure-text{
  margin-bottom: 10rem !important;
}

#blog-scroller .product-card-slider .slick-slide{
  width: 300px;
  opacity: 50%;
}

#blog-scroller .product-card-slider span{
  font-size: 15px;
  line-height: 20px;
}
#blog-scroller .product-card-slider .slick-active{
  opacity: 100%;
}
.dest-contact .contact-arrow{
  position: relative;
  bottom: 2px;
  left: 10px;
}
.home-sec-6 .contact-btn{
  padding: 10px 44px;
}
.home-sec-6 .footer-title {
  font-size: 40px !important;
  line-height: 48px;
}

}

/* for destination cards */
@media (max-width:360px){
  .destination-sec-3 .card{
    width: 240px;
  }
  .destination-sec-3 .slick-slide {
    width: 260px !important;
  }
}

@media (min-width:992px){
  .destination-sec-3 .card-1{
    margin-top: 7rem;
  }
  .amer-sec5{
    margin-bottom: 2rem;
  }
  .eu-sec-5 .dest-sec-2{
    margin-bottom: 2.5rem;
  }
  .blog-sec-2{
    padding-top: 3rem;
  }
  .me-banner-content, .la-banner-content{
    width: 53%;
  }
  /* .dest-contact .contact-arrow{
    position: relative;
    bottom: 2px;
    left: 10px;
  }
  .dest-contact{
    padding: 5px 20px;} */
}


@media (min-width:1400px){
  .home.banner p{
    max-width: 75%;
  }
  /* .home-sec-2 .card{
    width: 310px;
    height: 380px;
  } */
  .home-sec-2 .slick-slide{
    width: 320px;
  }
  /* .home-sec-2 .card-img-top{
    height: 410px;
  } */
  /* .home-sec-2 .card:hover{
    height: 470px;
  } */

  .ad-media-banner-container .text-overlay {
    width: 100%;
    padding-left: 6rem;
  }
  .ad-media-banner-container .banner p {
    max-width: 75%;
  }
  

  .gallery-sec-2 .row1 img{
    height: 390px;
    max-width: 100%;
  }
  .gallery-sec-2 .row2 img{
    height: 763px;
    max-width: 100%;
  }
  .gallery-sec-2 .row3 img{
    height: 367px;
    max-width: 100%;
  }
  .destination-sec-4 img{
    height: 280px;
  }
  .shopSub-sec-4 .col-2 {
    width: 17rem;
  }
  /* .timeline{
    margin-top: 21rem;
  } */
    .price{
      margin-left: 5.4rem !important;
    }
    .quantity{
      margin-left: 6.3rem !important;
    }
    .total{
      margin-left: 4.2rem !important;
    }
    .cart-sec-2 h3{
      margin-left: 7.6rem
    }
    .checkout-sec-3 .form {
      width: 530px;
    }
    .para{
      max-width: 93% !important;
    }
    .banner h1 ,.shopSub-banner h1, .shopSub-banner h1 span{
      font-size: 40px;
    }
    .blog-banner h1, .blog-banner h1 span{
      font-size: 40px;
    }
    .shopSub-sec-2 .col-5 {
      width: 55rem;
  }
    .gallery-sec-1 h2{
      font-size: 13px;
    }
    .shopSub-sec-4 img{
      margin-left: 55px;
    }
    .shopSub-sec-4 h6 , .shopSub-sec-4 p {
      margin-left: 50px;
    }
    .banner-timeline{
      margin-left: 7rem;
    }
    .line{
      width: 6.45rem;
    }
    .shopSub-banner-container {
      padding-top: 12rem;
  }
  .destination-banner .col-lg-5{
    width: 30.5%;
    }
    .shop-sec-4 .slick-next{
      left: calc( 100vw - 85%);
    }
     .shop-sec-4 .slick-current .card{
      height: 455px;
      width: 410px;
}
/* .blog-sec-2 img {
  width: 380px;
} */

.home-sec-4 .card:last-child .box:hover .line{
  width: 125px;
  
}
.home-sec-4 .card:last-child .box .line{
  left: 36%;
  
}
.about-sec-2 .padding{
  margin-right: 2rem;
}

.admedia {
  margin-top: 130px;
}
.admedia-sec-4 .card{
  width: 430px;
}
.cart-sec-2 .col-lg-4{
  margin-left: 6.5rem;
}
.checkout-sec-3 h3{
  margin-left: 7.5rem;
}
.checkout-sec-3 h5{
  margin-left: 8.7rem;
}
.checkout-sec-3 h6{
  margin-left: 10rem;
} 
.destination-sec-3 .card{
  left: 10%;
}
.form-section h1{
  margin-right: 32%;
}
.asia .col-lg-7{
  width: 45%;
}
.africa .col-lg-7{
  width: 46%;
}
.europe .col-lg-7{
  width: 49%;
}
/* .blog-sec-2 {
  margin-left: 8rem;
} */
/* .blog-sec-2 .card-sec{
  margin-left: -20px;
} */
.blog-sec-2 .card-sec-2{
  margin-left: -20px;
  margin-top: 5rem;
}
.blog-sec-2 .trending{
  position: relative;
  /* left: -20px; */
}
.admedia-card {
  padding: 2rem;
}
.me-banner-content, .la-banner-content{
  width: 50%;
}
.blog-sec-2 .blog-row{
  margin-bottom: 6rem !important;
}
.blog-sec-2 .card {
  margin-bottom: 6rem
}

    
}

/* @media (min-width:1280px){
  .home-sec-2 .slick-next {
    padding-right: 5rem;
  }
} */

@media (max-width:335px){
  /* .home-sec-4 .yellow-line {
    margin-top: 23rem;
  } */
  .home-sec-3 span {
    font-size: 18px;
  }
  .social-icons-container {
    font-size: 14px !important;
  }
  .abt-exp {
    margin-left: -6rem !important;
}
.asia-sec-3 {
  margin-top: 6rem;
}
.destination-sec-2.middleEast h1  {
  margin-top: 10rem !important;
}
.destination-sec-5 h1 {
  margin-top: 6rem ;
}
.destination-sec-2 h1{
  margin-top: 3rem;
}
.destination-sec-3 h1{
  margin-top: 4rem !important;
}
.home-sec-2 .slick-next{
  right: 11rem;
}
.home-sec-4 .slick-next {
  right: 13rem;
}
.navbar-toggler {
  padding-right: 5px !important;
}
}`, "",{"version":3,"sources":["webpack://./src/Pages/base.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EAIE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;;IAGI,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;;;;AAKA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kCAAkC;AACpC;AACA;EACE,UAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;;EAEhC,4BAA4B;EAC5B,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,sBAAsB;EAGtB,2BAA2B;EAG3B,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EAIE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA,uBAAuB,mCAAmC,CAAC;AAC3D;EACE,WAAW;EACX,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;;AAEvB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAElB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;;EAEd,eAAe;AACjB;AACA;;GAEG;AACH;;GAEG;AACH;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;;AAEb;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;;AAEb;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;IAChB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;AACA;EACE,gBAAgB;;AAElB;;;AAGA,cAAc;AACd;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,OAAO;AACT;AACA;;GAEG;;AAEH;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;GAEG;AACH;;GAEG;AACH;;GAEG;AACH;EACE,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,2BAA2B;EAC3B,YAAY;EACZ,WAAW;AACb;;;AAGA;;GAEG;AACH;EACE,gDAA8D;AAChE;AACA;EACE,gDAAgE;AAClE;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,MAAM;EACN,uBAAuB;EACvB,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;;AAEZ;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,mCAAmC;AACrC;AACA;;GAEG;AACH;;;GAGG;;AAEH;;;GAGG;;AAEH;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,4EAA4E;EAC5E,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;;;GAGG;AACH;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;;AAEjC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;;;AAGA;EACE,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;;;;AAIpB;AACA;;;GAGG;AACH;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,SAAS;EACT,0BAA0B;EAC1B,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,iEAAiE;EACjE,yBAAyB;AAC3B;AACA;;EAEE,iEAAiE;AACnE;AACA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;;AAEd;;;AAGA;AACA,uBAAuB;AACvB,gBAAgB;AAChB,wBAAwB;AACxB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;AACf;AACA;EACE;;AAEF;AACA;EACE,qBAAqB;;AAEvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;;AAE3B;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;CACC,cAAc;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,QAAQ;EACR,YAAY;AACd;AACA,qBAAqB;;AAErB;;EAEE,yDAA2D;;EAE3D,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,gBAAgB;;AAElB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yDAA0D;AAC5D;;AAEA;EACE,yDAA6D;EAC7D,UAAU;AACZ;AACA;EACE,yDAA+D;EAC/D,aAAa;EACb,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,UAAU;EACV,SAAS;EACT,eAAe;AACjB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;;;;AAKA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;;AAGA;EAIE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;EACE;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,iBAAiB;GAClB,gBAAgB;EACjB;AACF;EACE,eAAe;EACf;AACF;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,wBAAwB;AAC1B;AACA;;;GAGG;AACH;;eAEe;AACf,MAAM;;AAEN;EACE,aAAa;EACb,yBAAyB;AAC3B;;;;AAIA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,4EAA4E;EAC5E,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,aAAa;GACZ,WAAW;GACX,eAAe;GACf,yBAAyB;AAC5B;AACA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,0DAA0D;AAC5D;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,aAAa;AACf;;;AAGA;;;GAGG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;;;;AAKA;;GAEG;AACH;;;GAGG;;;AAGH,WAAW;AACX;;;;;;;;;;;GAWG;;AAEH;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;CACxB;CACA;EACC,uBAAuB;CACxB;;AAED;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;;;;AAKA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,yEAAyE;EACzE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;;AAEpB;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;;;AAIA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;AACA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX;AACF;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,6BAA6B;EAC7B,mCAAmC;AACrC;;;CAGC;EACC,4BAA4B;EAC5B,gBAAgB;CACjB;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;;;GAiBG;;AAEH,8BAA8B;;AAE9B;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;;;;AAKA,SAAS;;AAET;EACE,uBAAuB;AACzB;AACA;EAIE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;EACE;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;EACE;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,uBAAuB;;EAEzB;;AAEF;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;CACC;EACC,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;AACA,kBAAkB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;;;GAIG;AACH;;;;;GAKG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;;;AAIA;EAIE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,SAAS;;AAET;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,UAAU;AACZ;AACA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;;;;GAIG;AACH;EACE,QAAQ;AACV;AACA;EACE;eACa;EACb,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;CACd,oBAAoB;CACpB,kBAAkB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,mBAAmB;AACrB;AACA;AACA,2DAAuD;AACvD;AACA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;AACjC;AACA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,WAAW;EACX,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB,cAAc;AAChB;AACA,YAAY;;AAEZ;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;;;;AAIA;EACE,uBAAuB;AACzB;AACA;EAIE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;EACE;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB;EACF;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,mCAAmC;IACnC,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,UAAU;EACZ;EACA;IACE,cAAc;EAChB;;;AAGF,aAAa;;;AAGb;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;AACjB;AACA,SAAS;;AAET;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;;AAGA,aAAa;AACb;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA,aAAa;AACb;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb,oBAAoB;AACpB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB,sBAAsB;AACtB,yBAAyB;AACzB,2BAA2B;AAC3B,kBAAkB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,8EAA8E;EAC9E,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;;;GAGG;AACH;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,sEAAsE;EACtE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,aAAa;AACf;AACA;;GAEG;;AAEH;;GAEG;AACH;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA,YAAY;;AAEZ;EACE,gBAAgB;AAClB;AACA;EACE,0DAAkD;UAAlD,kDAAkD;EAClD,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,sDAA8C;UAA9C,8CAA8C;AAChD;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,YAAY;AACd;CACC;EACC,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;AACf;;;AAGA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd;yCACuC;AACzC;AAMA;EACE,KAAK,sBAAsB,EAAE;EAC7B,MAAM,8BAA8B,EAAE;EACtC,OAAO,6BAA6B,EAAE;AACxC;AACA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,cAAc;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,2BAA2B;EAC3B,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,cAAc;EACjC,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,4DAA4D;EAC5D,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,WAAW;AACb;;AAEA,UAAU;;AAEV;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;;AAEZ;;AAEA;EACE,0EAAuE;;AAEzE;AACA;;GAEG;;AAEH,aAAa;;AAEb;EACE,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;;AAExB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE;;;IAGE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,4CAA4C,EAAE,qBAAqB;AACvE;EACE;IACE,aAAa;MACX,iBAAiB;EACrB;EACA;;MAEI;EACJ;;KAEG;EACH;IACE,iBAAiB;EACnB;EACA;IACE;EACF;IACE;QACI,0BAA0B;QAC1B,iBAAiB;QACjB,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;;IAEA;MACE,UAAU;MACV,YAAY;MACZ,WAAW;MACX,UAAU;IACZ;;IAEA;MACE,WAAW;IACb;IACA;MACE,mBAAmB;MACnB,yBAAyB;IAC3B;IACA;MACE,iBAAiB;MACjB,wBAAwB;MACxB,qBAAqB;IACvB;IACA;MACE,iBAAiB;EACrB;IACE;MACE,aAAa;IACf;IACA;MACE,eAAe;IACjB;IACA;MACE,aAAa;MACb,0CAA0C;;IAE5C;IACA;MACE,UAAU;IACZ;IACA;MACE,SAAS;IACX;IACA;MACE,eAAe;MACf,iBAAiB;MACjB,gBAAgB;IAClB;IACA;MACE,iBAAiB;MACjB,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB;MACnB,4BAA4B;IAC9B;GACD;IACC,eAAe;GAChB;GACA;IACC,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;;;;EAIA;GACC,iBAAiB;AACpB;;EAEE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE;EACF;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;EACf;;AAEF;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;IACjB,iBAAiB;AACrB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;;AAGA;EACE,yBAAyB;EACzB,cAAc;AAChB;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,aAAa;IACb,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA,oBAAoB;IAClB,qBAAqB;IACrB,0BAA0B;IAC1B,sBAAsB;EACxB,MAAM;EACN;IACE,8BAA8B;IAC9B,YAAY;;EAEd;EACA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,aAAa;EACf;EACA;;KAEG;EACH;IACE,SAAS;EACX;EACA;MACI,kBAAkB;MAClB,SAAS;MACT,2BAA2B;MAC3B,YAAY;MACZ,YAAY;EAChB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,gDAA8D;EAChE;EACA;IACE,gDAAgE;EAClE;EACA;MACI,eAAe;EACnB;EACA;;KAEG;EACH;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;;;EAGA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,kBAAkB;;EAEpB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;;;EAGA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,oBAAoB;IACpB,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA,oBAAoB;;;EAGpB;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;AACd;EACE;IACE,eAAe;IACf;EACF;EACA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,oBAAoB;;EAEtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,kBAAkB;;EAEpB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;IAC9B,2BAA2B;EAC7B;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,eAAe;EACjB;EACA;IACE,UAAU;IACV,SAAS;IACT;EACF;IACE,SAAS;EACX;EACA;IACE,UAAU;IACV,aAAa;IACb,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,WAAW;AACf;EACE;IACE,UAAU;AACd;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;;GAEG;AACH;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA,cAAc;AACd;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA,SAAS;AACT;EACE,sBAAsB;AACxB;;EAEE;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf;IACA;MACE,iBAAiB;IACnB;EACF;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,OAAO;IACP,SAAS;AACb;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB;EACF;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,YAAY;IACZ,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;EACd;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB;EACF;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX;EACF;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,SAAS;EACX;EACA;IACE,UAAU;IACV,gBAAgB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B;EACE;;GAEC;AACH;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;AACZ;AACA,SAAS;;EAEP;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,WAAW;AACf;EACE;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,YAAY;AAChB;EACE;IACE,0BAA0B;EAC5B;GACC;IACC,kBAAkB;IAClB,oBAAoB;IACpB;EACF;IACE,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA,YAAY;;EAEZ;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;EACA,mBAAmB;EACnB;EACA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,UAAU;EACZ;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF,aAAa;;AAEb;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;EACE;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;IACb,0DAA0D;AAC9D;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;EAEE,SAAS;;EAET;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,4EAA4E;IAC5E,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,WAAW;AACf;AACA;CACC,aAAa;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;EACE,aAAa;;EAEb;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;EAC9B;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;;AAEnB;;AAEA;EACE,sBAAsB;AACxB;;EAEE,aAAa;;EAEb;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,sEAAsE;IACtE,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;;GAEC;AACH;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;;GAEG;;;CAGF;EACC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;CACxB;CACA;EACC,uBAAuB;CACxB;;CAEA;EACC,0DAA+D;CAChE;;EAEC,YAAY;;EAEZ;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ;wBACoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;AACjB;EACE;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,0DAA6D;IAC7D,aAAa;EACf;;;EAGA;IACE,cAAc;EAChB;EACA;IACE,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;;EAEA,YAAY;;;EAGZ;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,eAAe;IACf,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;;EAEA,UAAU;;EAEV;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,QAAQ;EACV;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,0BAA0B;EAC5B;EACA;;;KAGG;EACH;IACE,mBAAmB;EACrB;AACF;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;AACA,qBAAqB;AACrB;AACA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;AACb;;AAEA,aAAa;AACb;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;AAQA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgLG;AACH;EACE;IACE,sCAAsC,EAAE,qBAAqB;AACjE;AACA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;;IAGI,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,0CAA0C;;EAE5C;EACA;IACE,UAAU;EACZ;AACF;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,WAAW;AACb;EACE;IACE,sBAAsB;IACtB,aAAa;IACb,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;EACE;IACE,iBAAiB;IACjB,oBAAoB;IACpB,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,YAAY;IACZ,0CAA0C;;EAE5C;EACA;IACE,WAAW;EACb;EACA;;;KAGG;EACH;IACE,aAAa;IACb,OAAO;EACT;;AAEF;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,gDAA8D;AAChE;AACA;EACE,gDAAgE;AAClE;;EAEE;IACE,iBAAiB;IACjB,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,UAAU;EACZ;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,UAAU;IACV,4BAA4B;IAC5B,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,eAAe;AACnB;EACE;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,sEAAsE;EACxE;EACA;IACE,cAAc;IACd,wBAAwB;IACxB,kBAAkB;IAClB,sEAAsE;;EAExE;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,QAAQ;IACR,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;;;;;OAKK;;EAEL;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,OAAO;EACT;EACA;IACE,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,kCAAkC;IAClC,qBAAqB;IACrB,oBAAoB;EACtB;EACA;IACE,OAAO;EACT;EACA;IACE,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,aAAa;EACf;EACA;IACE,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,aAAa;AACjB;EACE;IACE,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,2BAA2B;IAC3B,+BAA+B;GAChC;GACA;IACC,cAAc;IACd,gBAAgB;GACjB;GACA;IACC,wBAAwB;GACzB;EACD;IACE,UAAU;IACV,WAAW;IACX,aAAa;EACf;EACA;IACE;EACF;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;IAC/B,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,YAAY;AAChB;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;EACA;IACE,qBAAqB;IACrB,iBAAiB;AACrB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,OAAO;AACT;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,0DAA6D;EAC7D,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;EAEE,uBAAuB;;EAEvB;IACE,iBAAiB;EACnB;EACA;EACA,aAAa;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB;EACF;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb;EACF;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;;;IAGb;IACA;MACE,0BAA0B;IAC5B;IACA;MACE,gCAAgC;IAClC;IACA;MACE,gCAAgC;IAClC;IACA;MACE,kBAAkB;MAClB,SAAS;IACX;EACF;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;IACR,YAAY;IACZ,UAAU;IACV;EACF;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB;EACF;IACE,SAAS;IACT;EACF;IACE,OAAO;IACP;EACF;IACE,kBAAkB;EACpB;EACA;;KAEG;EACH;IACE,4BAA4B;EAC9B;EACA;IACE,aAAa;IACb,WAAW;IACX,eAAe;EACjB;EACA;IACE,gCAAgC;EAClC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;EAC9B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gCAAgC;EAClC;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb;EACF;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,2BAA2B;;EAE7B;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,aAAa;EACf;EACA;IACE,kCAAkC;EACpC;EACA;IACE,mBAAmB;EACrB;EACA;;KAEG;EACH;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;;EAE9B;EACA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;AAEF,SAAS;AACT;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,OAAO;AACX;EACE;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,WAAW;IACX,iBAAiB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,0CAA0C;AAC5C;EACE;IACE,cAAc;IACd,eAAe;IACf,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;AAEF;EACE,aAAa;EACb,gBAAgB;;AAElB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,sEAAsE;EACtE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;;AAGA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;;AAGA,SAAS;;EAEP;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,OAAO;IACP,SAAS;AACb;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB;EACF;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,aAAa;EACf;EACA;EACA,mBAAmB;EACnB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,YAAY;AAChB;AACA;;GAEG;AACH;EACE,kBAAkB;AACpB;AACA;CACC,aAAa;AACd;;;AAGA,YAAY;;EAEV;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;AACb;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,wBAAwB;EAC1B;;;;AAIF,aAAa;;;EAGX;IACE,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;;EAEnB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,gBAAgB;AACpB;EACE;IACE,cAAc;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB;;AAEF,SAAS;;EAEP;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;;EAEnB;EACA;IACE,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,WAAW;AACf;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;;;AAGA,aAAa;;EAEX;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,iBAAiB;AACrB;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;AACrB;;EAEE;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,4EAA4E;IAC5E,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,QAAQ;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;EAEE;;KAEG;EACH,aAAa;EACb;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;EACA,kCAAkC;EAClC;EACA;IACE,aAAa;IACb,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,mBAAmB;EACrB;EACA;;GAEC;AACH;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;EACE,YAAY;;;EAGZ;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA,YAAY;;EAEZ;IACE,mBAAmB;EACrB;AACF;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf;;IAEE,UAAU;;IAEV;MACE,eAAe;MACf,iBAAiB;MACjB,mBAAmB;IACrB;IACA;MACE,SAAS;MACT,QAAQ;IACV;IACA;MACE,0BAA0B;MAC1B,kBAAkB;IACpB;IACA;MACE,UAAU;IACZ;IACA;MACE,WAAW;IACb;AACJ;EACE,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;;GAEG;AACH;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,2BAA2B;GAC1B,+BAA+B;GAC/B,gCAAgC;EACjC,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;AAEA,0BAA0B;AAC1B;EACE;IACE,YAAY;EACd;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;;;;;;yBAMuB;AACzB;;;AAGA;EACE;IACE,cAAc;EAChB;EACA;;;KAGG;EACH;IACE,YAAY;EACd;EACA;;KAEG;EACH;;KAEG;;EAEH;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;;;EAGA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;;KAEG;IACD;MACE,8BAA8B;IAChC;IACA;MACE,8BAA8B;IAChC;IACA;MACE,8BAA8B;IAChC;IACA;MACE;IACF;IACA;MACE,YAAY;IACd;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,YAAY;EAChB;IACE;MACE,eAAe;IACjB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,cAAc;IAChB;IACA;MACE,kBAAkB;EACtB;EACA;IACE,YAAY;IACZ;IACA;MACE,wBAAwB;IAC1B;KACC;MACC,aAAa;MACb,YAAY;AAClB;AACA;;GAEG;;AAEH;EACE,YAAY;;AAEd;AACA;EACE,SAAS;;AAEX;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;GAEG;AACH;;GAEG;AACH;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;AAChC;AACA;EACE;AACF;;;AAGA;;AAEA;;;;GAIG;;AAEH;EACE;;KAEG;EACH;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;AACjC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA","sourcesContent":["li {\r\n  font-size: 14px;\r\n}\r\n.banner-container{\r\n  -webkit-background-size: cover;\r\n  -moz-background-size: cover;\r\n  -o-background-size: cover;\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.home-sec-2 .title1, .home-sec-3 h1,.home-sec-4 h2,\r\n  .row.sec-title .yellow-line, .blog-sec-2 h2, .blog-sec-4 h2,\r\n  .contact-section-2 h1{\r\n    font-size: 40px !important;\r\n    line-height: 46px !important;\r\n  }\r\n.home-sec-1 .logo-video{\r\n  padding-left: 2rem;\r\n  width: 80%;\r\n  height: auto;\r\n}\r\n\r\n\r\n\r\n\r\n.banner-logos{\r\n  position: relative;\r\n  top: 1rem;\r\n}\r\n.banner .banner-container {\r\n  transition: opacity 3s ease-in-out;\r\n}\r\n.banner .slick-slide{\r\n  opacity: 1;\r\n}\r\n\r\n/* .banner .slick-slide{\r\n  transition: transform 0.5s ease !important; \r\n} */\r\n\r\n.section{\r\n  background: #FAEC24;\r\n  margin-top: 9rem !important;\r\n  /* border-radius: 75px; */\r\n  border-bottom-left-radius: 70px;\r\n  border-bottom-right-radius: 70px;\r\n\r\n  background-repeat: no-repeat;\r\n  width: 75%;\r\n  margin: auto;\r\n  background-position: center center;\r\n  background-size: cover;\r\n  -webkit-backface-visibility: hidden;\r\n  -moz-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n  -webkit-transform: translate3d(0,0,0);\r\n  -moz-transform: translate3d(0,0,0);\r\n  transform: translate3d(0,0,0) ;\r\n  position: relative;\r\n}\r\n.hidden-lg{\r\n  display: none !important;\r\n}\r\n.home-banner-container{\r\n  -webkit-background-size: cover;\r\n  -moz-background-size: cover;\r\n  -o-background-size: cover;\r\n  background-size: cover;\r\n  padding-bottom: 9rem;\r\n}\r\n.bold{\r\n  font-weight: bold;\r\n}\r\n.timeline{\r\n  /* margin-top: 18rem; */\r\n  height:180px;\r\n}\r\n.timeline{\r\n  display: flex; \r\n  flex-direction: column; \r\n  justify-content: baseline;\r\n  position: relative;\r\n  top: 2rem;\r\n}\r\n.background{\r\n  background-image:linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);\r\n}\r\n.banner .slick-prev::before, .banner .slick-next::before{\r\n  display: none !important;\r\n}\r\n.banner .slick-arrow.slick-next, .blog-sec-4 .slick-arrow.slick-next, .admedia-sec-4 .slick-arrow.slick-next{\r\n  display: none !important;\r\n}\r\n.banner.slick-arrow.slick-prev, .blog-sec-4 .slick-arrow.slick-prev, .admedia-sec-4 .slick-arrow.slick-prev{\r\n  display: none !important;\r\n}\r\n.banner{\r\n  min-height: 100vh;\r\n}\r\ninput .input-box:focus{border:2px solid #FAEC24 !important;}\r\n.banner h1{\r\n  color: #FFF;\r\n  font-family: Poppins;\r\n  font-size: 50px !important;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 48px;\r\n  letter-spacing: -0.8px;\r\n  text-transform: uppercase;\r\n  text-align: left;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.home-sec-4 {\r\n  padding-top: 6rem;\r\n  padding-bottom: 6rem;\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n\r\n.banner .first-slide{\r\n  color: #ffffff;\r\n  font-weight: 700;\r\n  /* font-size: 43px; */\r\n  \r\n}\r\n.banner .first-slide svg{\r\n  vertical-align: baseline;\r\n  position: relative;\r\n  left: 5px;\r\n  top: 5px;\r\n  height: 100%;\r\n}\r\n\r\n.banner .bold{\r\n  font-weight: 500 !important;\r\n}\r\n.banner h1 span{\r\n  color:#FFF;\r\n  font-weight: 700;\r\n}\r\n.banner p{\r\n  color: #FFF;\r\n  font-family: Poppins;\r\n  font-size: 17px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 27px;\r\n  text-align: left;\r\n  max-width: 82%;\r\n}\r\n.banner-timeline{\r\n  margin-left: 4.4rem;\r\n}\r\n.line{\r\n  border-top: 1px solid white;\r\n  margin-top: 15px;\r\n  width: 6rem;\r\n  justify-content: end;\r\n}\r\n.banner-timeline .row h4{\r\n  font-family: Bebas Neue;\r\n  font-size: 25px;\r\n  font-weight: 400;\r\n  line-height: 22px;\r\n  letter-spacing: 0em;\r\n  color:#9F9F9F;\r\n  justify-content: center;\r\n}\r\n.banner-timeline .row.active h4{\r\n  color:#fff;\r\n  font-size: 35px;\r\n  line-height: 30px;\r\n  width: 10px;\r\n  height: 30px;\r\n}\r\n.yellow-line{\r\n  position: relative;\r\n  width: -moz-fit-content;\r\n  width: fit-content;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.home-sec-1{\r\n  height: fit-content;\r\n  /* margin-bottom: 3rem; */\r\n}\r\n.home-sec-1 h1{\r\n  font-family: Poppins;\r\n  font-weight: 400;\r\n  font-size: 60px;\r\n  text-align: center;\r\n}\r\n\r\n.home-sec-1 h1 span{\r\n  color: #FFC700;\r\n  ;\r\n  font-size:100px;\r\n}\r\n/* .logo-arrow{\r\n  position: fixed;\r\n} */\r\n/* .home-container{\r\n  padding-left: 5rem;\r\n} */\r\n.home-sec-2{\r\n  background-color: #fff;\r\n  height: fit-content;\r\n  padding-top: 3rem;\r\n  padding-bottom: 3rem;\r\n  /* padding-left: 5rem; */\r\n  font-family: Poppins;\r\n}\r\n\r\n.home-sec-2 .yellowline {\r\n  height: 4px;\r\n  width: 130px;\r\n  background-color: yellow;\r\n  position: relative;\r\n  top: 2rem;\r\n}\r\n.home-sec-2 .title1{\r\n  position: relative;\r\n  top: 3rem;\r\n  font-size: 38px;\r\n  padding: 0;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.home-sec-3{\r\n  font-family: Poppins;\r\n  color: #000;\r\n}\r\n\r\n.home-sec-3 h1{\r\n  /* max-width: 60%; */\r\n  line-height: 48px;\r\n  font-size: 38px;\r\n  font-weight: 700;\r\n  font-family: Poppins;\r\n  color: #000;\r\n  \r\n}\r\n.home-sec-3 span{\r\n  text-transform: uppercase;\r\n  margin: 1rem 0;\r\n  color: #000;\r\n  \r\n}\r\n.home-sec-3 .theme{\r\n  margin-top: 2rem ;\r\n  margin-bottom: 2rem ;\r\n}\r\n.home-sec-3 .yellowline {\r\n  height: 4px;\r\n  width: 130px;\r\n  background-color: yellow;\r\n  position: relative;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n\r\n.contact-sec.form-section {\r\n  margin-bottom: 8rem; \r\n}\r\n.contact-row-line{\r\n  width: 100%;\r\n  border-bottom: 1px solid #fff4;  \r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.home-sec-3 .frame-icon{\r\n  position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 64px;\r\n    height: 64px;\r\n    opacity: 90%;\r\n}\r\n.home-sec-3 .play-icon{\r\n  margin-top: -7px;\r\n\r\n}\r\n\r\n\r\n/* ========= */\r\n.yellow-line:before{\r\n  content: \"\";\r\n  width:100%;\r\n  max-width: 130px;\r\n  height: 4px;\r\n  background-color: #FAEC24;\r\n  position: absolute;\r\n  top: -15px;\r\n  left: 0;\r\n}\r\n/* .home-sec-2{\r\n  background-color: #fff;\r\n} */\r\n\r\n.home-sec-2 .slick-list{\r\n  height: 550px;\r\n}\r\n.home-sec-2 h4, .home-sec-2 p{\r\n  color: #fff;\r\n  margin-bottom: 0px;\r\n}\r\n.home-sec-2 h4{\r\n  font-weight: 400;\r\n  font-size: 22px;\r\n  line-height: 32px;\r\n}\r\n.home-sec-2 p{\r\n  font-size: 16px;\r\n  font-weight: 300;\r\n  line-height: 27px;\r\n  color: #000;\r\n  text-align: left;\r\n  padding-left: 5px;\r\n}\r\n.home-sec-2 .contactus{\r\n  font-weight: 600;\r\n}\r\n/* .home-sec-2 .slick-next::before,.home-sec-2 .slick-prev::before{\r\n  margin: 0 6rem;\r\n} */\r\n/* .home-sec-2 .slick-next, .home-sec-2 .slick-prev{\r\n  top: -11%;\r\n} */\r\n/* .home-sec-2 .slick-next{\r\n  right: 12rem;\r\n} */\r\n.home-sec-2 .slick-prev{\r\n  position: absolute;\r\n  top: calc(-10% - 20px);\r\n  left: calc( 100% - 6.5rem);\r\n  transform: translateX(-50%); \r\n  font-size: 0;\r\n}\r\n.home-sec-2 .slick-next{\r\n  position: absolute;\r\n  top: calc(-10% - 20px);\r\n  /* left:45%; */\r\n  transform: translateX(-50%); \r\n  font-size: 0;\r\n  right: 1rem;\r\n}\r\n\r\n\r\n/* .home-sec-2 .slick-prev{\r\n  left: calc( 100vw - 380px);\r\n} */\r\n.home-sec-2 .slick-prev::before{\r\n  content: url(../../public/images/app-home/sec2/slick-prev.svg);\r\n}\r\n.home-sec-2 .slick-next::before{\r\n  content: url(../../public/images/app-home/sec2/slick-next-2.svg);\r\n}\r\n\r\n.home-sec-2 .product-card-slider{\r\n  width: 100%;\r\n  padding-top: 0rem;\r\n}\r\n\r\n.home-sec-2 .card{\r\n  width: 300px;\r\n  height: 410px;\r\n  background-size: cover;\r\n  background-position: center;\r\n  position: relative;\r\n  border: none;\r\n  border-radius: 0px;\r\n  margin: 8px;\r\n  margin-top: 46px;\r\n  transition: all ease 0.5s;\r\n  font-family: Poppins;\r\n  text-transform: uppercase;\r\n  color: #000;\r\n  top: 0;\r\n  transition: all 1s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n\r\n.home-sec-2 .card-body{\r\n  position: absolute;\r\n  bottom: 0;\r\n  opacity: 0;\r\n  width: 100%;\r\n  height: fit-content;\r\n  background-color: white;\r\n  padding: 30px 28px 30px 28px; \r\n  box-sizing: border-box;\r\n  text-align: left;\r\n  transition: all 1s ease;\r\n}\r\n\r\n.home-sec-2 .card:hover{\r\n  height: 450px;\r\n  z-index: 2;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  position: relative;\r\n  top: -20px;\r\n  \r\n}\r\n\r\n.home-sec-2 .card:hover .card-body{\r\n  opacity: 1;\r\n  /* height: fit-content; */\r\n  /* padding: 30px 28px 30px 28px;  */\r\n}\r\n/* .home-sec-2 .card-body:hover{\r\n  opacity: 1;\r\n} */\r\n/* .home-sec-2 .slick-slide:hover {\r\n  width: 410px;\r\n  transition: .7s ease;\r\n} */\r\n\r\n/* .home-sec-2 .slide{\r\n  padding-right: 15px;\r\n \r\n} */\r\n\r\n.home-sec-2 .box{\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  /* background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%); */\r\n  align-items: flex-start;\r\n  text-align: left;\r\n  padding: 55px 25px;\r\n  transition: all ease 0.3s;\r\n}\r\n.home-sec-2 .box:hover{\r\n  transform: scale(1.02);\r\n  z-index: 2;\r\n}\r\n.home-sec-2 h2{\r\n  margin-bottom: 40px;\r\n  color: #000;\r\n  font-weight: 700;\r\n}\r\n.home-sec-3{\r\n  height: fit-content;\r\n  margin-top: 7rem;\r\n}\r\n.none{\r\n  transition: all ease 0.3s;\r\n}\r\n/* .none:hover{\r\n  transform: scale(2,1.5);\r\n  z-index: 2;\r\n} */\r\n.home-sec-3 span {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  line-height: 26px;\r\n  letter-spacing: -0.02em;\r\n  text-align: left;\r\n  color:#000000;\r\n}\r\n.home-sec-3 p{\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-weight: 300;\r\n  line-height: 27px;\r\n  letter-spacing: -0.02em;\r\n  text-align: left;\r\n  color:#000000;\r\n}\r\n.home-sec-4 h2{\r\n  text-transform: uppercase;\r\n  text-align: center;\r\n  margin-bottom: 6px;\r\n  font-size: 38px;\r\n  font-weight: 700;\r\n  font-family: Poppins;\r\n}\r\n.home-sec-4>div{\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  height: fit-content;\r\n  width: fit-content;\r\n  justify-content: space-between; \r\n}\r\n.home-sec-4 .card{\r\n  height: 340px;\r\n  width: calc(33.33% - 10px); \r\n  margin: 5px; \r\n  border: none;\r\n  border-radius: 0;\r\n  transition: all ease 0.8s;\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n}\r\n\r\n.home-sec-4 .image-container {\r\n  position: relative;\r\n  width: 101%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  transition: transform 0.8s ease;\r\n  transform-origin: center center;\r\n  \r\n}\r\n\r\n.home-sec-4 .card .image-container:hover {\r\n  transform: scale(1.05);\r\n}\r\n.home-sec-4 .card:last-child .image-container:hover {\r\n  transform: none;\r\n}\r\n\r\n\r\n.home-sec-4 .card .box{\r\n  height: 100%;\r\n  width: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  padding: 30px 28px;\r\n  transition: ease 0.4s;\r\n  position: absolute;\r\n  \r\n  \r\n\r\n}\r\n/* .home-sec-4 .card:nth-child(8) .box{\r\n  opacity: 0.83;\r\n  background: linear-gradient(180deg, #FAEC24 0%, #000 100%);\r\n} */\r\n.home-sec-4 .yellow-line:before{\r\n  content: \"\";\r\n  width:100%;\r\n  max-width: 125px;\r\n  height: 4px;\r\n  background-color: #FAEC24;\r\n  position: absolute;\r\n  top: -15px;\r\n  left: calc( 50% - 62px );\r\n}\r\n.home-sec-4 h4{\r\n  color: #FFF;\r\n  margin: 0;\r\n  font-size: 34px;\r\n  line-height: 46px;\r\n}\r\n.home-sec-4 .card .line{\r\n  position: absolute;\r\n  top: 55%;\r\n  left: 34%;\r\n  width:0px;\r\n  border-top: 5px #fff solid;\r\n  transform: translateX( -50%, 50% );\r\n  transition: width 0.5s ease;\r\n  transform-origin:  left;\r\n}\r\n\r\n.home-sec-4 .card:last-child .box{\r\n  background: linear-gradient(180deg, #00000070 0%, #00000060 100%);\r\n  transition: all 0.5s ease;\r\n}\r\n.home-sec-4 .card:last-child .box:hover {\r\n  \r\n  background: linear-gradient(180deg, #0000009b 0%, #000000b6 100%);\r\n}\r\n.home-sec-4 .card:last-child .box:hover div{\r\n  cursor: pointer;\r\n}\r\n\r\n.home-sec-4 .card:last-child .box:hover .line{\r\n  width: 120px;\r\n  \r\n}\r\n\r\n\r\n.home-sec-5{\r\nmin-height: fit-content;\r\nbackground: #fff;\r\n/* padding-left: 3rem; */\r\n}\r\n.home-sec-5 .scroller{\r\n  height: 395px;\r\n  overflow-y: scroll;\r\n}\r\n::-webkit-scrollbar {\r\n  width: 3px;\r\n  height: 5px;\r\n  display: none;\r\n}\r\n::-webkit-scrollbar-track {\r\n  background: black\r\n  \r\n}\r\n::-webkit-scrollbar-thumb {\r\n  background: #888888cb;\r\n\r\n}\r\n::-webkit-scrollbar-thumb:hover {\r\n  display: contents;\r\n}\r\n.home-sec-5 .strip{\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  height: 79px;\r\n  transition: all 0.5s ease;\r\n\r\n}\r\n.home-sec-5 .seg1{\r\n  width: 15%;\r\n  text-align: left;\r\n  transition: all 0.5s ease;\r\n}\r\n.home-sec-5 .seg2{\r\n  width: 80%;\r\n  line-height: 50px;\r\n  transition: all 0.5s ease;\r\n}\r\n.home-sec-5 .seg3{\r\n  width: 18%;\r\n  transition: all 0.5s ease;\r\n}\r\n.home-sec-5 span{\r\n  font-family: Poppins;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n  line-height: 20px;\r\n  letter-spacing: -0.02em;\r\n  text-align: left;\r\n  color: #fff; \r\n  transition: all 0.5s ease;\r\n}\r\n.home-sec-5 button{\r\n  font-family: Poppins;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  line-height: 26px;\r\n  letter-spacing: -0.02em;\r\n  text-align: right;\r\n  color: #FAEC24;\r\n}\r\n.home-sec-5 .strip.active span, .home-sec-5 .strip.active button{\r\n  opacity: 100%;\r\n}\r\n.home-sec-5 .strip.active1 span, .home-sec-5 .strip.active1 button{\r\n  opacity: 30%;\r\n}\r\n.home-sec-5 .strip.active2 span, .home-sec-5 .strip.active2 button{\r\n  opacity: 15%;\r\n}\r\n.home-sec-5 button{\r\n  font-family: Poppins;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n  line-height: 26px;\r\n  letter-spacing: -0.02em;\r\n  text-align: right;\r\n  color: #FAEC24;\r\n}\r\n.home-sec-5 button:hover, .home-sec-5 button:focus {\r\n  color: #a19705;\r\n}\r\n.home-sec-6 p {\r\n  color: #f6f6f6;\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 22px;\r\n  letter-spacing: 0em;\r\n  text-align: center;\r\n  max-width: 60%;\r\n}\r\n.button{\r\n  background-color: white;\r\n  padding:10px 25px;\r\n}\r\n.home-sec-6 h1 span {\r\n color: #FAEC24;\r\n}\r\n.simple-slider {\r\n  height: 350px;\r\n}\r\n.simple-slider .slide {\r\n  padding: 40px 25px;\r\n  border: 1px solid #191919;\r\n  height: 250px;\r\n}\r\n.simple-slider h4 {\r\n  font-weight: 700;\r\n  width: 200px;\r\n}\r\n.home-sec-3 .box{\r\n  width: 100%;\r\n  height: 96%;\r\n}\r\n\r\n.frame-icon{\r\n  position: relative;\r\n  top: 50%;\r\n  z-index: 10;\r\n  left: 1%;\r\n  opacity: 60%;\r\n}\r\n/* Thumbnail image  */\r\n\r\n.about-banner-container, .blog-banner-container ,\r\n.ad-media-banner-container,.blogRead-banner-container {\r\n  background-image: url(../../public/images/about/banner.png);\r\n\r\n  /* Full height */\r\n  height: 100vh; \r\n  /* Create the parallax scrolling effect */\r\n  background-attachment: fixed;\r\n  background-position:bottom;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  position: relative;\r\n  /* transition: background-size 0.3s ease; */\r\n}\r\n.banner h1{\r\n  line-height: 62px;\r\n  font-weight: 700;\r\n  \r\n}\r\n.blog-banner-container .banner h1 span{\r\n  color: #FAEC24;\r\n}\r\n.about-banner-container .banner{\r\n  height: 100%;\r\n  position: relative;\r\n}\r\n\r\n.blog-banner-container{\r\n  background-image: url(../../public/images/blog/banner.png);\r\n}\r\n\r\n.ad-media-banner-container{\r\n  background-image: url(../../public/images/admedia/banner.png);\r\n  padding: 0;\r\n}\r\n.blogRead-banner-container {\r\n  background-image: url(../../public/images/blog_read/Banner.png);\r\n  height: 570px;\r\n  background-attachment: fixed;\r\n  background-position:bottom;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  position: relative;\r\n}\r\n\r\n.ad-media-banner-container .parallax-img{\r\n  margin-right:0;\r\n  height: 100vh;\r\n}\r\n.ad-media-banner-container .banner{\r\n  padding: 0;\r\n  margin: 0;\r\n  min-width: 100%;\r\n}\r\n.ad-media-banner-container .text-overlay {\r\n  width: 75%;\r\n  padding-left: 4rem;\r\n}\r\n.ad-media-banner-container .banner p {\r\n  max-width: 77%;\r\n}\r\n\r\n\r\n.parallax-img{\r\n  max-width: 100%;\r\n  height:100%;\r\n  margin-right: 20px;\r\n  position: relative;\r\n  align-self: flex-end\r\n}\r\n\r\n.blog-banner-container .text-overlay{\r\n  width: 75%;\r\n}\r\n\r\n.text-overlay {\r\n  position: absolute;\r\n  top: 40%;\r\n  left: 0%;\r\n  width: 50%;\r\n  text-align: center;\r\n  color: white;\r\n  z-index: 2;\r\n}\r\n\r\n.text-overlay h1 {\r\n  font-size: 24px;\r\n  /* margin: 0; */\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n\r\n\r\n\r\n.about-section-2{\r\n  padding-top: 5rem;\r\n  padding-bottom: 5rem;\r\n  height: fit-content;\r\n  background: #fff;\r\n  text-align: left;\r\n}\r\n\r\n\r\n.thumbnail{\r\n  border-radius: 0px;\r\n}\r\n.about-img{\r\n  border-radius: 10px;\r\n}\r\n\r\n.destination-sec-5 .about-exp{\r\n  padding-bottom: 30px;\r\n}\r\n\r\n\r\n.destination-banner-container{\r\n  -webkit-background-size: cover;\r\n  -moz-background-size: cover;\r\n  -o-background-size: cover;\r\n  background-size: cover;\r\n}\r\n.destination-banner{\r\n  min-height: 100vh;\r\n}\r\n  .destination-banner h1{\r\n    color: #FFF;\r\n    font-family: Poppins;\r\n    font-size: 40px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 48px;\r\n    letter-spacing: -0.8px;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n  }\r\n  .destination-banner h1 span{\r\n    color:#FAEC24;\r\n    font-size: 60px;\r\n    font-weight: 500;\r\n  }\r\n  .asia .col-lg-7{\r\n    width: 51%;\r\n  }\r\n  .africa .col-lg-7{\r\n    width: 53%;\r\n  }\r\n  .europe .col-lg-7{\r\n    width: 57%;\r\n  }\r\n  .p{\r\n    max-width: 100% !important;\r\n    margin-top: 0.25rem;\r\n  }\r\n  .destination-banner p{\r\n    color: #FFF;\r\n    font-family: Poppins;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 27px;\r\n    text-align: left;\r\n    max-width: 82%;\r\n  }\r\n  #dropdown-btn{\r\n    padding: 6px 27px;\r\n    font-family: Montserrat;\r\n    font-size: 15px;\r\n    font-style: italic;\r\n    font-weight: 500;\r\n    position: relative;\r\n    display: inline-block;\r\n    background: #FAEC24;\r\n    color: #000;\r\n    border: none;\r\n    border-radius: 20px;\r\n    cursor: pointer;\r\n  }\r\n  .dropdown-item{\r\n    color: white;\r\n    text-align: center;\r\n    line-height: 30px;\r\n    font-weight: 500;\r\n  }\r\n  .dropdown-item:hover{\r\n    background: #000000;\r\n    color: white;\r\n  }\r\n  .dropdown-menu{\r\n    background-color:black;\r\n    padding:5px 35px ;\r\n   margin-left: 8px;\r\n  }\r\n.destination-banner .col-lg-5{\r\n  width: 34.6667%;\r\n  }\r\n.destination-sec-2{\r\n  height: 100vh;\r\n}\r\n.destination-sec-2 p{\r\n  font-family: Poppins;\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  line-height: 25px;\r\n  letter-spacing: -0.02em;\r\n  text-align: left;\r\n  color:#fff;\r\n}\r\n.destination-sec-2 h1{\r\n  max-width: 48%;\r\n  line-height: 2.9rem;\r\n  text-align: center;\r\n  font-size: 38px;\r\n  font-weight: 400;\r\n}\r\n.destination-sec-2 .yellow-line:before{\r\n  content: \"\";\r\n  width:100%;\r\n  max-width: 130px;\r\n  height: 4px;\r\n  background-color: #FAEC24;\r\n  position: absolute;\r\n  top: -12px;\r\n  left: calc( 50% - 65px );\r\n}\r\n.destination-sec-3 p{\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  line-height: 20px;\r\n  letter-spacing: -0.02em;\r\n  text-align: left;\r\n  color:#fff;\r\n  margin-bottom: 3px;\r\n}\r\n.destination-sec-3 h1{\r\n  line-height: 3rem;\r\n  text-align: left;\r\n  font-size: 38px;\r\n  font-weight: 400;\r\n}\r\n.destination-sec-3 .yellow-line:before{\r\n  content: \"\";\r\n  width:100%;\r\n  max-width: 130px;\r\n  height: 4px;\r\n  background-color: #FAEC24;\r\n  position: absolute;\r\n  top: -15px;\r\n  left: 0%;\r\n}\r\n.destination-sec-3 .card{\r\n  border: none;\r\n  border-radius: 10px;\r\n  position: relative;\r\n  top: -38%;\r\n  transition:all ease 0.3s;\r\n}\r\n/* .destination-sec-3 .card:hover{\r\n  transform: scale(0.98);\r\n  z-index: 2;\r\n} */\r\n/* .destination-sec-3 .card .box:hover{\r\n  transform: scale(1);\r\n  z-index: 2; */\r\n/* } */\r\n\r\n.destination-sec-3.discover .card:hover{\r\n  height: 350px;\r\n  transition: all ease 0.6s;\r\n}\r\n\r\n\r\n\r\n.destination-sec-3 .card .box{\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  background: linear-gradient(182deg, rgba(0, 0, 0, 0.00) 20.68%, #000000 99%);\r\n  align-items: flex-start;\r\n  text-align: left;\r\n  padding: 40px 18px;\r\n  transition: all ease 0.3s;\r\n  /* border-radius: 10px; */\r\n}\r\n.destination-sec-3 .card{\r\n  height: 320px;\r\n   width:280px;\r\n   margin-top: 40%;\r\n   transition: all ease 0.6s;\r\n}\r\n.destination-sec-3 .card-1{\r\n  height: 320px;\r\n  width:270px;\r\n  margin-left:0px;\r\n}\r\n.destination-sec-3 .card:nth-child(8) .box{\r\n  opacity: 0.83;\r\n  background: linear-gradient(180deg, #FAEC24 0%, #000 100%);\r\n}\r\n.destination-sec-3 .disc-h4{\r\n  margin-bottom: 0px;\r\n}\r\n.destination-sec-3 h4{\r\n  color: #FFF;\r\n  text-align: left;\r\n  font-family: Poppins;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 24px;\r\n  margin-bottom: 3px;\r\n  letter-spacing: -0.5px;\r\n  text-transform: uppercase;\r\n}\r\n.destination-sec-4 h1{\r\n  line-height: 2.5rem;\r\n  text-align: left;\r\n  font-size: 28px;\r\n  margin-left: 20px;\r\n}\r\n.destination-sec-4 p{\r\n  font-family: Poppins;\r\n  font-size: 18px;\r\n  font-weight: 300;\r\n  line-height: 25px;\r\n  letter-spacing: -0.02em;\r\n  text-align: center;\r\n  color:#fff;\r\n}\r\n.destination-sec-5 h1{\r\n  max-width: 55%;\r\n  line-height: 2.9rem;\r\n  text-align: center;\r\n  font-weight: 400;\r\n  font-size: 38px;\r\n}\r\n.destination-sec-5 .yellow-line:before{\r\n  content: \"\";\r\n  width:100%;\r\n  max-width: 130px;\r\n  height: 4px;\r\n  background-color: #FAEC24;\r\n  position: absolute;\r\n  top: -15px;\r\n  left: calc( 50% - 65px );\r\n}\r\n.destination-sec-5 h4{\r\n  color: #fff;\r\n  line-height: 24px;\r\n  margin-bottom: 0px;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n.destination-sec-5 p{\r\n  color: #fff;\r\n  margin-top: 3px;\r\n}\r\n.destination-sec-5 .card{\r\n  border: none;\r\n  margin: auto;\r\n  border-radius: 10px;\r\n  height: fit-content;\r\n  width: 88%;\r\n  transition: ease 0.5s;\r\n  height: 468px;\r\n}\r\n\r\n\r\n/* .destination-sec-5 .slide:hover :not(:hover) .card{\r\n  width: 80%;\r\n  transform: scale(1);\r\n} */\r\n\r\n.destination-sec-5 .title-1{\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.destination-sec-5 .me-title{\r\n  margin-top: -4rem;\r\n}\r\n\r\n\r\n\r\n\r\n/* .destination-sec-5 .slide-container:hover .slick-slide{\r\n  width: 800px;\r\n} */\r\n/* .transform-card-in:hover{\r\n  transform: scale(.94);\r\n\r\n} */\r\n\r\n\r\n/* SLIDER */\r\n/* .destination-sec-5 .slide{\r\n  background-color: red;\r\n  height: 240px;\r\n  border: 2px solid #000;\r\n  width: 200px !important;\r\n}\r\n\r\n.destination-sec-5 .slide:hover {\r\n  background-color: yellow;\r\n  width: 220px !important;\r\n\r\n} */\r\n\r\n.scroll-top span{\r\n  color: #fff;\r\n  font-size: 11px;\r\n  font-weight: 300;\r\n  font-family: Montserrat;\r\n }\r\n .scroll-top .scroll-top-btn{\r\n  margin-bottom: -2.5rem ;\r\n }\r\n\r\n.destination-sec-5 .slide-container1 .slick-current  {\r\n  width: 500px !important;\r\n}\r\n\r\n.destination-sec-5 .slide-container1{\r\n  border: 2px red;\r\n}\r\n\r\n\r\n\r\n\r\n.destination-sec-5 .slide-container{\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n.destination-sec-5 .row{\r\n  max-width: 92%;\r\n  margin: auto;\r\n}\r\n.destination-sec-5 .slick-next::before,.destination-sec-5 .slick-prev::before{\r\n  display: none;\r\n}\r\n.destination-sec-5 .box{\r\n  height: 100%;\r\n  width:100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000000 100%);\r\n  align-items: flex-start;\r\n  text-align: left;\r\n  padding: 40px 28px;\r\n  border: none;\r\n  /* border-radius: 10px; */\r\n  transition:ease 0.3s;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n\r\n/* other button 01 */\r\n\r\n.form-section  .other01-btn {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  border: 2px solid #000;\r\n  transition: all ease .7s !important;\r\n}\r\n\r\n.form-section  .other01-btn:hover {\r\n  background: #FAEC24;\r\n  color: #000000;\r\n  border-color: #FAEC24; \r\n  transition: all ease .5s;\r\n}\r\n\r\n.form-section .other01-btn:active {\r\n  background: black;\r\n  color: white;\r\n  border-color: transparent; \r\n}\r\n\r\n.form-section .other01-btn:disabled {\r\n  background: #ECE9E9;\r\n  color: #9F9F9F;\r\n  border-color: transparent; \r\n}\r\n\r\n\r\n\r\n.travel-btn, .button {\r\n  font-family: Poppins;\r\n  border-radius: 0px;\r\n  font-size: 16px;\r\n  margin-right: 10px !important;\r\n  font-weight: 400;\r\n  /* max-height: 42px; */\r\n  border: 2px solid transparent;\r\n  transition: all ease .7s !important;\r\n  padding: 10px 65px 10px 65px;\r\n}\r\n\r\n.travel-btn:hover {\r\n  background: #000000;\r\n  color: #FAEC24;\r\n  border-color: #FAEC24; \r\n  transition: all ease .5s;\r\n}\r\n\r\n.travel-btn:active {\r\n  background-color: #FAEC24 !important;\r\n  color: rgb(0, 0, 0) !important;\r\n  border-color: #FAEC24;  \r\n}\r\n\r\n.travel-btn:disabled {\r\n  background: #ECE9E9;\r\n  color: #9F9F9F;\r\n  border-color: transparent; \r\n}\r\n\r\nbutton{\r\n  font-weight: 100;\r\n}\r\n/* contact button */\r\n.contact-btn {\r\n  border-radius: 0px;\r\n  font-family: Poppins;\r\n  font-weight: 400;\r\n  /* max-height: 42px; */\r\n  font-size: 16px;\r\n  background: #000000 !important;\r\n  border: 2px solid white;\r\n  color: #fff;\r\n  padding: 10px 44px;\r\n  transition: all ease .7s !important;\r\n}\r\n.contact-btn:hover{\r\n  background: #FAEC24 !important;\r\n  border-color: #FAEC24; \r\n  color: #000;\r\n  }\r\n.contact-btn:active{\r\n  background: #000000 !important;\r\n  color: #FAEC24 !important;\r\n  border: 2px solid #FAEC24 !important;\r\n  transition: all ease .5s;\r\n} \r\n.contact-btn:disabled {\r\n  background: #ECE9E9 !important;\r\n  color: #9F9F9F !important;\r\n  border-color: none !important;\r\n  transition: all ease .5s !important;\r\n}\r\n\r\n\r\n .home-sec-6 .button{\r\n  padding: 10px 15px 10px 15px;\r\n  font-weight: 600;\r\n }\r\n.contact{\r\n  padding: 8px 25px;\r\n  color: #000;\r\n  font-family: Montserrat;\r\n  font-size: 16px;\r\n  font-style: italic;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  letter-spacing: -0.36px;\r\n}\r\n\r\n/* .dest-contact{\r\n  padding: 8px 25px;\r\n  background-color: #CAC251  ;\r\n  color: #000;\r\n  font-family: Montserrat;\r\n  font-size: 16px;\r\n  font-style: italic;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  letter-spacing: -0.36px;\r\n  border: none;\r\n}\r\n.dest-contact:hover{\r\n  background-color: #CAC251  ;\r\n  color: #000;\r\n  border: none;\r\n \r\n} */\r\n\r\n/* detination-contact button */\r\n\r\n.dest-contact {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  background-color: #CAC251;\r\n  border: 2px solid transparent;\r\n  transition: all ease .8s !important;\r\n  padding-right: 3px;\r\n  padding-left: 15px;\r\n  padding-top: 5px;\r\n  padding-bottom: 4px;\r\n}\r\n.dest-contact .arrow-icon{\r\n  margin-left: 8px;\r\n}\r\n\r\n.dest-contact:hover {\r\n  background: #000000;\r\n  color: #CAC251 !important;\r\n  border-color: #CAC251 !important; \r\n  transition: all ease .8s;\r\n}\r\n\r\n.dest-contact:hover svg path{\r\n  stroke: #CAC251 !important;\r\n  transition: all ease .5s;\r\n}\r\n\r\n.dest-contact:active {\r\n  background: black !important;\r\n  color: white !important;\r\n  border-color: black !important;\r\n}\r\n.dest-contact:active svg path{\r\n  stroke: #ffff !important;\r\n  transition: all ease .5s;\r\n}\r\n\r\n.dest-contact:disabled {\r\n  background: #ECE9E9;\r\n  color: #9F9F9F;\r\n  border-color: transparent; \r\n}\r\n\r\n.dest-contact:disabled svg path{\r\n  stroke: #9F9F9F !important;\r\n  transition: all ease .5s;\r\n}\r\n\r\n\r\n\r\n\r\n/* Blog */\r\n\r\n.blog,.shop{\r\n  background-color: white;\r\n}\r\n.blog-banner-container{\r\n  -webkit-background-size: cover;\r\n  -moz-background-size: cover;\r\n  -o-background-size: cover;\r\n  background-size: cover;\r\n}\r\n.blog-banner{\r\n  min-height: 100vh;\r\n}\r\n  .blog-banner h1{\r\n    color: #FFF;\r\n    font-family: Poppins;\r\n    font-size: 40px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 48px;\r\n    letter-spacing: -0.8px;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n  }\r\n  .blog-banner h1 span{\r\n    color:#FAEC24;\r\n    font-size: 40px;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .blog-banner h1 span:after {\r\n    content: '.';\r\n    color: #FFF; \r\n    margin-left: 5px; \r\n}\r\n  .blog-banner p{\r\n    color: #FFF;\r\n    font-family: Poppins;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 27px;\r\n    text-align: left;\r\n    max-width:84%;\r\n  }\r\n  .blog-banner .btn-primary{\r\n    padding: 6px 30px;\r\n    font-family: Montserrat;\r\n    font-size: 17px;\r\n    font-style: italic;\r\n    font-weight: 500;\r\n  }\r\n  .blog-sec-2{\r\n    background-color: white;\r\n    \r\n  }\r\n  \r\n.blog-sec-2 h2{\r\n  color: #000000;\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n}\r\n.blog-sec-2 h5{\r\n  text-align: left;\r\n  color: #D3C61A;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 25px;\r\n}\r\n .blog-sec-2 span:hover{\r\n  color:  #d3c61a;\r\n  cursor: pointer;\r\n}\r\n.blog-sec-2 h5:hover{\r\n  color: #495057;\r\n  cursor: pointer;\r\n}\r\n.blog-sec-2 span{\r\n  color: #495057;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 25px; \r\n  text-align: left;\r\n  margin: 20px;\r\n}\r\n.blog-sec-2 .card{\r\n  border: none;\r\n  transition: all ease 0.2s;\r\n}\r\n.blog-sec-2 .tag{\r\n  position: absolute;\r\n  top: 4%;\r\n  left: 71%;\r\n  border-radius: 8px;\r\n  background: rgba(255, 255, 255, 0.20);\r\n}\r\n.blog-sec-2 .tag h2{\r\n  color: #FFF;\r\n  text-align: center;\r\n  font-family: Roboto;\r\n  font-size: 11px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 2px;\r\n  padding: 11px 12px 10px;\r\n  margin-bottom: 0;\r\n}\r\n.blog-sec-2 .box{\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  align-items: flex-start;\r\n  text-align: left;\r\n  transition: all ease 0.2s;\r\n}\r\n.blog-sec-2 img{\r\n  width: 400px;\r\n  height: 350px;\r\n}\r\n.checkout-sec-3 .radio{\r\nmargin-top: 1.8rem;\r\n}\r\n.blog-sec-2 .card{\r\n  height: 500px;\r\n  margin-bottom: 3rem;\r\n}\r\n.blog-sec-2 h6{\r\n  color: #6C757D;\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  margin-top: 15px;\r\n}\r\nhr.solid-small {\r\n  border-top: 2px solid white;\r\n  width: 5%;\r\n  opacity: 0.75;\r\n  margin-left: 47.5%;\r\n}\r\n.blog-sec-2 h4{\r\n  color: #000000;\r\n  font-family: Poppins;\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 25px; \r\n  height: 45px;\r\n  margin-bottom: 10px;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.blog-sec-2 p{\r\n  color: #000000;\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 20px; \r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n/* .blog-sec-2 .text-container {\r\n  width: 80%;\r\n  margin: 50px auto;\r\n  text-align: center;\r\n} */\r\n/* .blog-sec-2 .adventure-text {\r\n  \r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n} */\r\n\r\n.blog-box { \r\n  position: relative;\r\n}\r\n\r\n.blog-box-img {\r\n  transition: transform 0.5s ease;\r\n  width: 400px;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.blog-content{\r\n  padding: 10px;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  height: fit-content;\r\n  overflow: hidden;\r\n  transition: all 0.5s ease;\r\n}\r\n.blog-sec-2 .img-hover-zoom {\r\n  overflow: hidden; \r\n  border-radius: 0px;\r\n  width: 100%;\r\n}\r\n\r\n.blog-content:hover{\r\n  box-shadow:none;\r\n}\r\n\r\n.blog-sec-2 .img-hover-zoom img {\r\n  transition: transform 0.5s ease; \r\n}\r\n\r\n.img-hover-zoom:hover img {\r\n  transform: scale(1.2);\r\n}\r\n\r\n\r\n\r\n.blog-sec-3-banner-container{\r\n  -webkit-background-size: cover;\r\n  -moz-background-size: cover;\r\n  -o-background-size: cover;\r\n  background-size: cover;\r\n}\r\n.blog-sec-3-banner{\r\n  min-height: 100vh;\r\n}\r\n.blog-sec-3-banner h1{\r\n  line-height: 48px;\r\n  font-size: 40px;\r\n  text-align: center;\r\n  font-weight: 700;\r\n  max-width: 60%;\r\n  margin: auto;\r\n}\r\n.blog-sec-3-banner p{\r\n  color: #E5E5E5;\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 27px;\r\n}\r\n.blog-sec-4 .yellow-line:before{\r\n  left: 12px;\r\n}\r\n.blog-sec-4 h2{\r\n  color: #000000;\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n}\r\n.blog-sec-4 h6{\r\n  color: #E5E5E5;\r\n  font-family: Poppins;\r\n  font-size: 13px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n}\r\n.blog-sec-4 h4{\r\n  color: white;\r\n  font-family: Poppins;\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 24px; \r\n  max-width: 70%;\r\n  text-align: left;\r\n  margin-bottom: 5px;\r\n}\r\n.blog-sec-3-banner-container{\r\n  background-position:center;\r\n}\r\n.blog-sec-4 p{\r\n  color: #E5E5E5;\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 18px; \r\n  max-width: 92%;\r\n}\r\n.blog-sec-4 .card{\r\n  border: none;\r\n  margin-right: 25px;\r\n  width: 100%;\r\n}\r\n.blog-sec-4 .box{\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  align-items: flex-start;\r\n  text-align: left;\r\n  padding: 10px 28px;\r\n}\r\n\r\n/* Shop */\r\n\r\n.shop-sec-2 h2{\r\n  color: var(--font-color, #333);\r\n  font-family: Poppins;\r\n  font-size: 32px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: normal;\r\n  text-align: center;\r\n}\r\n.shop-sec-2 h4{\r\n  color: var(--font-color, #333);\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n}\r\n.shop-sec-2 p{\r\n  color: var(--font-color-1, #666);\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 19px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 0px;\r\n}\r\n.shop-sec-2 .card{\r\n  border: none;\r\n}\r\n.shop-sec-2 .box{\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-right: 50px;\r\n}\r\n.shop-sec-2 img{\r\n  height: 450px;\r\n  border-radius: 10px;\r\n  max-width: 100%;\r\n}\r\n.shop-sec-3 h2{\r\n  color: var(--font-color, #333);\r\n  font-family: Poppins;\r\n  font-size: 32px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: normal;\r\n  text-align: center;\r\n}\r\n.shop-sec-3 h6{\r\n  color: var(--color-gray-1, #3A3A3A);\r\n  font-family: Poppins;\r\n  font-size: 24px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 120%; \r\n}\r\n.shop-sec-3 h5{\r\n  color: var(--color-gray-3, #898989);\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 150%; \r\n}\r\n.shop-sec-3 p{\r\n  color: var(--color-gray-1, #3A3A3A);\r\n  font-family: Poppins;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n}\r\n.shop-sec-3 .tag1{\r\n  position: absolute;\r\n  top: 3%;\r\n  left: 73%;\r\n  background: #E97171;\r\n  border-radius: 60px;\r\n}\r\n.shop-sec-3 .tag1 h2{\r\n  color: var(--color-white, #FFF);\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 100%; /* 13px */\r\n  padding: 10px;\r\n  width: 48px;\r\n  margin-bottom: 0;\r\n}\r\n.shop-sec-3 .tag2{\r\n  position: absolute;\r\n  top: 3%;\r\n  left: 73%;\r\n  background: #FAEC24;\r\n  border-radius: 70px;\r\n}\r\n.shop-sec-3 .tag2 h2{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 13px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 150%; /* 21px */\r\n  padding: 12px 8px;\r\n  margin-bottom: 0;\r\n}\r\n.shop-sec-3 .overlay .btn-primary{\r\n  color: #FFF;\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 24px */\r\n  border-radius: 0;\r\n  padding: 20px 5px;\r\n}\r\n.shop-sec-3 .card{\r\n  border: none;\r\n  height: 477px;\r\n  text-align:left ;\r\n  transition:ease 0.2s;\r\n  position: relative;\r\n}\r\n.shop-sec-3 .overlay{\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 95%;\r\n  height: 96%;\r\n  background:#3a3a3abb ;\r\n  opacity: 0;\r\n  transition:all ease 0.3s;\r\n}\r\n.overlay p{\r\n  color: var(--color-white, #FFF);\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 24px */\r\n  text-align: center;\r\n  cursor: pointer;\r\n}\r\n.overlay .btn{\r\n  color: #FFF;\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 24px */\r\n  background: rgba(0, 0, 0, 0.767);\r\n  border: 0.5px solid black;\r\n  padding: 10px 35px;\r\n  border-radius: 0;\r\n}\r\n.overlay .btn:hover{\r\n  border: 0.5px solid white;\r\n}\r\n.shop-sec-3 .card:hover .overlay{\r\n  opacity: 1;\r\n}\r\n.shop-sec-3 .card:hover{\r\n  transform: scale(1.015);\r\n  z-index: 2;\r\n}\r\n.shop-sec-3 .box{\r\n background-color: #F4F5F7;\r\n margin-right: 15px;\r\n}\r\n.shop-sec-3 .title-box{\r\n  padding-left: 15px;\r\n}\r\n.shop-sec-3 .btn-primary{\r\n  border: 2px solid #000;\r\n  background: #FFF;\r\n  color: #000;\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n  padding: 10px 60px;\r\n  border-radius: 0; \r\n  margin-top: 5px;\r\n}\r\n.shop-sec-3 .btn-primary:hover{\r\n  color: #FFF;\r\n  background: #000;\r\n}\r\n.shop-sec-4{\r\n  background-color: #F4F5F7;\r\n}\r\n.shop-sec-4 h1{\r\n  color: var(--color-gray-1, #3A3A3A);\r\n  font-family: Poppins;\r\n  font-size: 40px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 120%;\r\n}\r\n.shop-sec-4 p{\r\n  color: var(--color-gray-2, #616161);\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 150%;\r\n  max-width: 80%;\r\n  text-align: left;\r\n}\r\n.shop-sec-4 .btn-primary{\r\n  border: 2px solid #000;\r\n  color: #FFF;\r\n  background: #000;\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n  padding: 10px 55px;\r\n  border-radius: 0; \r\n}\r\n.filter ,.sort{\r\n  align-items: center !important;\r\n  display: flex;\r\n  margin-bottom: 0rem !important;\r\n}\r\n.shop-sec-4 .btn-primary:hover{\r\n  background: #FFF;\r\n  color: #000;\r\n}\r\n.shop-sec-4 .slick-prev::before{\r\n  display: none;\r\n}\r\n.shop-sec-4 .slick-list{\r\n  height: 470px;\r\n}\r\n.shop-sec-4 .slide{\r\n  transition: ease 0.3s;\r\n}\r\n/* .shop-sec-4 .slide:hover{\r\n  transform: scaleY(1.13) scaleX(1.07);\r\n  z-index: 2;\r\n  margin: 10px 0px 0px;\r\n} */\r\n.shop-sec-4 .slick-next, .shop-sec-4 .slick-prev{\r\n  top: 45%;\r\n}\r\n.shop-sec-4 .slick-arrow.slick-next::before{\r\n  /* content: url(../../public/images/right.svg) !important;\r\n  opacity: 1; */\r\n  display: none;\r\n}\r\n.shop-sec-4 .slick-next{\r\n  left: calc( 100vw - 665px);\r\n}\r\n.shop-sec-4 .card{\r\n  margin: 8px;\r\n  border: none;\r\n  height: 415px;\r\n transition:ease 0.2s;\r\n position: relative;\r\n}\r\n.shop-sec-4 .box{\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  align-items: flex-start;\r\n  text-align: left;\r\n  padding: 30px 18px;\r\n}\r\n.shop-sec-4 .slick-dots li {\r\n  margin: -2px; \r\n  line-height: 30px;\r\n}\r\n.shop-sec-4 .slick-dots li button::before{\r\n  line-height: 35px;\r\n  opacity: 1;\r\n}\r\n.shop-sec-4 .slick-dots li button::before {\r\n  content:url(../../public/images/Ellipse\\ 1.svg) !important;\r\n  margin-top: -2.6rem;\r\n  margin-left: 5.9rem;\r\n}\r\n.shop-sec-4 .slick-dots li.slick-active button::before {\r\ncontent: url(../../public/images/Active.svg) !important;\r\n}\r\n.shop-sec-4 h4{\r\n  color: var(--color-gray-1, #3A3A3A);\r\n  font-family: Poppins;\r\n  font-size: 24px;\r\n  font-style: normal;\r\n  max-width: 77%;\r\n  font-weight: 600;\r\n  line-height: 116%; /* 27.84px */\r\n}\r\n.shop-sec-4 .content-box{\r\n  background: rgba(255, 255, 255, 0.72);\r\n  backdrop-filter: blur(1.5px);\r\n  -webkit-backdrop-filter: blur(1.5px);\r\n  padding: 10px 0px 0px 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: left;\r\n  position: absolute;\r\n  top: 68%;\r\n  left: 8%;\r\n  width: 55%;\r\n  height: 25%;\r\n  opacity: 0;\r\n  transition:all ease 0.3s;\r\n}\r\n.shop-sec-4 .slick-current .content-box{\r\n  opacity: 1;\r\n}\r\n.shop-sec-4 .slick-current .card{\r\n  height: 450px;\r\n  width: 350px;\r\n}\r\n.shop-sec-4 .yellow-box{\r\n  display: none;\r\n}\r\n.shop-sec-4 .slick-current .yellow-box{\r\n  width: 35px;\r\n  height: 33px;\r\n  padding: 5px;\r\n  position: absolute;\r\n  top: 85.8%;\r\n  left: 63%;\r\n  background-color: yellow;\r\n  display: block;\r\n}\r\n/* ShopSub */\r\n\r\n.admedia-card .slidecard{\r\n  width: 360px;\r\n}\r\n.admedia-card{\r\n  overflow-x: 'auto';\r\n}\r\n\r\n\r\n\r\n.shopSub{\r\n  background-color: white;\r\n}\r\n.shopSub-banner-container{\r\n  -webkit-background-size: cover;\r\n  -moz-background-size: cover;\r\n  -o-background-size: cover;\r\n  background-size: cover;\r\n  padding-top: 5rem;\r\n}\r\n.shopSub-banner-container{\r\n  height: 80vh;\r\n}\r\n  .shopSub-banner h1{\r\n    color: #FFF;\r\n    font-family: Poppins;\r\n    font-size: 42px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 2.8rem;\r\n    letter-spacing: -0.8px;\r\n    text-transform: uppercase;\r\n    text-align: center;\r\n  }\r\n  .shopSub-banner h1 span{\r\n    color:#FAEC24;\r\n    font-size: 42px;\r\n    font-weight: 650;\r\n  }\r\n  .shopSub-banner p{\r\n    color: #FFF;\r\n    font-family: Poppins;\r\n    font-size: 17px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: normal;\r\n    text-align: center;\r\n  }\r\n  .shopSub-sec-2, .shopSub-sec-4{\r\n    background-color: #E5E5E5;\r\n  }\r\n  .shopSub-sec-2 .col-1{\r\n    width: 3rem;\r\n  }\r\n  .shopSub-sec-2 .col-2{\r\n    width: 5.5rem;\r\n  }\r\n  .shopSub-sec-2 .col-5{\r\n    width: 43rem;\r\n  }\r\n  #dropdown-toggle1{\r\n    background-color: white;\r\n    padding: 2px;\r\n    width: 7.8rem;\r\n    height: 38px;\r\n    color: #495057;\r\n    border-radius: 0;\r\n    border: transparent\r\n  }\r\n  #dropdown-menu{\r\n    background: white;\r\n    min-width: 5rem;\r\n    color: black;\r\n  }\r\n  #dropdown-menu:hover{\r\n    background:  #ECECEC ;\r\n  }\r\n  .shopSub-sec-2 .dropdown-menu{\r\n    background-color: white;\r\n    min-width: 7.8rem;\r\n    margin-left: 0;\r\n    padding: 5px;\r\n  }\r\n \r\n  .shopSub-sec-4 h6{\r\n    color: #242424;\r\n    font-family: Poppins;\r\n    font-size: 18px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    line-height: 20px;\r\n    text-align: left;\r\n  }\r\n  .shopSub-sec-4 p{\r\n    color: var(--color-gray-3, #898989);\r\n    font-family: Poppins;\r\n    font-size: 13px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 6px; \r\n    text-align: left;\r\n  }\r\n  .shopSub-sec-4 .col-1{\r\n    width: 3.6rem;\r\n    padding: 0;\r\n  }\r\n  .shopSub-sec-4 .col-2{\r\n    width: 14.2rem;\r\n  }\r\n\r\n\r\n/* ShopSub2 */\r\n\r\n\r\n.shopSub2-sec-2{\r\n  background-color: #E5E5E5;\r\n  margin-top:7.5rem ;\r\n}\r\n.shopSub2-sec-2 p{\r\n  color: #6C757D;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  margin-top: 3px;\r\n}\r\n.shopSub2-sec-2 h5{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  text-align: left;\r\n  line-height: normal;\r\n  margin-top: 5px;\r\n}\r\n.shopSub2-sec-2 .col-2{\r\n  width: 8rem;\r\n}\r\n.shopSub2-sec-4{\r\n  background-color: white;\r\n}\r\n.shopSub2-sec-4 .card{\r\n  background-color: #D9D9D9;\r\n  justify-content: center;\r\n  border: none;\r\n  transition:all ease 0.4s;\r\n}\r\n.shopSub2-sec-4 .card:hover{\r\n  transform: scale(1.3);\r\n  z-index: 2;\r\n}\r\n.shopSub2-sec-4 .col-lg-5{\r\n  border-radius: 10px;\r\n  background: #E5E5E5;\r\n  width: 23rem;\r\n  height: 25rem;\r\n  margin-left: 2rem;\r\n}\r\n.shopSub2-sec-4 h2{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 38px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  text-align: left;\r\n  margin-bottom: 4px;\r\n}\r\n.sofa{\r\n  margin-right: 4rem;\r\n  transition:all ease 0.5s;\r\n}\r\n.sofa:hover{\r\n  transform: scale(1.04);\r\n  z-index: 2;\r\n}\r\n.shopSub2-sec-4 .col-6{\r\n  margin-left: 2rem;\r\n}\r\n.shopSub2-sec-4 h4{\r\n  color: #9F9F9F;\r\n  font-family: Poppins;\r\n  font-size: 24px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n  text-align: left;\r\n  margin-bottom: 4px;\r\n}\r\n.shopSub2-sec-4 .col-2{\r\n  width: 7rem;\r\n}\r\n.shopSub2-sec-4 p{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height:21px;\r\n  text-align: left;\r\n}\r\n.shopSub2-sec-4 .btn-primary{\r\n  border: 2px solid #000;\r\n  color: #FFF;\r\n  background: #000;\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n  padding: 12px 75px;\r\n  border-radius: 0; \r\n}\r\n.shopSub2-sec-4 .btn-primary:hover{\r\n  background: #FFF;\r\n  color: #000;\r\n}\r\n.shopSub2-sec-4 .count {\r\n  width: 100px;\r\n  padding: 0;\r\n  border: 1.5px solid black;\r\n  margin-left: 16px;\r\n  padding-top: 2px;\r\n}\r\n.count input{\r\n  width: 40px;\r\n  border-radius: 0;\r\n  text-align: center;\r\n  font-size: 18px;\r\n  border: none !important;\r\n}\r\n\r\n.count button{\r\n  background: white;\r\n  border: none !important;\r\n  font-size: 20px;\r\n}\r\n/* Cart */\r\n\r\n.cart-1{\r\n  background-color: white;\r\n}\r\n.cart-sec-2-row, .cart-sec-2 .col-lg-4{\r\n  background-color: #E5E5E5;\r\n}\r\n.cart-sec-2 .col-lg-4{\r\n  margin-left: 2.9rem;\r\n  width: 20rem;\r\n}\r\n.cart-sec-2 h3{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n  margin-left: 4.6rem\r\n}\r\n.price{\r\n  margin-left: 5rem !important;\r\n}\r\n.quantity{\r\n  margin-left: 5.7rem !important;\r\n}\r\n.cart-sec-2 h2{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 28px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n}\r\n.cart-sec-2-img{\r\n  border-radius: 10px;\r\n  background: #D9D9D9;\r\n}\r\n.cart-sec-2 img{\r\n  height: 50px;\r\n  max-width: 140px;\r\n  margin-top: 5px;\r\n}\r\n.cart-sec-2 h4{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  text-align: left;\r\n}\r\n.cart-sec-2 .count {\r\n  width: 96px;\r\n  padding: 0;\r\n  border: 1.5px solid black;\r\n  height: 49px;\r\n}\r\n.cart-sec-2 h5{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  text-align: left;\r\n}\r\n.cart-sec-3 h4{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n  margin-bottom: 2rem;\r\n}\r\n.cart-sec-3 h6{\r\n  color: #495057;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  margin-bottom: 1.9rem;\r\n  line-height: normal;\r\n}\r\n.cart-sec-3 h5{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n  margin-left: 1rem;\r\n}\r\n.cart-sec-2 .btn-primary{\r\n  border: 2px solid #000;\r\n  color: #FFF;\r\n  background: #000;\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n  padding: 10px 70px;\r\n  border-radius: 0; \r\n}\r\n.cart-sec-2 .btn-primary:hover{\r\n  background: #FFF;\r\n  color: #000;\r\n}\r\n.cart-sec-2 .col-1{\r\n  height: 60px;\r\n  width: 80px;\r\n}\r\n.cart-sec-2 .box-1 {\r\n  width: 100px;\r\n  padding-top: 6px;\r\n  height: 38px;\r\n  border: 1.5px solid black;\r\n}\r\n\r\n\r\n/* Checkout */\r\n.checkout-sec-2 ,.checkout-sec-3{\r\n  background-color: white;\r\n}\r\n.checkout-sec-2 h1{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 36px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n}\r\n.checkout-sec-3 .form {\r\n  background-color: white;\r\n  color: black;\r\n  width: 455px;\r\n  border-radius: 5px;\r\n  text-align: left;\r\n}\r\n.checkout-sec-3 label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n  text-align: left;\r\n  width: 97%;\r\n}\r\n.checkout-sec-3 .input-box {\r\n  padding: 10px;\r\n  width: 100%;\r\n  height: 3.3rem;\r\n  margin-bottom: 25px;\r\n  border: 1px solid white;\r\n  border-radius: 0px;\r\n  margin-top: 5px;\r\n}\r\n.checkout-sec-3 h3{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 24px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n  margin-left: 3.5rem;\r\n  text-align: center;\r\n}\r\n.checkout-sec-3 h2{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 24px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n}\r\n.checkout-sec-3 h5{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 24px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 4.4rem;\r\n  text-align: center;\r\n  margin-left: 2.7rem;\r\n}\r\n.checkout-sec-3 h4{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  text-align: left;\r\n} \r\n.checkout-sec-3 h6{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height:9px;\r\n  text-align: center;\r\n  margin-top: 2rem;\r\n  margin-left: 3rem;\r\n} \r\n.checkout-sec-3 p{\r\n  color: #9F9F9F;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  text-align: left;\r\n  margin-top: 2rem;\r\n  max-width: 99%;\r\n}\r\n.para{\r\n  max-width: 88% !important;\r\n}\r\n.checkout-sec-3 .btn-primary{\r\n  border: 2px solid #000;\r\n  color: #FFF;\r\n  background: #000;\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n  padding: 10px 70px;\r\n  border-radius: 0; \r\n}\r\n.checkout-sec-3 .btn-primary:hover{\r\n  background: #FFF;\r\n  color: #000;\r\n}\r\n.checkout-sec-3 span{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 13.6px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n}\r\nhr.solid {\r\n  border-top: 2px solid #bbb;\r\n  width: 90%;\r\n}\r\n\r\n.checkout-sec-3 h1{\r\n  color: #6C757D;\r\n  text-align: justify;\r\n  font-family: Poppins;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n}\r\n.checkout-col{\r\n  margin-left: 2rem;\r\n}\r\n.checkout-col-1{\r\n  margin-left: 2rem;\r\n}\r\n.nopage h4 , .nopage h3{\r\n  color: white;\r\n}\r\n.page-not-found{\r\n  height: 105vh;\r\n}\r\n\r\n/* Ad&media */\r\n.admedia-bg{\r\n  background-color: white;\r\n}\r\n.admedia{\r\n  margin-top: 138px;\r\n}\r\n.admedia .banner-container{\r\n  margin-bottom: 0;\r\n}\r\n.admedia-sec-1 h1{\r\n  color: #FFF;\r\nfont-family: Poppins;\r\nfont-size: 40px;\r\nfont-style: normal;\r\nfont-weight: 400;\r\nline-height: 48px; \r\nletter-spacing: -0.8px;\r\ntext-transform: uppercase;\r\ntext-align: left !important;\r\nmargin-bottom: 5px;\r\n}\r\n.admedia-sec-1{\r\n  min-height: 85vh;\r\n}\r\n.admedia-sec-1 h2{\r\n  color: #FAEC24;\r\n  font-family: Poppins;\r\n  font-size: 70px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 48px;\r\n  text-align: left !important;\r\n  letter-spacing: -1.6px;\r\n  text-transform: uppercase;\r\n}\r\n.admedia-sec-1 p{\r\n  color: #FFF;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 27px;\r\n  letter-spacing: -0.36px;\r\n  text-align: left;\r\n  max-width: 80%;\r\n}\r\n.admedia-sec-2 h1{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 32px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 38px;\r\n  letter-spacing: -1px;\r\n  text-transform: uppercase;\r\n  text-align: left;\r\n  margin-bottom: 40px;\r\n}\r\n.admedia-sec-3 p{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 17px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 27px;\r\n  letter-spacing: -0.36px;\r\n  text-align: left;\r\n}\r\n.admedia-sec-3 .card{\r\n  border: none;\r\n  border-radius: 12px;\r\n  position: relative;\r\n}\r\n.admedia-sec-3 .card .box{\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  background: linear-gradient(182deg, rgba(0, 0, 0, 0.00) 20.68%, #000000e0 99%);\r\n  align-items: flex-start;\r\n  text-align: left;\r\n  padding: 5px 20px;\r\n  border-radius: 10px;\r\n  transition: 0.2s;\r\n}\r\n.admedia-sec-3 .card{\r\n  height: 340px;\r\n  width:490px;\r\n  margin-left:50px;\r\n  transition:all ease 0.2s;\r\n}\r\n/* .admedia-sec-3 .card:hover{\r\n  transform: scale(1.01);\r\n  z-index: 2;\r\n} */\r\n.admedia-sec-3 h4{\r\n  color: #FFF;\r\n  text-align: left;\r\n  font-family: Poppins;\r\n  font-size: 25px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 0px;\r\n  letter-spacing: -0.5px;\r\n  text-transform: uppercase;\r\n}\r\n.admedia-sec-3 .card p{\r\n  font-family: Poppins;\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n  line-height: 25px;\r\n  letter-spacing: -0.02em;\r\n  text-align: left;\r\n  color:#fff;\r\n}\r\n.admedia-sec-4 .box{\r\n  height:100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);\r\n  align-items: flex-start;\r\n  text-align: left;\r\n  padding: 40px 28px;\r\n  border: none;\r\n  border-radius: 12px;\r\n  transition:ease 0.4s;\r\n}\r\n.admedia-sec-4 h4, .admedia-sec-4 p{\r\n  color: #fff;\r\n  line-height: 0px;\r\n  margin-top: -1.3rem;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n.admedia-sec-4 .card{\r\n  border: none;\r\n  margin: auto;\r\n  border-radius: 12px;\r\n  height: fit-content;\r\n  width: 88%;\r\n  transition: ease 0.5s;\r\n  height: 480px;\r\n}\r\n/* .admedia-sec-4 .slide:hover :not(:hover) .card{\r\n  width: 80%;\r\n} */\r\n\r\n/* .admedia-sec-4 .slide-container:hover .card{\r\n  width: 100%;\r\n} */\r\n.admedia-sec-4 .slide-container{\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n.admedia-sec-4 .row{\r\n  max-width: 89%;\r\n  margin: auto;\r\n}\r\n.admedia-sec-4 .slick-next::before,.admedia-sec-4 .slick-prev::before{\r\n  display: none;\r\n}\r\n.admedia-sec-4 .slick-arrow.slick-next,.admedia-sec-4 .slick-arrow.slick-prev{\r\n  display: none;\r\n}\r\n\r\n/* Gallery */\r\n\r\n.gallery{\r\n  margin-top: 8rem;\r\n}\r\n.gallery-sec-1 h2{\r\n  text-decoration: 2.5px solid transparent underline;\r\n  color: #FFF;\r\n  text-align: center;\r\n  font-family: Montserrat;\r\n  font-size: 11.375px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  text-transform: uppercase;\r\n  text-underline-offset: 5px;\r\n  transition:all ease 1s !important;\r\n}\r\n.gallery-sec-1 h2:hover{\r\n  cursor: default;\r\n  text-decoration: 2.5px solid #FAEC24 underline;\r\n} \r\nhr.gallery-solid {\r\n  border-top: 2px solid #bbb;\r\n  width: 100%;\r\n}\r\n.gallery-sec-2{\r\n  margin: auto;\r\n}\r\n .gallery-sec-2 .row1 img{\r\n  height: 320px;\r\n  max-width: 100%;\r\n}\r\n.gallery-sec-2 .row2 img{\r\n  height: 631px;\r\n  max-width: 100%;\r\n}\r\n.gallery-sec-2 .row3 img{\r\n  height: 302px;\r\n  max-width: 100%;\r\n}\r\n\r\n/* dest-banner */\r\n.dest-contact .contact-arrow{\r\n  position: relative;\r\n  bottom: 1px;\r\n}\r\n\r\n/* Contact */\r\n.contact-sec .select-arrow{\r\n  display: none;\r\n}\r\n\r\n\r\n.contact-sec-1 h1{\r\n  color:#000;\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 40px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 44px;\r\n  letter-spacing: -1px;\r\n  text-transform: uppercase;\r\n  max-width: 60%;\r\n  /* -webkit-animation: color-change 100s infinite alternate;\r\n  animation: color-change 10s infinite; */\r\n}\r\n@-webkit-keyframes color-change{\r\n  0% { color: rgb(20, 11, 11); }\r\n  50% { color: rgba(20, 11, 11, 0.603); }\r\n  100% { color: rgba(20, 11, 11, 0.11); }\r\n}\r\n@keyframes color-change {\r\n  0% { color: rgb(20, 11, 11); }\r\n  50% { color: rgba(20, 11, 11, 0.603); }\r\n  100% { color: rgba(20, 11, 11, 0.11); }\r\n}\r\n.contact-sec-1 .yellow-line:before{\r\n  content: \"\";\r\n  width:100%;\r\n  max-width: 125px;\r\n  height: 4px;\r\n  background-color: #FAEC24;\r\n  position: absolute;\r\n  top: 106%;\r\n  left:calc( 50% - 62px );\r\n  margin-top: 10px;\r\n}\r\n.contact-sec-1 p{\r\n  color:#000;\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 17px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  max-width: 80%;\r\n  margin-bottom: 3.5rem !important;\r\n  margin: auto;\r\n}\r\n.contact-sec-2 h1{\r\n  color: #FFF;\r\n  font-family: Poppins;\r\n  font-size: 35px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  text-transform: capitalize;\r\n  text-align: left !important;\r\n}\r\n.form-section h1{\r\n  color: #FFF;\r\n  font-family: Poppins;\r\n  font-size: 1.9rem;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 10px;\r\n  text-transform: capitalize;\r\n  margin-right: 27%;\r\n  margin-bottom: 3rem;\r\n}\r\n#enquiryForm{\r\n  width: 60%;\r\n  margin-top: 2%;\r\n  color: #E5E5E5;\r\n  font-family: Poppins;\r\n  font-size: 1.25rem;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 175%; /* 2.1875rem */\r\n}\r\n.contact-form input::placeholder{\r\n  color: #E5E5E5 !important;\r\n}\r\n.form-section label{\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  color: #000000;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 175%;\r\n}\r\n.form-control:focus{\r\n  background: rgb(255, 255, 255);\r\n  outline: none;\r\n  box-shadow: none !important;\r\n  border: 1.2px solid  #E5E5E5 !important;\r\n}\r\n.form-select:focus{\r\n  outline: none;\r\n  box-shadow: none !important;\r\n  border: 1.2px solid  #E5E5E5 !important;\r\n}\r\n.form-section input, .form-section textarea, .form-section select{\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: center;\r\n  background-color: rgb(255, 255, 255);\r\n  border-bottom: 1px solid #FFF;\r\n  color: #070707 !important;\r\n  font-family: Poppins;\r\n  font-size: 1.1rem;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 26px; \r\n}\r\n.form-section option,.form-section p {\r\n  background: rgb(255, 255, 255);\r\n  color: #000000;\r\n  font-family: Poppins;\r\n  font-size: 1.1rem;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 200%; /* 2.1875rem */\r\n  border-radius: 0px;\r\n}\r\n#exampleFormControlTextarea1{\r\n  border-radius: 0.1rem !important;\r\n}\r\n.text-danger{\r\n  display: none;\r\n}\r\n.form-section button{\r\n  display: flex;\r\n  width: 8.5rem;\r\n  height: 2.6rem;\r\n  padding: 0.5rem 0.5rem;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* border-radius: 1.5625rem; */\r\n  background: #FFF;\r\n  /* box-shadow: 0px 0px 13px 4px rgba(126, 189, 190, 0.70); */\r\n  color: #000;\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size:17px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 175%; \r\n}\r\n.form-section button:hover{\r\n  background: #FAEC24;\r\n  /* box-shadow: 0px 0px 13px 4px rgba(126, 189, 190, 0.70); */\r\n  color: #000;\r\n}\r\n\r\n/* About */\r\n\r\n.about-sec-2 h1{\r\n  color: #FFF;\r\n  font-family: Poppins;\r\n  font-size: 40px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 44px;\r\n  letter-spacing: -1px;\r\n  text-transform: uppercase;\r\n}\r\n.about-sec-2 .yellow-line:before{\r\n  content: \"\";\r\n  width:100%;\r\n  max-width: 110px;\r\n  height: 4px;\r\n  background-color: #FAEC24;\r\n  position: absolute;\r\n  top: 108%;\r\n  left: 1%;\r\n}\r\n.about-sec-2 p{\r\n  color: #FFF;\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 27px;\r\n  max-width: 106% !important;\r\n  letter-spacing: -0.36px;\r\n  text-align: left !important;\r\n}\r\n.about-sec-2 .col-lg-5{\r\n  width: 44.8%;\r\n}\r\n\r\n.about-sec-2 .about-col-img{\r\n  padding: 0;\r\n\r\n}\r\n\r\n.form-select{\r\n  --bs-form-select-bg-img:url(../../public/images/Polygon.svg) !important;\r\n  \r\n}\r\n/* .form-select:focus{\r\n  --bs-form-select-bg-img:url(../../public/images/Polygon.svg) !important;\r\n} */\r\n\r\n/* BlogRead */\r\n\r\n.blogRead{\r\n  background: white;\r\n  /* margin-top: 130px; */\r\n}\r\n.blogRead-sec-1 .bRead{\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: flex-end;\r\n  flex-direction: column;\r\n\r\n}\r\n\r\n.blogRead-sec-1 h1{\r\n  color:#000;\r\n  text-align: left;\r\n  font-family: Poppins;\r\n  font-size: 52px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 62px;\r\n  letter-spacing: -1px;\r\n  text-transform: uppercase;\r\n  max-width: 95%;\r\n}\r\n.blogRead-sec-1 .yellow-line:before{\r\n  content: \"\";\r\n  width:100%;\r\n  max-width: 125px;\r\n  height: 4px;\r\n  background-color: #FAEC24;\r\n  position: absolute;\r\n  top: 106%;\r\n  left: 43.4%;\r\n}\r\n.blogRead-sec-1 h2{\r\n  color: #9F9F9F;\r\n  text-align: center;\r\n  font-family: Poppins;\r\n  font-size: 17px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n}\r\n.blogRead-sec-1 h3{\r\n  color: #000;\r\n  font-family: Poppins;\r\n  font-size: 22px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 13px;\r\n}\r\n.blogRead-sec-1 span{\r\n  text-decoration-line: underline;\r\n  font-weight: 600 !important;\r\n}\r\n.blogRead-sec-1 p, .blogRead-sec-2 p{\r\n  color:#000;\r\n  text-align: left;\r\n  font-family: Poppins;\r\n  font-size: 17px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  /* max-width: 80%; */\r\n  margin: auto;\r\n}\r\n.blogRead-sec-2 h3{\r\n  color:#000;\r\n  text-align: left !important;\r\n  font-family: Poppins;\r\n  font-size: 30px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 27px;\r\n  letter-spacing: -1px;\r\n  text-transform: uppercase;\r\n}\r\n.blogRead-sec-2 .yellow-line:before{\r\n  content: \"\";\r\n  width:100%;\r\n  max-width: 105px;\r\n  height: 4px;\r\n  background-color: #FAEC24;\r\n  position: absolute;\r\n  top: 106%;\r\n  left: calc( 50% - 55px);\r\n}\r\n  \r\n@media (min-width:768px) and (max-width:992px) {\r\n  .home-sec-2 .title1, .home-sec-3 h1,.home-sec-4 h2,\r\n  .row.sec-title .yellow-line, .blog-sec-2 h2, .blog-sec-4 h2,\r\n  .contact-section-2 h1{\r\n    font-size: 40px !important;\r\n    line-height: 46px !important;\r\n  }\r\n  .form-section .other01-btn ,.home-sec-6 .btn-primary,.home-sec-5 button {\r\n    font-size: 15px !important;\r\n  }\r\n  .banner-content{\r\n    /* margin-top: -40px; */\r\n    width: 68%;\r\n  }\r\n  .banner-container {\r\n    background-position: right center !important; /* Adjust as needed */\r\n}\r\n  .timeline{\r\n    height: 210px;\r\n      margin-top: -4rem;\r\n  }\r\n  /* .banner-container{\r\n    margin-bottom: 100px;\r\n  }  */\r\n  /* .banner{\r\n    min-height: 70vh;\r\n  } */\r\n  .blog-banner-container .banner{\r\n    min-height: 100vh;\r\n  }\r\n  .banner-timeline .row h4 {\r\n    margin-left:1.35rem\r\n  }\r\n    .banner h1{\r\n        font-size: 52px !important; \r\n        line-height: 58px;\r\n        width: 100%;\r\n        margin-bottom: 10px;\r\n    }\r\n    .banner p{\r\n        max-width: 100%;\r\n    }\r\n\r\n    .banner .first-slide svg{\r\n      right: 5px;\r\n      height: 70px;\r\n      width: 100%;\r\n      left: auto;\r\n    }\r\n\r\n    .home-sec-1 .logo-video{\r\n      width: 112%;\r\n    }\r\n    .home-sec-1{\r\n      height: fit-content;\r\n      /* margin-bottom: 3rem; */\r\n    }\r\n    .home-sec-2 {\r\n      padding-top: 3rem;\r\n      /* padding-left: 2rem; */\r\n      padding-bottom: 10rem;\r\n    }\r\n    .home-sec-2 h4{\r\n      line-height: 30px;\r\n  }\r\n    .travel{\r\n      display: none;\r\n    }\r\n    .page-down-btn img{\r\n      max-width: 40px;\r\n    }\r\n    .home-sec-2 .card{\r\n      height: 458px;\r\n      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n      \r\n    }\r\n    .home-sec-2 .card .card-body{\r\n      opacity: 1;\r\n    }\r\n    .home-sec-2 .card:hover{\r\n      top: none;\r\n    }\r\n    .home-sec-2 .card-title{\r\n      font-size: 23px;\r\n      line-height: 34px;\r\n      margin-bottom: 0;\r\n    }\r\n    .home-sec-2 .box{\r\n      padding: 8px 12px;\r\n      max-width: 330px;\r\n      max-height: 440px;\r\n      border-radius: 10px;\r\n      padding: 90px 28px 30px 28px;\r\n    }\r\n   .home-sec-2 p{\r\n    font-size: 16px;\r\n   }\r\n   .home-sec-2 .slick-next::before,.home-sec-2 .slick-prev::before{\r\n    display: block;\r\n  }\r\n  .home-sec-2 .slick-prev,.home-sec-2  .slick-next{\r\n    top: calc(100% );\r\n  }\r\n  .home-sec-2 .slick-prev{\r\n    left: 1rem;\r\n  }\r\n  .home-sec-2 .slick-next{\r\n    left: 6rem;\r\n  }\r\n\r\n\r\n\r\n  .banner-timeline .row.active h4 {\r\n   margin-left: 0rem;\r\n}\r\n  \r\n  .home-sec-2 .col-4, .home-sec-2 .col-lg-4 {\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n  }\r\n  .home-sec-2 .col-8, .home-sec-2 .col-lg-8 {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n  .home-sec-2 .col-8 div, .home-sec-2 .col-lg-8 div {\r\n    height: unset\r\n  }\r\n  .home-sec-3{\r\n    height: fit-content;\r\n    margin-top: 6rem;\r\n    padding: 1rem;\r\n  }\r\n\r\n.home-sec-3 h1{\r\n  max-width: 100%;\r\n  font-size: 32px;\r\n  line-height: 34px;\r\n  margin-bottom: 1rem;\r\n    padding-top: 1rem;\r\n}\r\n\r\n.home-sec-3 .theme{\r\n  margin-bottom: 2rem !important;\r\n}\r\n.home-sec-3 .thumb-img{\r\n  margin-top: 3rem;\r\n  justify-content: center !important;\r\n}\r\n\r\n\r\n.home-sec-3 span{\r\n  text-transform: uppercase;\r\n  margin: 1rem 0;\r\n}\r\n  .home-sec-3 .tabs-container .tab-btn {\r\n    font-size: 20px;\r\n    padding: 15px 10px;\r\n    background-color: #fff;\r\n    width: 100%;\r\n    color: #1d1d1e;\r\n    border: unset;\r\n    border-bottom: 1px solid #000;\r\n  }\r\n  .br{\r\n    white-space: pre;\r\n  }\r\n  .home-sec-5 h2{\r\n    margin-top: 7rem !important;\r\n  }\r\n  /* .home-sec-4 h2{ */\r\n    /* text-align:left; */\r\n    /* padding-left:12.5rem; */\r\n    /* margin-top: 5rem; */\r\n  /* } */\r\n  .home-sec-4 .yellow-line::before{\r\n    /* left: calc( 68% - 57px ); */\r\n    top: -1.2rem;\r\n\r\n  }\r\n  .home-sec-4 {\r\n    padding-bottom: 10rem;\r\n    padding-top: 6rem;\r\n  }\r\n  .home-sec-4 .card{\r\n    width: 97%;\r\n    height: 250px;\r\n  }\r\n  /* .home-sec-4 .slick-next::before,.home-sec-4 .slick-prev::before{\r\n    margin: 0 -10px;\r\n  } */\r\n  .home-sec-4 .slick-next, .home-sec-4 .slick-prev{\r\n    top: 115%;\r\n  }\r\n  .home-sec-4 .slick-next{\r\n      position: absolute;\r\n      left: 53%;\r\n      transform: translateX(-50%); \r\n      font-size: 0;\r\n      right: 14rem;\r\n  }\r\n  .home-sec-4 .slick-prev{\r\n    position: absolute;\r\n    left:42%;\r\n    transform: translateX(-50%); \r\n    font-size: 0;\r\n  }\r\n  \r\n  .home-sec-4 .slick-prev::before{\r\n    content: url(../../public/images/app-home/sec2/slick-prev.svg);\r\n  }\r\n  .home-sec-4 .slick-next::before{\r\n    content: url(../../public/images/app-home/sec2/slick-next-3.svg);\r\n  }\r\n  .home-sec-5 span{\r\n      font-size: 20px;\r\n  }\r\n  /* .home-sec-5 button{\r\n    font-size: 20px !important;\r\n  } */\r\n  .home-sec-5 .seg1{\r\n    width: 20%;\r\n    margin-top: 1.4rem;\r\n  }\r\n  .home-sec-5 .seg1 span{\r\n    font-size: 15px;\r\n    line-height: 20px;\r\n  }\r\n  .home-sec-5 .seg2{\r\n    text-align: left;\r\n    width: 80%;\r\n    line-height: 24px;\r\n    font-size: 18px;\r\n    margin-top: 1rem;\r\n  }\r\n  .home-sec-5 .seg2 span{\r\n    line-height: 24px;\r\n    font-size: 18px;\r\n  }\r\n\r\n  \r\n  .home-sec-5 .scroller{\r\n    padding-right: 3px;\r\n    /* height: 350px; */\r\n  }\r\n  .home-sec-5 .seg3{\r\n    text-align: left;\r\n    width: 100%;\r\n    margin-top: 0.5rem;\r\n\r\n  }\r\n  .home-sec-5 .seg3 .btn{\r\n    padding: 0;\r\n  }\r\n  .home-sec-6 .plan-txt{\r\n    margin-bottom: 2rem;\r\n  }\r\n  .home-sec-6 .footer-title{\r\n    font-size: 40px;\r\n  }\r\n\r\n\r\n  .gallery-sec-1{\r\n    margin-top: 2rem !important;\r\n  }\r\n\r\n  .simple-slider {\r\n    height: 450px;\r\n  }\r\n  .home-sec-6 p{\r\n    max-width: 75%;\r\n    padding-bottom: 1rem;\r\n    font-size: 14px !important;\r\n  }\r\n  .home-sec-6 .btn-primary{\r\n    padding: 10px 55px;\r\n    font-size: 17px;\r\n  }\r\n  .tail .media button img {\r\n    height: 36px;\r\n  }\r\n  .button{\r\n    background-color: white;\r\n  }\r\n  .hidden-lg{\r\n    display: block !important;\r\n  }\r\n  .video, .video-2{\r\n    margin-top: 0rem;\r\n  }\r\n\r\n  .home-sec-4>div{\r\n    width: auto;\r\n  }\r\n  .home-sec-4>div .yellow-line{\r\n    width: auto;\r\n  }\r\n\r\n  /* Destination tab */\r\n\r\n    \r\n  .destination-banner{\r\n    min-height: 75vh;\r\n  }\r\n  .destination-banner h1{\r\n    font-size: 38px;\r\n    line-height: 3.2rem;\r\n    margin-top: 10rem;\r\n  }\r\n  .destination-banner h1 span{\r\n    font-size: 66px;\r\n  }\r\n  .destination-banner .col-lg-5 {\r\n    width: 30%;\r\n}\r\n  .destination-banner p{\r\n    font-size: 17px;\r\n    max-width:100%\r\n  }\r\n  .dest-contact{\r\n    /* padding: 6px 40px; */\r\n    padding:9px 15px!important;\r\n    margin-left: -1.5rem;\r\n\r\n  }\r\n  .destination-banner .btn-2{\r\n    margin-left: -4rem;\r\n  }\r\n  .destination-sec-2{\r\n    height: 75vh;\r\n  }\r\n  .destination-sec-2 h1{\r\n    margin-bottom: 7%;\r\n    max-width: 100%;\r\n    font-size: 30px;\r\n    /* line-height: 5rem; */\r\n  }\r\n  .destination-sec-2 .yellow-line:before{\r\n    top: -10px;\r\n    /* left: 280px; */\r\n  }\r\n  .dest-rw{\r\n    margin-top: 6rem !important;\r\n  }\r\n  .destination-sec-2 .pt-4{\r\n    padding-top: 0 !important;\r\n  }\r\n  .destination-sec-2 p{\r\n    /* margin-top: 1rem; */\r\n    text-align: center;\r\n\r\n  }\r\n  .destination-sec-3.discover{\r\n    margin-bottom: 0 !important;\r\n  }\r\n  .destination-sec-5 .title-1 {\r\n    margin-bottom: 1rem !important;\r\n    margin-top: 1rem !important;\r\n  }\r\n  .destination-sec-2 .content-img-text{\r\n    padding: 0;\r\n  }\r\n  .destination-sec-5-content{\r\n    padding-top: 2rem;\r\n  }\r\n  .destination-sec-5 .sec-title{\r\n    margin-top: 1rem;\r\n    margin-bottom: 3rem;\r\n  }\r\n  .amer.destination-sec-4 p{\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n    margin-bottom: 2rem;\r\n  }\r\n  .destination-sec-2 .le {\r\n    margin-top: 0 !important;\r\n  }\r\n  .home-sec-1 h1{\r\n    font-size: 40px;\r\n  }\r\n\r\n  .asia-img {\r\n    height: 246px;\r\n    width: 120vw; \r\n    max-width: none;\r\n  }\r\n  .dest-sec-5-p{\r\n    width: 91%;\r\n    padding-left: 4rem;\r\n  }\r\n  .eu-dest-sec-5-p{\r\n    width: 92%;\r\n    padding-left: 4rem;\r\n  }\r\n  .me-dest-sec-5-p{\r\n    width: 95%;\r\n    padding-left: 2rem;\r\n  }\r\n  .middleEast{\r\n    height: 83vh;\r\n  }\r\n  .destination-sec-5 .me-title{\r\n    margin-top: 0;\r\n  }\r\n  .destination-sec-5 .sec5-title{\r\n    max-width: 63% !important;\r\n    margin-top: 4rem;\r\n  }\r\n  .destination-sec-3 .sec-3-title{\r\n    font-size: 25px;\r\n  }\r\n  .destination-sec-3 .content-sec{ \r\n    margin-left: 1rem;\r\n  }\r\n  .middleEast .sec-title{\r\n    margin-bottom: 0;\r\n  }\r\n  .destination-sec-3 .col-md-5{\r\n    width: 38%;\r\n  }\r\n  .destination-banner-container{\r\n    height: 83vh;\r\n  }\r\n  .destination-sec-3 p{\r\n    font-size: 18px;\r\n    line-height: 22px;\r\n  }\r\n  .destination-sec-3 h1{\r\n    line-height: 2.3rem;\r\n    font-size: 27px;\r\n    margin-top: 26%;\r\n  }\r\n  .destination-sec-3 .yellow-line:before{\r\n    top: -15px;\r\n    left: 2px;\r\n    }\r\n  .destination-sec-3 .card{\r\n    top: -33%;\r\n  }\r\n  .destination-sec-3 .card{\r\n    top: -46px;\r\n    height: 290px;\r\n    width:210px;\r\n    margin-left:0px;\r\n  }\r\n  .destination-sec-3 .card-1{\r\n    height: 290px;\r\n    margin-top: 5.3rem;\r\n    width:190px;\r\n    margin-left:0px;\r\n  }\r\n  .destination-sec-5 h4, .destination-sec-5 p{\r\n    line-height: 14px;\r\n  }\r\n  .destination-sec-5 .card {\r\n    width: 325px;\r\n    margin: 5px;\r\n}\r\n  .destination-sec-3 .col-md-3 {\r\n    padding: 0;\r\n}\r\n  .destination-sec-4 p{\r\n    text-align: center;\r\n  }\r\n  .destination-sec-3 h4{\r\n    font-size: 19px;\r\n    line-height: 24px;\r\n  }\r\n  .destination-sec-3 .card .box{\r\n    padding: 10px 9px;\r\n  }\r\n.destination-sec-5 h1{\r\n  max-width: 60%;\r\n  font-size: 30px;\r\n  line-height: 36px;\r\n}\r\n/* .blogRead{\r\n  margin-top: 100px;\r\n} */\r\n.content-america{\r\n  margin-top: -0.5rem !important;\r\n}\r\n.destination-sec-5 .yellow-line:before{\r\n  max-width: 140px;\r\n  text-align: center;\r\n  /* left:26%; */\r\n} \r\n.destination-sec-5 .yellow-line:before{\r\n  text-align: center;\r\n  max-width: 140px;\r\n  /* left:26%; */\r\n}\r\n.expl .yellow-line:before {\r\n  max-width: 140px;\r\n  left: 25.5%;\r\n}\r\n.home-sec-3 .box{\r\n  width: 100%;\r\n  height: 96%;\r\n}\r\n.padding-1{\r\n  padding: 0;\r\n}\r\n\r\np{\r\n  font-size: 17px !important;\r\n  line-height: 26px !important;\r\n}\r\nbutton{\r\n  font-size: 15px;\r\n}\r\n\r\n.blogRead-sec-1 .cred{\r\n  margin-top: 3rem !important;\r\n}\r\n\r\n\r\n/* add media */\r\n.admedia-sec-3 p{\r\n  text-align: justify;\r\n}\r\n.admedia-sec-3 .card{\r\n  border-radius: 10px;\r\n}  \r\n/* Blog */\r\n.destination-banner .w-50{\r\n  width: 100% !important;\r\n}\r\n\r\n  .blog-banner{\r\n    min-height: 70vh;\r\n  }\r\n  .none{\r\n    display: none;\r\n  }\r\n  .blog-banner h1{\r\n    font-size: 35px;\r\n    line-height: 2.6rem;\r\n    padding-top: 8rem;\r\n  }\r\n  .blog-banner h1 span{\r\n    font-size: 35px;\r\n  }\r\n  .blog-banner p{\r\n    font-size: 17px;\r\n    max-width: 92%;\r\n  }\r\n  .blog-banner .btn-primary{\r\n    padding: 6px 30px;\r\n    font-size: 17px;\r\n    }\r\n    .blog-sec-2{\r\n      padding-top: 3rem;\r\n    }\r\n  .blog-sec-2 h5{\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    line-height: 25px;  \r\n  }\r\n  .blog-sec-2 .tag {\r\n    top: 6%;\r\n    left: 82%;\r\n}\r\n  .blog-sec-2 span{\r\n    font-size: 16px;\r\n    line-height: 25px; \r\n    margin: 14px;\r\n    margin-left: 2rem;\r\n    }\r\n  .blog-sec-2 .card{\r\n    height: 500px;\r\n    margin-right:0px;\r\n    margin-bottom: 5rem;\r\n    width: 50%;\r\n  }\r\n  .blog-sec-2 img{\r\n    width: 700px;\r\n    height: 320px;\r\n    transform: scale(1.1);\r\n  }\r\n  .blog-sec-2 h4{\r\n    font-size: 18px;\r\n    line-height: 25px; \r\n    max-width: 90%;\r\n    height: 50px;\r\n  }\r\n  .blog-content{\r\n    padding-bottom: 30px;\r\n  }\r\n  .blog-sec-2 p{\r\n    font-size: 14px;\r\n    line-height: 20px; \r\n    margin-top: 0.4rem;\r\n  }\r\n  .blog-sec-3-banner{\r\n    min-height: 58vh;\r\n  }\r\n  .blog-sec-3-banner h1{\r\n    max-width: 100%;\r\n    margin: auto;\r\n    font-size: 36px;\r\n  }\r\n  \r\n  .blog-sec-3-banner p{\r\n    font-size: 14.7px;\r\n    line-height: 20px;\r\n  }\r\n  .blog-sec-4 h6{\r\n    font-size: 13px;\r\n    line-height: normal;\r\n    }\r\n  .blog-sec-4 h4{\r\n    max-width: 100%;\r\n    margin-bottom: 5px;\r\n  }\r\n  .blog-sec-4 p{\r\n    font-size: 13px;\r\n    max-width: 100%;\r\n  }\r\n  .blog-sec-4 .card{\r\n    margin-right: 10px;\r\n    margin-bottom: 20px;\r\n    width: 100%;\r\n    }\r\n  .blog-sec-4 .box{\r\n    padding: 0px 0px 50px 50px ;\r\n    width: 60%;\r\n  }\r\n  .blog-sec-4 .box h1{\r\n    font-size: 18px;\r\n  }\r\n  .blog-sec-4 .box p{\r\n    font-size: 12px !important;\r\n    line-height: 20px !important;\r\n  }\r\n\r\n  .blogRead-sec-1 .yellow-line:before{\r\n    left: 38%;\r\n  }\r\n  hr.solid-small {\r\n    width: 10%;\r\n    margin-left: 45%;\r\n}\r\n.shop-sec-4 .slick-dots li button::before {\r\n  margin-top: 0.3rem;\r\n  margin-left: 0.7rem;\r\n}\r\n\r\n.about-banner-container .text-overlay {\r\n  width: 100%;\r\n}\r\n.about-banner-container .parallax-img{\r\n  height: 80%;\r\n  left: 6rem;\r\n}\r\n.about-section-2 {\r\n  border-bottom: 1px #fff solid;\r\n}\r\n  /* .home-sec-2 .slick-list{\r\n  height: 450px;\r\n} */\r\n.number img{\r\n  max-width: 131% !important;\r\n  position: relative;\r\n  left: 4rem;\r\n}\r\n/* Shop */\r\n\r\n  .shop-sec-2 h4{\r\n    font-size: 20px;\r\n  }\r\n  .shop-sec-2 p{\r\n    line-height: 23px;\r\n    max-width: 75%;\r\n    margin: auto;\r\n  }\r\n  .shop-sec-2 img{\r\n    height: 460px;\r\n    border-radius: 10px;\r\n    max-width: 100%;\r\n  }\r\n  .shop-sec-3 h2{\r\n    font-size: 32px;\r\n  }\r\n  .shop-sec-3 .card{\r\n    height: 500px;\r\n    width: 400px;\r\n    margin-right:9px;\r\n    margin-left: 10px;\r\n  }\r\n  .shop-sec-3 p{\r\n    font-size: 20px;\r\n    line-height: 40px;\r\n  }\r\n  .shop-sec-3 img{\r\n    width: 345px;\r\n  }\r\n  .shop-sec-4 p{\r\n    margin-bottom: 1.2rem;\r\n    max-width: 100%;\r\n  }\r\n  .shop-sec-4 .card{\r\n    margin: 20px 30px;\r\n    margin-right:30px;\r\n    height: 350px;\r\n  }\r\n  .overlay img {\r\n    width: 22px;\r\n}\r\n  .shop-sec-4 h4{\r\n    font-size: 24px;\r\n    max-width: 77%;\r\n    line-height: 116%;\r\n  }\r\n  .shop-sec-3 .overlay {\r\n    width: 95%;\r\n    height: 106%;\r\n}\r\n  .shop-sec-4 .content-box{\r\n    padding: 10px 0px 0px 10px;\r\n  }\r\n   .shop-sec-3 .title-box{\r\n    padding-left: 15px;\r\n    padding-bottom: 25px;\r\n    }\r\n  .hidden-md{\r\n    display: none !important;\r\n  }\r\n  .shop-sec-2 .box{\r\n    width: 96%;\r\n    margin: auto;\r\n    margin-right: 7px;\r\n  }\r\n  .blogRead-sec-1 h1{\r\n    font-size: 36px;\r\n  }\r\n  /* ShopSub */\r\n\r\n  .shopSub-banner-container{\r\n    padding-top: 10rem;\r\n  }\r\n  .shopSub-banner-container{\r\n    height: 55vh;\r\n  }\r\n  .shopSub-banner h1{\r\n    font-size: 35px;\r\n    line-height: 2rem;\r\n    text-align: left;\r\n  }\r\n  #dropdown-toggle1 {\r\n  margin-bottom: 15px;\r\n  }\r\n  .para{\r\n    max-width: 98% !important;\r\n    margin-left: 0.8rem !important;\r\n  }\r\n  .sort{\r\n    margin-top: 6px;\r\n  }\r\n  .shopSub-banner h1 span{\r\n    font-size: 36px;\r\n  }\r\n  .shopSub-banner p{\r\n    font-size: 17px;\r\n  }\r\n  .shopSub-sec-2 .col-1{\r\n    width: 3rem;\r\n  }\r\n  .shopSub-sec-2 .col-2{\r\n    width: 5.5rem;\r\n  }\r\n  .shopSub-sec-2 .col-5{\r\n    width: 18rem;\r\n  }\r\n  .shopSub-sec-4 h6{\r\n    font-size: 21px;\r\n    line-height: 10px;\r\n  }\r\n  .shopSub-sec-4 p{\r\n    font-size: 17px;\r\n    line-height: 22px; \r\n  }\r\n  .shopSub-sec-4 .col-1{\r\n    width: 3.6rem;\r\n    padding: 0;\r\n  }\r\n  .shopSub-sec-4 .col-2{\r\n    width: 38rem;\r\n    margin-bottom: 3rem;\r\n  }\r\n  .title-box img{\r\n    max-width: 100px;\r\n  }\r\n/* ShopSub2 */\r\n\r\n.shopSub2-sec-2{\r\n  margin-top:9rem ;\r\n}\r\n.shopSub2-sec-2 p{\r\n  font-size: 16px;\r\n  margin-top: 3px;\r\n}\r\n.shopSub2-sec-4 .col-md-12{\r\n  background-color: #E5E5E5;\r\n  width: 60rem;\r\n  margin: 0;\r\n  padding-left: 3.5rem;\r\n  border-radius: 0;\r\n  height: 28rem;\r\n}\r\n.shopSub2-sec-2 h5{\r\n  font-size: 15px;\r\n  text-align: left;\r\n  margin-top: 5px;\r\n}\r\n.shopSub2-sec-2 .col-2{\r\n  width: 8rem;\r\n}\r\n.shopSub2-sec-4{\r\n  background-color: white;\r\n}\r\n.sofa{\r\n  margin-right: 0rem;\r\n}\r\n.shopSub2-sec-4 h6{\r\n  color: #9F9F9F;\r\n  text-align: right;\r\n  font-family: Poppins;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height:30px;\r\n  text-align: right;\r\n}\r\n.shopSub2-sec-4 .col-5{\r\n  border-radius: 10px;\r\n  background: #E5E5E5;\r\n  width: 23rem;\r\n  height: 25rem;\r\n  margin-left: 2rem;\r\n}\r\n.shopSub2-sec-4 h2{\r\n  font-size: 38px;\r\n  text-align: left;\r\n}\r\n.shopSub2-sec-4 .col-6{\r\n  margin-left: 3.5rem;\r\n}\r\n.shopSub2-sec-4 h4{\r\n  font-size: 24px;\r\n  text-align: right;\r\n}\r\n  .shopSub2-sec-4 .col-2{\r\n    width: 7rem;\r\n  }\r\n  .shopSub2-sec-4 p{\r\n    font-size: 14px;\r\n    text-align: left;\r\n  }\r\n  .shopSub2-sec-4 .btn-primary{\r\n    font-size: 18px;\r\n    padding: 10px 70px;\r\n  }\r\n  .shopSub2-sec-4.box {\r\n    border: 1px solid black;\r\n    padding: 20px; \r\n    margin: 20px; \r\n  }\r\n\r\n  .home-sec-4 .product-card-slider .slide:nth-child(8) > .box{\r\n    opacity: 0.83;\r\n    background: linear-gradient(180deg, #FAEC24 0%, #000 100%);\r\n}\r\n.popular-milestone h4{\r\n  font-size: 18px;\r\n  line-height: 30px;\r\n}\r\n.popular-milestone p{\r\n  font-size: 16px !important;\r\n  line-height: 27px !important;\r\n}\r\n.popular-milestone .box{\r\n  padding-left: 14px !important; \r\n  padding-right: 14px !important;\r\n}\r\n.blog-sec-2 h4{\r\n  max-width: 75%;\r\n}\r\n\r\n  /* Cart */\r\n\r\n  .cart-sec-2-row, .cart-sec-2 .col-lg-4{\r\n    background-color: #E5E5E5;\r\n  }\r\n  .cart-sec-2 .col-md-12{\r\n    margin-left: 0rem;\r\n    margin-top: 5rem;\r\n    width: 50rem;\r\n  }\r\n  .cart-sec-2 h3{\r\n    font-size: 15px;\r\n  }\r\n  .cart-sec-2 h2{\r\n    font-size: 28px;\r\n    text-align: center;\r\n  }\r\n  .cart-sec-2 h5{\r\n    text-align: left;\r\n  }\r\n  .cart-sec-3 h4{\r\n    margin-bottom: 2rem;\r\n    text-align: center;\r\n    margin-left: 2rem;\r\n  }\r\n  .cart-sec-3 h6{\r\n    margin-bottom: 1.9rem;\r\n    text-align: left;\r\n    font-size: 18px;\r\n    margin-left: 6rem;\r\n  }\r\n  .cart-sec-3 h5{\r\n    margin-left: 6rem;\r\n    margin-bottom: 3rem;\r\n  }\r\n  .cart-sec-2 .btn-primary{\r\n    padding: 10px 75px;\r\n  }\r\n  .cart-sec-4 h4{\r\n    font-size: 22px;\r\n    line-height: 22px;\r\n    margin-left: 45px;\r\n  }\r\n  .cart-sec-4 .row{\r\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n    padding: 20px 8px;\r\n    border-radius: 10px;\r\n  }\r\n  .cart-sec-4 h5{\r\n    font-size: 19px;\r\n    text-align: left;\r\n    margin-left: 44px;\r\n  }\r\n  .cart .count {\r\n    width: 120px;\r\n    padding: 0;\r\n    border: 1.5px solid black;\r\n    margin-left: 40px;\r\n    padding-top: 2px;\r\n    margin-top: 20px;\r\n    height: 53px;\r\n  }\r\n  .count input{\r\n    width: 40px;\r\n    border-radius: 0;\r\n    text-align: center;\r\n    font-size: 18px;\r\n    border: none !important;\r\n  }\r\n  \r\n  .count button{\r\n    background: white;\r\n    border: none !important;\r\n    font-size: 20px;\r\n  }\r\n  .cart-sec-4-img img{\r\n    height: 25px;\r\n    margin-left: 20px;\r\n  }\r\n  .cart-sec-2-img img{\r\n    height: 85px;\r\n  }\r\n  .cart-sec-4 .col-1 {\r\n    height: 81px;\r\n    width: 81px;\r\n}\r\n.shop-sec-4 .slick-arrow.slick-next::before{\r\n display: none;\r\n}\r\n.asia .col-lg-7{\r\n  width: 42%;\r\n}\r\n.africa .col-lg-7{\r\n  width: 43%;\r\n}\r\n.europe .col-lg-7{\r\n  width: 46%;\r\n}\r\n  /* Checkout */\r\n\r\n  .checkout-sec-2 h1{\r\n    font-size: 36px;\r\n  }\r\n  .checkout-sec-3 .form {\r\n    padding: 20px;\r\n    width: 700px;\r\n    border-radius: 5px;\r\n    text-align: left;\r\n    border: none;\r\n  }\r\n  .checkout-sec-3 label {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n    font-size: 18px;\r\n    text-align: left;\r\n  }\r\n  .checkout-sec-3 .input-box {\r\n    padding: 10px;\r\n    width: 100%;\r\n    height: 3.3rem;\r\n    margin-bottom: 25px;\r\n    margin-top: 5px;\r\n  }\r\n  .checkout-sec-3 h3{\r\n    font-size: 24px;\r\n    margin-left: 0rem;\r\n    text-align:right;\r\n    margin-right: 15px;\r\n  }\r\n  .checkout-sec-3 h2{\r\n    font-size: 24px;\r\n  }\r\n  .checkout-sec-3 h5{\r\n    font-size: 24px;\r\n    line-height: 3rem;\r\n    text-align: right;\r\n    margin-right: 15px;\r\n  }\r\n  .checkout-sec-3 h4{\r\n    font-size: 16px;\r\n    text-align: left;\r\n    line-height: 30px;\r\n  } \r\n  .checkout-sec-3 h6{\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height:9px;\r\n    text-align: right;\r\n    margin-top: 2rem;\r\n    margin-right: 17px;\r\n  } \r\n  .checkout-sec-3 p{\r\n    font-size: 17px;\r\n    line-height: 25px;\r\n    text-align: left;\r\n    margin-bottom: 10px;\r\n    margin-top: 1.5rem;\r\n  }\r\n  .checkout-sec-3 .btn-primary{\r\n    font-size: 16px;\r\n    padding: 10px 75px;\r\n    margin-bottom: 3rem;\r\n  }\r\n  .checkout-sec-3 span{\r\n    color: #000;\r\n    font-family: Poppins;\r\n    font-size: 13.6px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: normal;\r\n  }\r\n  hr.solid {\r\n    border-top: 2px solid #bbb;\r\n    width: 100% !important;\r\n    margin-left: 0rem !important;\r\n  }\r\n  .checkout-sec-3 h1{\r\n    color: #6C757D;\r\n    text-align: justify;\r\n    font-family: Poppins;\r\n    font-size: 15px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: normal;\r\n  }\r\n  .checkout-col-1 {\r\n    margin-left: 0rem;\r\n}\r\n.checkout-col {\r\n  margin-left: 0rem;\r\n}\r\n.blog-sec-4{\r\n  padding-top: 3rem;\r\n  \r\n}\r\n\r\n.blog-sec-4-cards{\r\n  flex-direction: column;\r\n}\r\n\r\n  /* Ad&media */\r\n \r\n  .admedia{\r\n    margin-top: 120px;\r\n  }\r\n  .admedia-sec-1 h1{\r\n    font-size: 36px;\r\n    line-height: 40px;\r\n    margin-top: 9rem;\r\n  }\r\n  .admedia-sec-1 span{\r\n    font-size: 80px;\r\n  }\r\n  .admedia-sec-1 p{\r\n    font-size: 17px;\r\n    line-height: 23px;\r\n    /* max-width: 100%; */\r\n  }\r\n  .admedia-sec-2 h1{\r\n    font-size: 40px;\r\n    max-width: 100%;\r\n  }\r\n  .admedia-sec-3 p{\r\n    font-size: 19px;\r\n    max-width: 100%;\r\n    line-height: 25px;\r\n    margin-bottom: 25px;\r\n  }\r\n  .admedia-sec-3 .card{\r\n    height: 400px;\r\n    width:100%;\r\n    margin-left:0px;\r\n    margin-top: 30px;\r\n  }\r\n  .admedia-sec-3 h4{\r\n    font-size: 25px;\r\n  }\r\n  .admedia-sec-3 .card p{\r\n    font-family: Poppins;\r\n    font-size: 18px;\r\n    font-weight: 400;\r\n    line-height: 33px;\r\n  }\r\n  .admedia-sec-4 .box{\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-end;\r\n    background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);\r\n    align-items: flex-start;\r\n    text-align: left;\r\n    padding: 40px 28px;\r\n    border: none;\r\n    border-radius: 12px;\r\n  }\r\n  .admedia-sec-4 h4, .admedia-sec-4 p{\r\n    color: #fff;\r\n    line-height: 14px;\r\n  }\r\n  .admedia-sec-4 .row{\r\n    max-width: 100%;\r\n    margin: 0;\r\n  }\r\n  .admedia-sec-4 .card{\r\n    margin: 10px;\r\n    height: 480px;\r\n  }\r\n  /* .enlarged .card {\r\n    transform: scale(1);\r\n} */\r\n.shop-sec-4 .slick-current .card{\r\n  height: 450px;\r\n  width: 420px;\r\n}\r\n.about-sec-2 .col-lg-5{\r\n  width: 100%;\r\n}\r\n/* .about-sec-2 .content-title{\r\n  margin-left: -2rem;\r\n} */\r\n\r\n \r\n .scroll-top span{\r\n  color: #fff;\r\n  font-size: 11px;\r\n  font-weight: 300;\r\n  font-family: Montserrat;\r\n }\r\n .scroll-top .scroll-top-btn{\r\n  margin-bottom: -2.5rem ;\r\n }\r\n\r\n .about-banner-container{\r\n  background-image: url(../../public/images/about/banner-tab.png);\r\n }\r\n\r\n  /* Gallery */\r\n\r\n  .gallery{\r\n    margin-top:120px;\r\n  }\r\n  .gallery-sec-1 h2{\r\n    font-size: 13px;\r\n  }\r\n  .gallery-sec-2{\r\n    margin: auto;\r\n    /* margin-right: 0px;\r\n    margin-left: 24px; */\r\n  }\r\n  .gallery-sec-2 img{\r\n    margin-bottom: 30px;\r\n  }\r\n  .gallery-sec-1 .col-2 {\r\n    width: 9.2rem;\r\n}\r\n  .equator{\r\n    width: 720px;\r\n  }\r\n  .gallery-sec-2 .row1 img{\r\n    height: unset;\r\n    max-width: 100%;\r\n  }\r\n  .gallery-sec-2 .row2 img{\r\n    height: unset;\r\n    max-width: 100%;\r\n  }\r\n  .gallery-sec-2 .row3 img{\r\n    height: unset;\r\n    max-width: 100%;\r\n  }\r\n  .admedia-sec-1{\r\n    min-height: 60vh;\r\n  }\r\n\r\n  .blogRead-banner-container {\r\n    background-image: url(../../public/images/blog_read/1-md.png);\r\n    height: 570px;\r\n  }\r\n\r\n\r\n  #blog-scroller{\r\n    height: 520px ;\r\n  }\r\n  #blog-scroller .product-card-slider .slick-slide{\r\n    opacity: 30%;\r\n    transition: all ease 1s;\r\n  }\r\n  #blog-scroller .product-card-slider .slick-active{\r\n    opacity: 100%;\r\n  }\r\n  \r\n  /* Contact */\r\n\r\n\r\n  .contact-sec-1{\r\n    padding-top: 2.5rem;\r\n  }\r\n  .contact-sec-1 p{\r\n    max-width: 85%;\r\n    margin: auto;\r\n  }\r\n  .contact-sec-2 h1{\r\n    font-size: 35px;\r\n    text-align: left !important;\r\n  }\r\n  .banner-timeline{\r\n    margin-left: 0.4rem;\r\n  }\r\n\r\n  /* about */\r\n\r\n  .about-sec-2 h1{\r\n    font-size: 34px;\r\n    line-height: 46px;\r\n    margin-bottom: 2rem;\r\n  }\r\n  .about-sec-2 .yellow-line:before{\r\n    top: 108%;\r\n    left: 1%;\r\n  }\r\n  .about-sec-2 p{\r\n    font-size: 17px;\r\n    margin-left: 10px;\r\n    max-width: 106% !important;\r\n  }\r\n  /* .about-img{\r\n    margin-left: -30px;\r\n    min-width: 730px;\r\n  } */\r\n  .contact-sec-1{\r\n    padding-top: 1.5rem;\r\n  }\r\n.contact-sec-1 h1{\r\n  font-size: 38px;\r\n  line-height: 43px;\r\n  margin-top: 0rem !important;\r\n}\r\n.contact-sec-1 .yellow-line:before{\r\n  margin-top: 20px;\r\n  left: 35%;\r\n}\r\n.contact-txt{\r\n  margin-top: 5rem !important;\r\n}\r\n.contact-txt p{\r\n  text-align: left;\r\n}\r\n.contact-sec-1 p{\r\n  font-size: 16.5px;\r\n  max-width: 75%;\r\n  margin-bottom: 0rem !important;\r\n  margin-top: -1.4rem !important;\r\n}\r\n.contact-sec-2 h1{\r\n  font-size: 35px;\r\n}\r\n.form-section h1{\r\n  line-height: 40px;\r\n  max-width: 90%;\r\n  margin-right: 23%;\r\n  /* margin-top: -30 !important; */\r\n  margin-top: 30px;\r\n}\r\n#enquiryForm{\r\n  width: 80%;\r\n  margin-top: 0%;\r\n}\r\n.form-section input, .form-section textarea, .form-section select{\r\nmargin-bottom: 0.6rem;\r\n}\r\n.section{\r\n  margin-top: 10rem !important;\r\n  border-bottom-left-radius: 70px;\r\n  border-bottom-right-radius: 70px;\r\n  padding: 45px 20px;\r\n  width: 100%;\r\n}\r\n\r\n/* ad media */\r\n.admedia-title{\r\n  margin-bottom: 30%;\r\n}\r\n.contact-sec-1{\r\n  background-color: black;\r\n}\r\n.home-sec-6 .contact-btn{\r\n  padding: 10px 32px;\r\n}\r\n    \r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* \r\n@media (max-width:768px) {\r\n  section .row>*  {\r\n    padding-left: 24px;\r\n    padding-right: 24px;\r\n  }\r\n  h1,\r\n  h2,h3 {\r\n    \r\n      font-size: 38px !important;\r\n      line-height: 40px !important;\r\n  }\r\n  h3{\r\n    text-align: left;\r\n  }\r\n  h4{\r\n    font-size: 20px;\r\n    margin-bottom: 5px;\r\n  }\r\n\r\n  h1 {\r\n    width: 100% !important;\r\n  }\r\n  p{\r\n    font-size: 16px !important;\r\n    line-height: 28px !important;\r\n  }\r\n\r\n.banner-container{\r\n  min-height: 100vh;\r\n  margin-bottom: 90px;\r\n}\r\n .banner{\r\n  min-height: 100vh;\r\n  \r\n}\r\n.banner{\r\npadding: 30px 24px;\r\n} \r\n.banner h1{\r\n  font-size: 38px;\r\n  line-height: 40px;\r\n}\r\n  .home-sec-1 {\r\n    min-height: 750px;\r\n  }\r\n  .home-book-button {\r\n    background: #26B2E3;\r\n    font-size: 15px;\r\n  }\r\n\r\n  .home-book-button:hover{\r\n    background: linear-gradient(180deg, #198bca 0%, #0f5789 100%);\r\n  }\r\n  .home-sec-2 .slick-list{\r\n    height: 460px;\r\n  }\r\n  .home-sec-2 .slick-next, .home-sec-2 .slick-prev{\r\n    top: 95%;\r\n  }\r\n  .home-sec-2 .slick-next{\r\n    right: 30px;\r\n    height: 10px;\r\n  }\r\n  .home-sec-2 .slick-prev{\r\n    left: calc( 100vw - 300px);\r\n  }\r\n  p {\r\n    width: 100% !important\r\n  }\r\n  .accordion-item{\r\n    border: unset !important;\r\n  }\r\n  .accordion  .active{\r\n    border-left: unset;\r\n    border-bottom: 3px solid #F28B20 !important;\r\n  }\r\n  .tab-btn{\r\n    font-size: 20px !important;\r\n    font-weight: 700 !important;\r\n    border: unset !important;\r\n    width: fit-content !important;\r\n    margin-bottom: 20px !important;\r\n    padding: 1px 10px 1px 0 !important;\r\n  }\r\n  .home-sec-3 .tab-btn {\r\n    width: 100% !important;\r\n    padding: 10px 10px !important;\r\n    border-top-left-radius: 0 !important;\r\n    border-top-right-radius: 0 !important;\r\n    border-bottom: unset;\r\n  }\r\n  .home-sec-3 .active{\r\n    border-left: unset;\r\n    border-bottom: unset !important;\r\n  }\r\n  .tab-btn:after{\r\n    display: none;\r\n  }\r\n  .home-sec-3 .tab-contents-container ul {\r\n    column-count: 1;\r\n  }\r\n  .home-sec-3 .tab-contents-container ul li {\r\n    font-size: 14px;\r\n  }\r\n  .home-sec-3 .tab-contents-container .tab-content{\r\n    padding: 20px 10px;\r\n  }\r\n  .home-sec-3 .tab-contents-container .tab-content p {\r\n    margin-bottom: 30px;\r\n  }\r\n  .home-sec-4 .card{\r\n    width: 100%\r\n  };\r\n\r\n  .home-sec-5 span{\r\n    font-size: 10px !important;\r\n  }\r\n  .home-sec-5 button{\r\n    font-size: 10px !important;\r\n  }\r\n .non-breaking-mob-container{\r\n  width:100%;\r\n  overflow-x: scroll;\r\n}\r\n.non-breaking-mob-container .row{\r\n  width:1000px;\r\n  flex-wrap: nowrap;\r\n}\r\n.grey-bg{\r\n  width: 100%;\r\n height: calc(inherit + 50px);\r\n background: linear-gradient(174.7deg, #F4F4F2 88.97%, rgba(244, 244, 242, 0) 100%);\r\n}\r\n.de-banner .row {\r\n  position: relative;\r\n}\r\n.de-banner .row .col-lg-6{\r\n  position: absolute;\r\n  top: 200px;\r\n  z-index: 1;\r\n  color: #f6f6f6;\r\n  }\r\n  .de-banner .row .col-lg-6:last-child{\r\n    padding: 0;\r\n    z-index: 0;\r\n    top: 0;\r\n  }\r\n\r\n  .de-banner .row .col-lg-6 h3{\r\n  \r\n    color: #f6f6f6;\r\n  }\r\n      .de-banner .row .col-lg-6 .responsive-col-gap{\r\n        width: 100%;\r\n        overflow-x: hidden;\r\n      }\r\n.de-banner img{\r\n\r\n height: 569px;\r\n width: 100%;\r\n}\r\n}\r\n@media (min-width:992px) {\r\n\r\n  .home-sec-1, .home-sec-3{\r\n    padding-left: 23px;\r\n    padding-right: 100px;\r\n  }\r\n  .home-sec-5 .col-lg-4 .box {\r\n    height: 560px;\r\n  }\r\n  .home-sec-5 .col-lg-4:first-child .box {\r\n    height:1120px;\r\n  }\r\n\r\n} */\r\n@media (max-width:576px){\r\n  .banner-container {\r\n    background-position: center !important; /* Adjust as needed */\r\n}\r\n.banner .first-slide{\r\n  font-size: 38px !important;\r\n  line-height: 24px;\r\n}\r\n.home.banner h1{\r\n  font-size: 32px !important;\r\n  line-height: 38px;\r\n}\r\n\r\n.home-sec-2 .title1, .home-sec-3 h1,.home-sec-4 h2,\r\n  .row.sec-title .yellow-line, .blog-sec-2 h2, .blog-sec-4 h2,\r\n  .contact-section-2 h1{\r\n    font-size: 32px !important;\r\n    line-height: 38px !important;\r\n  }\r\n\r\n  .home-sec-2 .card{\r\n    height: 458px;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n    \r\n  }\r\n  .home-sec-2 .card .card-body{\r\n    opacity: 1;\r\n  }\r\n.home-sec-1{\r\n  height: fit-content;\r\n  /* margin-bottom: 2rem; */\r\n}\r\n.home-sec-1 .logo-video{\r\n  padding-left: 0;\r\n  width: 100%;\r\n}\r\n  .timeline{\r\n    /* margin-top: 8rem; */\r\n    height: 320px;\r\n    top: -1rem;\r\n  }\r\n  h1,h3 {\r\n    font-size: 35px ;\r\n    line-height: 40px;\r\n  }\r\n  .banner h1{\r\n    font-size: 38px !important;\r\n    line-height: 44px;\r\n    margin-top: 2rem;\r\n    margin-bottom: 20px;\r\n  }\r\n  h1 {\r\n    width: 100% ;\r\n  }\r\n\r\n  p{\r\n    font-size: 16px ;\r\n    line-height: 24px ;\r\n  }\r\n  .banner p {\r\n    max-width: 97%;\r\n    font-size: 16px ;\r\n    line-height: 24px ;\r\n}\r\n  .home-sec-2 {\r\n    padding-top: 1rem;\r\n    padding-bottom: 8rem;\r\n    /* padding-left: 1rem; */\r\n  }\r\n  .home-sec-2 .card{\r\n    height: 360px;\r\n    width: 230px;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n    \r\n  }\r\n  .home-sec-2 .card-img-top {\r\n    height: 79%;\r\n  }\r\n  /* .home-sec-2 .card-body{\r\n    padding: 10px;\r\n    height: 20%;\r\n  } */\r\n  .home-sec-2 .card:hover{\r\n    height: 360px;\r\n    top: -0;\r\n  }\r\n  \r\n.home-voyage{\r\n  margin-top: 4rem;\r\n}\r\n.home-sec-4 .card{\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n.home-sec-4 .slick-next::before,.home-sec-4 .slick-prev::before{\r\n  margin: 0 -10px;\r\n}\r\n.home-sec-4 .slick-next, .home-sec-4 .slick-prev{\r\n  top: 120%;\r\n  position:absolute;\r\n}\r\n.home-sec-4 .slick-next{\r\n  /* right: 16rem; */\r\n  left: 25%;\r\n}\r\n.home-sec-4 .slick-prev{\r\n  left: 2rem;\r\n}\r\n.home-sec-4 .slick-prev::before{\r\n  content: url(../../public/images/app-home/sec2/slick-prev.svg);\r\n}\r\n.home-sec-4 .slick-next::before{\r\n  content: url(../../public/images/app-home/sec2/slick-next-3.svg);\r\n}\r\n  \r\n  .banner-timeline .row h4{\r\n    line-height: 17px;\r\n    font-size: 25px;\r\n    margin-left: 17.8rem;\r\n  }\r\n  .banner-timeline .row.active h4{\r\n    color:#fff;\r\n    font-size: 30px;\r\n    margin-left: 16rem;\r\n  }\r\n  .banner h1 span{\r\n    font-weight: 700;\r\n  }\r\n  .banner-timeline .row.active p{\r\n    margin-left: 16.8rem;\r\n  }\r\n  .banner-timeline span{\r\n    display: none;\r\n  }\r\n  .banner .first-slide svg{\r\n    /* right: 35px; */\r\n    height: 52px;\r\n    left: auto;\r\n  }\r\n  .banner .first-slide{\r\n    color: #ffffff;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .travel{\r\n    display: none;\r\n  }\r\n  .line{\r\n    width: 1.9rem;\r\n    margin-left: 16.56rem;\r\n  }\r\n  .btn-borderless{\r\n    width: 50px;\r\n    padding: 0;\r\n    margin-right: 0px !important;\r\n    margin-top: 5px !important;\r\n  }\r\n  .home-sec-1 h1{\r\n    font-size: 35px;\r\n    line-height: 30px;\r\n    text-align: center;\r\n  }\r\n\r\n  .dest-contact{\r\n    padding-right: 12px;\r\n  }\r\n  .home-sec-2 .title1{\r\n    font-size: 32px;\r\n    line-height: 38px;\r\n  }\r\n  .home-sec-2 h4 {\r\n    line-height: 39px;\r\n    font-size: 23px;\r\n}\r\n  .home-sec-2 p{\r\n    font-size: 17px;\r\n  }\r\n  .home-sec-2 .yellow-line{\r\n    margin-left: 0.5rem;\r\n    max-width: 100%;\r\n    line-height: 36px;\r\n    margin-bottom: 0rem;\r\n  }\r\n  .home-sec-2 .slick-list {\r\n    height: 520px;\r\n  }\r\n  .home-sec-2 .slick-prev::before{\r\n    display: block;\r\n    /* content: url(../../public/images/app-home/sec2/slick-next-3.svg); */\r\n  }  \r\n  .home-sec-2 .slick-next::before{\r\n    display: block;\r\n    /* position: relative; */\r\n    /* right: -7rem; */\r\n    /* content: url(../../public/images/app-home/sec2/slick-next-3.svg); */\r\n\r\n  }\r\n  .home-sec-2 .product-card-slider{\r\n    padding-top: 0;\r\n  }\r\n  .home-sec-2 .product-card-slider .slick-slide .slide{\r\n    margin-left: -7px;\r\n  }\r\n  .home-sec-2 .slick-next, .home-sec-2 .slick-prev{\r\n    top: 85%;\r\n    position:absolute;\r\n  }\r\n  .home-sec-2 .slick-next{\r\n    /* right: 14rem; */\r\n    left: 25%;\r\n  }\r\n  .home-sec-2 .slick-prev{\r\n    left: 1rem;\r\n    z-index: 1;\r\n  }\r\n  \r\n  /* .home-sec-5 .slick-arrow.slick-next,.home-sec-5 .slick-arrow.slick-prev{\r\n    display: none !important;\r\n  }  \r\n  .home-sec-5 .slick-next::before,.home-sec-5 .slick-prev::before{\r\n    display: none !important;\r\n  }   */\r\n\r\n  .home-sec-5 .slick-prev{\r\n    left: 2rem !important;\r\n  }\r\n  .home-sec-5 .slick-next{\r\n    left: 25% !important;\r\n  }\r\n  .home-sec-3 .thumb-img{\r\n    margin-top: 3rem;\r\n    justify-content: center;\r\n  }\r\n\r\n  .home-sec-3 h1{\r\n    max-width: 100%;\r\n    line-height: 38px;\r\n    font-size: 32px;\r\n  }\r\n  .home-sec-3{\r\n    margin-top: 3rem;\r\n  }\r\n  .home-sec-3 p{\r\n    font-size: 19px;\r\n    line-height: 25px;\r\n  }\r\n  .home-sec-4 h2{\r\n    text-align: left;\r\n    width: 93%;\r\n    /* margin-left: 0.3rem; */\r\n    font-size: 32px;\r\n    line-height: 36px;\r\n  }\r\n  .home-sec-4 h4{\r\n    font-size: 20px;\r\n  }\r\n  .home-sec-4 .yellow-line:before{\r\n    left: 0;\r\n  }\r\n  .home-sec-4 .yellow-line{\r\n    margin-top: 3rem;\r\n    left: 1rem;\r\n  }\r\n  .video{\r\n    justify-content: center !important;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n  }\r\n  .frame-icon{\r\n    top:50%;\r\n  }\r\n  .home-sec-5 .yellow-line{\r\n    margin-left: 1rem;\r\n    margin-top: 3.5rem !important;\r\n    font-size: 32px;\r\n    line-height: 36px;\r\n  }\r\n  .home-sec-5 .strip{\r\n    width: 100%;\r\n    display:block;\r\n    justify-content: center;\r\n    height: unset;\r\n  }\r\n  .home-sec-5 .scroller{\r\n    height: 620px;\r\n    width: 100%;\r\n    overflow-y: unset;\r\n    margin-left: 0.7rem;\r\n  }\r\n  .home-sec-5 .slider{\r\n    opacity: 100%;\r\n  }\r\n  .home-sec-5 .slick-active {\r\n    display: block;\r\n    opacity: 100%;\r\n}\r\n  .home-sec-5 .row{\r\n    width: 100%;\r\n    margin-bottom: 0 !important;\r\n  }\r\n  .button-travel{\r\n    margin-left: 0.45rem;\r\n  }\r\n  .le {\r\n    margin-top: 5rem !important;\r\n    margin-bottom: -7rem !important;\r\n   }\r\n   .le .sm-yellow{\r\n    margin-left: 0;\r\n    margin-bottom: 0;\r\n   }\r\n   .destination-sec-2 .content{\r\n    padding: none !important;\r\n   }\r\n  ::-webkit-scrollbar {\r\n    width: 3px;\r\n    height: 5px;\r\n    display: none;\r\n  }\r\n  ::-webkit-scrollbar-track {\r\n    background: black\r\n  }\r\n  ::-webkit-scrollbar-thumb {\r\n    background: #888888cb;\r\n  }\r\n  ::-webkit-scrollbar-thumb:hover {\r\n    display: none;\r\n  }\r\n\r\n  .home-sec-5{\r\n    padding-top: 2rem !important;\r\n    padding-bottom: 1rem !important;\r\n    margin-top: -1rem;\r\n  }\r\n  .home-sec-5 .seg1{\r\n    width: 100% ;\r\n    margin-top: 1.3rem;\r\n  }\r\n  .home-sec-5 .seg2{\r\n    width: 90%;\r\n    margin-left: 0rem;\r\n    margin-top: 0.7rem;\r\n    line-height: 20px;\r\n    text-align: left;\r\n  }\r\n  .home-sec-5 .seg2 .text{\r\n    font-size: 18px !important;\r\n    line-height: 24px !important;\r\n  }\r\n  .home-sec-5 .seg1 {\r\n    font-size: 15px !important;\r\n    line-height: 20px !important;\r\n  }\r\n\r\n  .home-sec-5 #inner{\r\n    height: 600px;\r\n    overflow: hidden;\r\n  }\r\n  .home-sec-5 .seg3{\r\n    width: 100%;\r\n    margin-top: 0.7rem;\r\n  }\r\n  .home-sec-5 span{\r\n    font-size: 21px;\r\n    line-height: 22px;\r\n    text-align: left;\r\n    width: 10% !important;\r\n  }\r\n  .home-sec-5 button {\r\n    font-size: 18px;\r\n    padding: 0px;\r\n}\r\n  .home-sec-6 h1 {\r\n    text-align: left;\r\n    margin-left: 0.6rem;\r\n    font-size: 45px !important;\r\n    line-height: 50px;\r\n    max-width: 40%;\r\n  }\r\n  .dest-exp{\r\n    margin-left: 0.3rem !important;\r\n  }\r\n  .le-exp{\r\n    margin-left: -0.8rem !important;\r\n  }\r\n  .abt-exp{\r\n    margin-left: -9rem !important;\r\n  }\r\n  .home-sec-6 p {\r\n    font-size: 14px !important;\r\n    line-height: 22px !important;\r\n    margin-left: 0.6rem;\r\n    text-align: left;\r\n    max-width: 100%;\r\n    margin-bottom: 0.8rem;\r\n  }\r\n  .home-sec-6 .btn-primary{\r\n    padding: 10px 35px;\r\n    font-size: 15px;\r\n  }\r\n  .button{\r\n    background-color: white;\r\n  }\r\n  .h2{\r\n    font-weight: 400!important;\r\n    font-size: 32px!important;\r\n    line-height: 36px!important;\r\n  }\r\n  .h1{\r\n    font-weight: 400!important;\r\n    font-size: 32px!important;\r\n    line-height: 36px!important;\r\n  }\r\n  .travel-btn{\r\n    margin-left: 0.5rem;\r\n    margin-right: 0.3rem !important;\r\n  }\r\n  .home-sec-4 {\r\n    padding-bottom: 10rem;\r\n    padding-top: 2rem;\r\n}\r\n.home-voyage{\r\n  margin-bottom: 0rem !important;\r\n}\r\n\r\n.about-banner-container .banner h1{\r\n  font-size: 38px !important;\r\n  line-height: 44px;\r\n  padding-left: 0.5rem;\r\n}\r\n\r\n.about-banner-container .text-overlay {\r\n  width: 80%;\r\n  top:48%;\r\n}\r\n.about-banner-container .parallax-img{\r\n  height: 520px;\r\n  max-width: 100vh;\r\n  left: 6rem;\r\n}\r\n.about-section-2 {\r\n  border-bottom: 1px #fff solid;\r\n}\r\n.ad-media-banner-container .parallax-img{\r\n  height: 80vh;\r\n  object-fit: cover;\r\n}\r\n\r\n.blog-sec-4{\r\n  background-color: #fff;\r\n}\r\n.blog-banner-container .text-overlay {\r\n  width: 90%;\r\n}\r\n.blogRead-banner-container {\r\n  background-image: url(../../public/images/blog_read/1-sm.png);\r\n  height: 360px;\r\n  background-size: cover;\r\n}\r\n.blogRead-sec-2 img{\r\n  width: 100%;\r\n}\r\n\r\n  /* Destination mobile */\r\n\r\n  .destination-banner{\r\n    min-height: 105vh;\r\n  }\r\n  .destination-banner-container{\r\n  height: 110vh;\r\n  }\r\n  .destination-europe{\r\n    height: fit-content;\r\n  }\r\n  .destination-asia{\r\n    height: fit-content;\r\n  }\r\n  .destination-africa{\r\n    height: fit-content;\r\n  }\r\n  .destination-middleEast{\r\n    height: fit-content;\r\n  }\r\n  .destination-america{\r\n    height: fit-content;\r\n  }\r\n  .destination-banner h1{\r\n    font-size: 34px;\r\n    line-height: 2.7rem;\r\n    margin-top: 12rem;\r\n  }\r\n  .destination-banner h1 span{\r\n    font-size: 48px;\r\n  }\r\n  .destination-row{\r\n    padding: 0;\r\n  }\r\n  .destination-banner p{\r\n    max-width: 95%;\r\n  }\r\n  .sec-5{\r\n    margin-top: 5rem;\r\n  }\r\n  .content{\r\n    margin-top: -1.5rem !important;\r\n  }\r\n  .margin{\r\n    height: 5rem !important;\r\n  }\r\n  .none{\r\n    display: none;\r\n  }\r\n  .destination-banner .btn-primary{\r\n    margin-top:15px;\r\n  }\r\n  .destination-sec-2{\r\n    height: fit-content;\r\n    }\r\n  .destination-sec-2 p{\r\n    font-size: 18px;\r\n    line-height: 22px;\r\n    margin-top: 0rem;\r\n    padding: 10px;\r\n    }\r\n  .destination-sec-2 h1{\r\n    max-width: 100%;\r\n    font-size: 32px;\r\n    line-height: 36px;\r\n    text-align: left;\r\n    margin-bottom: 2rem;\r\n    /* margin-left: -4rem; */\r\n    padding: 10px;\r\n\r\n    \r\n    }\r\n    .destination-sec-5 .title-1{\r\n      margin-top: 0px !important;\r\n    }\r\n    .des-sec-3{\r\n      justify-content: left !important;\r\n    }\r\n    .des-sec{\r\n      justify-content: left !important;\r\n    }\r\n    .des-sec-3{\r\n      position: relative;\r\n      top: 3rem;\r\n    }\r\n  .eu .dest-yellow-sm{\r\n    margin-left: -2rem;\r\n    font-size: 30px;\r\n  }\r\n  .destination-sec-5-content{\r\n    margin-top: 2rem;\r\n  }\r\n  .destination-sec-2 .yellow-line:before{\r\n    left: 5%;\r\n    width: 100px;\r\n    top: -1rem;\r\n    }\r\n  .destination-sec-3 p{\r\n    font-size: 14px !important;\r\n    font-weight: 400 !important;\r\n  }\r\n  .destination-sec-3 h1{\r\n    font-size: 32px;\r\n    line-height: 36px;\r\n    text-align: left;\r\n    max-width: 100%;\r\n    /* margin-bottom: 2rem; */\r\n    margin-left: 0.4rem;\r\n    }\r\n  .destination-sec-3 .yellow-line:before{\r\n    left: 3px;\r\n    }\r\n  .destination-sec-3 .card{\r\n    top: 2%;\r\n    }\r\n  .destination-sec-3 .card .box{\r\n    padding: 55px 25px;\r\n  }\r\n  /* .content{\r\n    padding: 0;\r\n  } */\r\n  .africa-sec2-content{\r\n    margin-left: none !important;\r\n  }\r\n  .destination-sec-3 .card{\r\n    height: 350px;\r\n    width:288px;\r\n    margin-left:0px;\r\n  }\r\n  .dest-sec-2{\r\n    justify-content: left !important;\r\n  }\r\n  .sm-yellow{\r\n    padding-left: 1rem !important;\r\n  }\r\n  .amer-ft{\r\n    margin-top: 8rem;\r\n  }\r\n  .amer-sec5{\r\n    padding-left: 0;\r\n  }\r\n  .sm-p {\r\n    padding-left: 1rem !important;\r\n    /* padding: 0 !important; */\r\n    margin-top: -1rem !important;\r\n  }\r\n  .dest-yellow-sm{\r\n    left: 3% !important;\r\n  }\r\n  .dest-yellow-sm::before{\r\n    left: 3% !important;\r\n  }\r\n  .dest-p-sm{\r\n    padding-left: 10px;\r\n  }\r\n  .dest-rw{\r\n    justify-content: left !important;\r\n  }\r\n  .blog-sec-2 img{\r\n    width: 100%;\r\n    /* height: 350px; */\r\n    margin-top: 1rem;\r\n  }\r\n  .destination-sec-3 .card-1{\r\n    display: none;\r\n    }\r\n  .destination-sec-3 h4{\r\n    font-size: 20px;\r\n    line-height: 24px;\r\n  }\r\n  .destination-sec-5 h4{\r\n    font-size: 20px !important;\r\n    line-height: 24px !important;\r\n  }\r\n  .destination-sec-4{\r\n    margin-top: 3.5rem;\r\n  }\r\n  .destination-sec-4 p{\r\n    max-width: 88%;\r\n    text-align: center;\r\n    margin: auto;\r\n  }\r\n  .destination-sec-5 h1{\r\n    max-width: 100%;\r\n    font-size: 32px;\r\n    line-height: 36px;\r\n    text-align: left;\r\n    margin-left: -0.8rem;\r\n    margin-top: 1rem;\r\n  }\r\n  .content-america .sm-p{\r\n    margin-bottom: 2px !important;\r\n  }\r\n  .destination-sec-5 .yellow-line:before{\r\n    left: 2px;\r\n  }\r\n  .asia-sec-3{\r\n    margin-top: 1rem;\r\n  }\r\n  .destination-sec-4 img{\r\n    margin-left: 1px;\r\n    width: 600px !important;\r\n  }\r\n  .asia-image{\r\n    max-width: 600px !important;\r\n\r\n  }\r\n  .destination-sec-5 .row{\r\n    max-width: 100%;\r\n  }\r\n  .destination-sec-5 .card{\r\n    /* margin: 0px; */\r\n    margin-left: 20px;\r\n    width: 230px;\r\n    height: 298px;\r\n  }\r\n  .content-sec{\r\n    justify-content: center !important;\r\n  }\r\n  .destination-sec-5 .afr-expl{\r\n    margin-left: 0.5rem;\r\n  }\r\n  /* .home-sec-3 p{\r\n    font-size: 16px !important;\r\n  } */\r\n  .blog-banner p{\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n  }\r\n\r\n  .common-section p{\r\n    font-size: 16px ;\r\n    line-height: 24px;\r\n  }\r\n  .home-sec-2 .sec2-desc{\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n  }\r\n  .destination-sec-5 .exp-content{\r\n    margin-left: 0.5rem;\r\n  }\r\n  .destination-sec-3 .card p{\r\n    font-size: 14px !important;\r\n  }\r\n  .destination-sec-3 .card h4{\r\n    line-height: 24px !important;\r\n  }\r\n  .destination-sec-5 .card h4{\r\n    line-height: 24px !important;\r\n    margin-bottom: 0;\r\n  }\r\n  .destination-sec-5 .card p{\r\n    font-size: 14px !important;\r\n    line-height: 17px !important;\r\n    \r\n  }\r\n  .amer-scrolltop{\r\n    margin-top: 8rem;\r\n    /* margin-bottom: -5rem; */\r\n  }\r\n \r\n/* Blog */\r\n.blog-sec-2 .box{\r\n  display: block;\r\n}\r\n.timeline .col-2 img{\r\n  max-width: unset;\r\n  height: 150px;\r\n  overflow-x: hidden;\r\n}\r\n.banner-timeline{\r\n  margin-left: 0rem;\r\n}\r\n  .blog-banner{\r\n    min-height: 109vh;\r\n  }\r\n  .blog-banner h1{\r\n    font-size: 32px;\r\n    line-height: 36px;\r\n    margin-top: 8rem;\r\n    margin-bottom: 20px;\r\n  }\r\n  .blog-banner h1 span{\r\n    font-size: 39px;\r\n  }\r\n  .blog-banner p{\r\n    max-width:96%;\r\n  }\r\n  .blog-sec-2 h2{\r\n    margin-top: 0.15rem;\r\n    font-size: 32px;\r\n    line-height: 36px;\r\n  }\r\n  .blog-sec-4 h2{\r\n    font-size: 32px;\r\n    line-height: 36px;\r\n  }\r\n  .blog-sec-2 .card{\r\n    margin-right:0px;\r\n    margin-bottom: 13px;\r\n  }\r\n  .blog-sec-2 h6{\r\n    font-size: 16px;\r\n    margin-top: 15px;\r\n  }\r\n  .blog-sec-2 h4{\r\n    font-size: 18px;\r\n    line-height: 22px; \r\n    max-width: 70%;\r\n  }\r\n  .blog-sec-2 p{\r\n    font-size: 14px;\r\n    line-height: 20px; \r\n  }\r\n  .blog-sec-2 .tag {\r\n    top: 4%;\r\n}\r\n  .blog-sec-3-banner-container{\r\n    background-position:0;\r\n  }\r\n  .blog-sec-3-banner h1{\r\n    max-width: 100%;\r\n    font-size: 30px;\r\n  }\r\n  .blog-sec-2 span {\r\n    margin:10px;\r\n    margin-left: 35px;\r\n}\r\n.blog-sec-2 .card {\r\n  margin-bottom: 2rem;\r\n  width: 100%;\r\n  padding: 0;\r\n  height: fit-content;\r\n}\r\n.blog-sec-2 h4 {\r\n  height: 40px;\r\n}\r\n.blog-content {\r\n  height: 200px;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n  .blog-sec-3-banner p{\r\n    max-width: 84%;\r\n    font-size: 16px;\r\n    margin: auto;\r\n  }\r\n  .hidden-lg{\r\n    display: block !important;\r\n  }\r\n  .blog-sec-3-banner {\r\n    min-height: 105vh;\r\n  }\r\n  .blog-sec-4 h6{\r\n    font-size: 13px;\r\n    padding-bottom: 1rem;\r\n  }\r\n  .blog-sec-4 h4{\r\n    font-size: 20px;\r\n    max-width: 100%;\r\n    margin-bottom: 1rem;\r\n  }\r\n  .blog-sec-4 p{\r\n    font-size: 15px;\r\n    max-width: 100%;\r\n    margin-top: 0.5rem;\r\n  }\r\n  .blog-sec-4 .card{\r\n    margin-right: 0px;\r\n    margin-bottom: 15px;\r\n  }\r\n  .blog-sec-4 .box{\r\n    padding:20px;\r\n  }\r\n  hr.solid-small {\r\n    border-top: 2px solid white;\r\n    width: 22.6%;\r\n    opacity: 0.75;\r\n    margin-left: 39%;\r\n  }\r\n  \r\n.blog-sec-4 .slick-list{\r\n  height: 400px;\r\n  margin-top: 40px;\r\n\r\n}\r\n.blog-sec-4 .slick-next::before,.blog-sec-4 .slick-prev::before{\r\n  display: none;\r\n}\r\n.blog-sec-4 .card{\r\n  border: none;\r\n  margin: 0px;\r\n  height: 400px;\r\n  border-radius: 0;\r\n  margin-bottom: 2rem;\r\n}\r\n.blog-sec-4 .box{\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);\r\n  align-items: flex-start;\r\n  text-align: left;\r\n  padding: 42px 18px;\r\n  transition: all ease 0.3s;\r\n}\r\n\r\n\r\n.destination-sec-3 .slick-slide{\r\n  width: 310px !important;\r\n  padding-left: 20px;\r\n}\r\n\r\n\r\n.home-sec-3 .thumb-img{\r\n  justify-content: center !important;\r\n}\r\n\r\n.home-sec-3 .thumbnail-container, .home-sec-3 .thumbnail-container img{\r\n  width: 100%;\r\n}\r\n\r\n  \r\n/* Shop */\r\n\r\n  .shop-sec-2 h4{\r\n    margin-bottom: 2rem;\r\n  }\r\n  .shop-sec-2 p{\r\n    font-size: 19px;\r\n    line-height: 24px;\r\n  }\r\n  .shop-sec-2 .card{\r\n    margin-right: 0px;\r\n  }\r\n  .shop-sec-3 p{\r\n    margin-top: 8px;\r\n  }\r\n  .shop-sec-3 img{\r\n    width: 350px;\r\n  }\r\n  .shop-sec-3 .card{\r\n    height: 497px;\r\n    margin-right:0px;\r\n    margin: 0px 0px 75px 12px;\r\n  }\r\n  .shop-sec-3 .tag1 , .shop-sec-3 .tag2{\r\n    top: 4%;\r\n    left: 77%;\r\n}\r\n  .star {\r\n    max-width: 100px;\r\n  }\r\n  .shop-sec-3 .title-box{\r\n    padding-left: 15px;\r\n    padding-bottom: 25px;\r\n    }\r\n  .shop-sec-3 .btn-primary{\r\n    margin-top: 2rem;\r\n  }\r\n  .shop-sec-4 p{\r\n    max-width: 90%;\r\n    font-size: 18px;\r\n    margin-bottom: 2rem;\r\n  }\r\n  .shop-sec-4 .card{\r\n    margin: 0px;\r\n    margin-top: 2rem;\r\n    border: none;\r\n    height: 400px;\r\n  }\r\n  .shop-sec-4 .box{\r\n  margin-bottom: 2rem;\r\n  }\r\n  .shop-sec-4 .slick-dots li {\r\n    margin: -15px 10px; \r\n  }\r\n\r\n  .reduced .box {\r\n    height: 450px;\r\n    width: 358px;\r\n}\r\n/* .destination-sec-5 .slick-arrow.slick-next{\r\n  display: none !important;\r\n} */\r\n.destination-sec-5 .box{\r\n  padding: 55px 25px;\r\n}\r\n.shop-sec-4 .slick-dots li button::before {\r\n display: none;\r\n}\r\n\r\n\r\n/* ShopSub */\r\n\r\n  .shopSub2-sec-2{\r\n    margin-top:8.6rem ;\r\n  }\r\n  .shopSub-banner-container{\r\n    height: 80vh;\r\n  }\r\n  .shopSub-banner h1{\r\n    font-size: 32px;\r\n    line-height: 2.3rem;\r\n    text-align: left;\r\n    margin-top: 9rem;\r\n  }\r\n  .shopSub-banner h1 span{\r\n    font-size: 32px;\r\n  }\r\n  .shopSub-banner p{\r\n    font-size: 17px;\r\n  }\r\n  .shopSub-sec-2 p{\r\n    font-size: 20px;\r\n    line-height: 30px;\r\n    margin-left: 4rem;\r\n  }\r\n  .filter{\r\n    margin-left: -5.3rem !important;\r\n  }\r\n  .shopSub-sec-2 .col-1{\r\n    width: 3rem;\r\n    margin-left: 7rem;\r\n    margin-bottom: 0.8rem;\r\n  }\r\n  .shopSub-sec-2 .col-2{\r\n    width: 11rem;\r\n    margin-top: 1rem;\r\n    margin-bottom: 1rem;\r\n    padding-left: 0;\r\n  }\r\n  #dropdown-toggle1 {\r\n    width: 10rem;\r\n    font-size: 15px;\r\n}\r\n.shopSub-sec-2 .dropdown-menu {\r\n  min-width: 9rem;\r\n}\r\n.shop-sec-3 .overlay{\r\n  height: 108%;\r\n  width: 96%;\r\n}\r\n.overlay img{\r\n  width: 22px;\r\n}\r\n  .shopSub-sec-2 .col-5{\r\n    width: 43rem;\r\n  }\r\n  .dropdown-toggle{\r\n    padding: 7px;\r\n    width: 11rem;\r\n    height: 40px;\r\n    align-items: center;\r\n  }\r\n  .shopSub-sec-4 h6{\r\n    font-size: 21px;\r\n    line-height: 20px;\r\n  }\r\n  .shopSub-sec-4 p{\r\n    font-size: 17px;\r\n    line-height: 15px; \r\n  }\r\n  .shopSub-sec-4 .col-1{\r\n    margin-left: 1rem;\r\n    margin-top: 5px;\r\n  }\r\n  .shopSub-sec-4 .col-2{\r\n    width: 17rem;\r\n    margin-bottom: 3.9rem;\r\n  }\r\n  .hidden{\r\n    display: none !important;\r\n  }\r\n\r\n  \r\n  \r\n/* ShopSub2 */\r\n\r\n\r\n  .shopSub2-sec-4 .col-5{\r\n    border-radius: 0px;\r\n    width: 23.8rem;\r\n    height: 30rem;\r\n    margin-left: 0rem;\r\n  }\r\n  .shopSub2-sec-4 h2{\r\n    font-size: 28px;\r\n    max-width: 50%;\r\n    margin-left: 5px;\r\n  }\r\n  .shopSub2-sec-4 .col-6{\r\n    margin-left: 0rem;\r\n  }\r\n  .shopSub2-sec-4 h3{\r\n    color: #9F9F9F;\r\n    font-family: Poppins;\r\n    font-size: 15px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: normal;\r\n    margin-top: 0.3rem;\r\n    text-align: right;\r\n  }\r\n  .shopSub2-sec-4 .col-lg-5{\r\n    border-radius: 0px;\r\n    width: 100%;\r\n    height: 28rem;\r\n    margin-left: 0rem;\r\n    margin-top: 8.15rem;\r\n  }\r\n  .star1{\r\n    max-width: 100%;\r\n  }\r\n \r\n  .sofa img{\r\n    height:  23rem;\r\n    max-width: 21.8rem;\r\n    margin-left: 0;\r\n  }\r\n  .shopSub2-sec-4 h4{\r\n    font-size: 28px;\r\n    margin-top: 10px;\r\n    line-height: 29px;\r\n    text-align: right;\r\n\r\n  }\r\n  .sofa{\r\n    margin-right: 0;\r\n  }\r\n  .shopSub2-sec-4 .col-2{\r\n    width: 7rem;\r\n  }\r\n  .shopSub2-sec-4 p{\r\n    font-size: 15px;\r\n    line-height:19px;\r\n    margin-left: 5px;\r\n  }\r\n  .sh-sec-5 .col-5{\r\n    width: auto !important;\r\n    height: auto !important;\r\n  }\r\n  .shopSub2-sec-4 .btn-primary{\r\n    font-size: 18px;\r\n    padding: 12px 122px;\r\n    margin-left: 4px;\r\n  }\r\n  .shopSub2-sec-4.box {\r\n    padding: 20px; \r\n    margin: 60px; \r\n  }\r\n  .shopSub2-sec-4 .count {\r\n    margin-left: 6px;\r\n}\r\n  .shopSub2-sec-4 h6{\r\n    color: #9F9F9F;\r\n  font-family: Poppins;\r\n  font-size: 15.2px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  margin-top: 10px;\r\n  }\r\n\r\n/* Cart */\r\n\r\n  .cart-sec-2 .col-4{\r\n    margin-left: 0rem;\r\n    width: 20rem;\r\n  }\r\n  .cart-sec-2 h3{\r\n    font-size: 15px;\r\n  }\r\n  .cart-sec-2 h2{\r\n    font-size: 28px;\r\n  }\r\n  .cart-sec-2 h4{\r\n    font-size: 16px;\r\n  }\r\n  .cart-sec-2 h5{\r\n    font-size: 20px;\r\n    text-align: center;\r\n  }\r\n  .cart-sec-3 h4{\r\n    font-size: 19px;\r\n    margin-bottom: 2.8rem;\r\n  }\r\n  .cart-sec-3 h6{\r\n    font-size: 19px;\r\n    margin-bottom: 2.6rem;\r\n  }\r\n  .cart-sec-3 h5{\r\n    font-size: 24px;\r\n    margin-left: 0.5rem;\r\n  }\r\n  .cart-sec-2 .btn-primary{\r\n    font-size: 17px;\r\n    padding: 18px 95px; \r\n    margin-top: 1rem;\r\n  }\r\n  .bg{\r\n    background-color: #E5E5E5;\r\n  }\r\n  .cart-sec-2 .col-lg-4{\r\n    margin-left: 0rem;\r\n    width: 25rem;\r\n    margin-top: 1rem;\r\n    padding-top: 1rem;\r\n  }\r\n  .cart-sec-4 h4{\r\n    color: #000;\r\n    font-family: Poppins;\r\n    font-size: 19px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 22px;\r\n    margin-left: 10px;\r\n  }\r\n  .cart-sec-4 h5{\r\n    color: #000;\r\n    font-family: Poppins;\r\n    font-size: 19px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    text-align: left;\r\n    line-height: normal;\r\n    margin-left: 10px;\r\n\r\n  }\r\n  .cart-sec-4 .box-1 {\r\n    width: 100px;\r\n    border: 2px solid black;\r\n    margin-left: 10px;\r\n    margin-bottom: 30px;\r\n  }\r\n  .cart-sec-4-img img{\r\n    height: 25px;\r\n    margin-left: 20px;\r\n  }\r\n  .cart-sec-4 .col-1 {\r\n    height: 81px;\r\n    width: 81px;\r\n}\r\n.cart-sec-4 .row-1{\r\n  border-radius: 10px;\r\n  border-color: #000;\r\n}\r\n.blog-banner-container .text-overlay {\r\n  top: 30%;\r\n}\r\n\r\n  \r\n/* Checkout */\r\n\r\n  .checkout-sec-2 h1{\r\n    font-size: 36px;\r\n  }\r\n  .checkout-sec-3 .form {\r\n    padding: 7px;\r\n    width: 350px;\r\n  }\r\n  .checkout-sec-3 label {\r\n    font-size: 19px;\r\n  }\r\n  .checkout-sec-3 .input-box {\r\n    padding: 10px;\r\n    width: 100%;\r\n    height: 3.6rem;\r\n    margin-bottom: 30px;\r\n    margin-top: 5px;\r\n  }\r\n  .checkout-sec-3 h3{\r\n    font-size: 24px;\r\n    margin-left: 2.6rem;\r\n  }\r\n  .checkout-sec-3 h2{\r\n    font-size: 24px;\r\n  }\r\n  .checkout-sec-3 h5{\r\n    font-size: 24px;\r\n    line-height: 1rem;\r\n    margin-top: 1.9rem;\r\n    text-align: right;\r\n    margin-right: 0.8rem;\r\n  }\r\n  .checkout-col-1 {\r\n    margin-left: 0rem;\r\n}\r\n  .checkout-sec-3 h4{\r\n    font-size: 16px;\r\n    margin-top: 15px;\r\n  } \r\n  .checkout-col {\r\n    margin-left: 0rem;\r\n}\r\n\r\n  .checkout-sec-3 h6{\r\n    font-size: 16px;\r\n    line-height:9px;\r\n    margin-top: 2rem;\r\n    text-align: right;\r\n    margin-right: 0.9rem;\r\n  } \r\n  .checkout-sec-3 p{\r\n    font-size: 16px;\r\n    margin-top: 2rem;\r\n    margin-bottom: 1rem;\r\n  }\r\n  .para{\r\n    max-width: 95% !important;\r\n    margin-left: 0.8rem !important;\r\n  }\r\n  .checkout-sec-3 .btn-primary{\r\n    font-size: 17px;\r\n    padding: 15px 95px;\r\n    margin-bottom: 4rem;\r\n  }\r\n  .checkout-sec-3 span{\r\n    font-size: 13.6px;\r\n  }\r\n  hr.solid {\r\n    width: 98%;\r\n  }\r\n  .checkout-sec-3 h1{\r\n    font-size: 15px;\r\n  }\r\n  .cart-sec-4 .row{\r\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n    padding: 14px 0px;\r\n    border-radius: 10px;\r\n    margin-bottom: 2rem;\r\n  }\r\n  .p.know-more{\r\n    font-size: 15px;\r\n  }\r\n  \r\n  .admedia-sec-1 h2{\r\n    margin-bottom: 20px;\r\n  }\r\n  .blog-sec-2{\r\n    padding-top: 2rem;\r\n  }\r\n  .ad-media-banner-container .text-overlay {\r\n    width: 90%;\r\n    padding-left: 1rem;\r\n    top: 38%;\r\n}\r\n.ad-media-banner-container .banner p{\r\n  max-width: 100%;\r\n}\r\n.blog-banner-container .parallax-img{\r\n  margin-right: -25px;\r\n}  \r\n\r\n  /* .home.banner h1{\r\n    font-size: 31px;\r\n  } */\r\n  /* Ad&media */\r\n  .admedia-sec-1{\r\n    min-height: 62vh;\r\n  }\r\n  .admedia{\r\n    margin-top: 120px;\r\n  }\r\n  .admedia-sec-1 h1{\r\n    font-size: 32px;\r\n    line-height: 38px;\r\n    letter-spacing: -0.5px;\r\n    margin-top: 0rem;\r\n    margin-bottom: 0rem;\r\n  }\r\n  .admedia-sec-4 .box{\r\n    padding: 55px 25px;\r\n  }\r\n  .admedia-sec-1 span{\r\n    font-size: 75px;\r\n    letter-spacing: -0.1px;\r\n    line-height: 100%;\r\n    margin-top: 0rem;\r\n    text-align: left !important;\r\n    margin-left: -33px;\r\n    margin-right: auto;\r\n  }\r\n  .admedia-sec-1 p{\r\n    font-size: 17.8px;\r\n    margin-top: 5px;\r\n    max-width: 95%;\r\n  }\r\n  .admedia-sec-2 h1{\r\n    font-size: 32px;\r\n    line-height: 36px;\r\n    margin-left: 0.2rem;\r\n    margin-bottom: 0.5rem !important;\r\n    margin-top: 0rem;\r\n  }\r\n  .admedia-sec-3 p{\r\n    font-size: 17px;\r\n    margin-left: 0.2rem;\r\n  }\r\n  .tab{\r\n  justify-content: center !important;\r\n  }\r\n  .admedia-sec-3 .card{\r\n    height: 340px;\r\n    width:330px;\r\n    margin-left:0px;\r\n    margin-top: 3rem;\r\n  }\r\n  .admedia-sec-3 h4{\r\n    font-size: 25px;\r\n    line-height: 16px;\r\n  }\r\n  .admedia-sec-3 .card p{\r\n    font-size: 18px;\r\n    line-height: 25px;\r\n  }\r\n  .admedia-sec-4 h4, .admedia-sec-4 p,   .destination-sec-5 h4, .destination-sec-5 p {\r\n    color: #fff;\r\n    line-height: 15px;\r\n    margin-bottom: 10px;\r\n  }\r\n  .destination-sec-5 h4{\r\n    margin-bottom: 0px;\r\n  }\r\n  .admedia-sec-4 h4{\r\n    font-size: 20px;\r\n    line-height: 20px;\r\n  }\r\n  .admedia-sec-4 .row{\r\n    max-width: 100%;\r\n    margin: 0;\r\n  }\r\n  .admedia-sec-4 .card{\r\n    margin: 0px;\r\n    width: 90%;\r\n    /* width: 203px; */\r\n    /* height: 299px; */\r\n  }\r\n  /* .reduced .card {\r\n    transform: scale(1);\r\n} */\r\n.admedia-sec-3 .card .box {\r\n  padding: 20px 20px;\r\n}\r\n.home-sec-4>div{\r\n  flex-wrap: unset;\r\n  height: unset;\r\n  width: unset;\r\n}\r\n\r\n.contact-sec-1{\r\n  background-color: black;\r\n}\r\n  /* Gallery */\r\n\r\n  \r\n  .gallery{\r\n    margin-top: 115px;\r\n  }\r\n  .gallery-sec-1 h2{\r\n    font-size: 14px;\r\n  } \r\n  .gallery-sec-1 .col-2{\r\n    width: 4.5rem;\r\n  }\r\n  .gallery-sec-2{\r\n    margin-right: 0px;\r\n  }\r\n  .gallery-sec-2 img{\r\n    width: 500px;\r\n    margin-bottom: 15px;\r\n  }\r\n  .gallery-sec-2 .row1 img{\r\n    height: unset;\r\n    max-width: 100%;\r\n  }\r\n  .gallery-sec-2 .row2 img{\r\n    height: unset;\r\n    max-width: 100%;\r\n  }\r\n  .gallery-sec-2 .row3 img{\r\n    height: unset;\r\n    max-width: 100%;\r\n  }\r\n  /* Contact */\r\n\r\n  .contact-sec-1{\r\n    padding-top: 1.5rem;\r\n  }\r\n.contact-sec-1 h1{\r\n  font-size: 24px;\r\n  line-height: 30px;\r\n  margin-top: 0rem !important;\r\n  max-width: 100%;\r\n}\r\n.contact-sec-1 .yellow-line:before{\r\n  left: 26%;\r\n}\r\n.contact-sec-1 p{\r\n  font-size: 16.5px;\r\n  max-width: 99%;\r\n  margin-bottom: 0rem !important;\r\n  margin-top: -1.1rem;\r\n}\r\n.contact-sec-2 h1{\r\n  font-size: 35px;\r\n}\r\n.form-section h1{\r\n  font-size: 32px;\r\n  line-height: 36px;\r\n  max-width: 100%;\r\n  text-align: left;\r\n  margin-right: 0%;\r\n  margin-top: 0px !important;\r\n}\r\n#enquiryForm{\r\n  width: 100%;\r\n  margin-top: 0%;\r\n  padding: 2rem;\r\n}\r\n.form-section input, .form-section textarea, .form-section select{\r\n  /* margin-bottom: 1.5rem !important; */\r\n  margin-top: 2rem;\r\n  font-size: 16px;\r\n  }\r\n\r\n    /* about */\r\n\r\n    .about-sec-2 h1{\r\n      font-size: 30px;\r\n      line-height: 36px;\r\n      margin-bottom: 3rem;\r\n    }\r\n    .about-sec-2 .yellow-line:before{\r\n      top: 108%;\r\n      left: 1%;\r\n    }\r\n    .about-sec-2 p{\r\n      max-width: 100% !important;\r\n      margin-top: 1.5rem;\r\n    }\r\n    .padding{\r\n      padding: 0;\r\n    }\r\n    .about-sec-2 .col-lg-5{\r\n      width: 100%;\r\n    }\r\n.destination-sec-4 .col-12{\r\n  padding: 0;\r\n}\r\n.yellow-btn{\r\n  margin-top: 2.3rem !important;\r\n}\r\n.blogRead-sec-1 h1{\r\n  line-height: 39px;\r\n  font-size: 28px;\r\n  max-width: 100%;\r\n}\r\n.blogRead-sec-1 p, .blogRead-sec-2 p{\r\n  max-width: 100%;\r\n  margin-top: -1.5rem;\r\n}\r\n.blogRead-sec-1 .yellow-line:before{\r\n  left: 33%;\r\n  top:100%;\r\n}\r\n/* .blogRead{\r\n  margin-top: 7.5rem;\r\n} */\r\n.bRead{\r\n  padding: 0 !important;\r\n}\r\n.blogRead-sec-1 h3{\r\n  font-size: 20px;\r\n}\r\n.blogRead-sec-1 h2{\r\n  font-size: 18px;\r\n}\r\n.p-image{\r\n  padding: 0;\r\n}\r\n.p-image img{\r\n  width: 500px !important;\r\n}\r\n.form-section label{\r\n  font-size: 16px;\r\n  line-height: 150%;\r\n}\r\n.section{\r\n  margin-top: 9rem !important;\r\n   border-bottom-left-radius: 70px;\r\n   border-bottom-right-radius: 70px;\r\n  padding: 36px 22px;\r\n  width: 100%;\r\n}\r\n.scroll-top .col-auto{\r\n  margin-right: 1rem;\r\n}\r\n.scroll-top span{\r\n  font-size: 7px ;\r\n}\r\n.scroll-top .scroll-top-btn{\r\n  margin-bottom: -3rem;\r\n}\r\n\r\n.home-sec-6 .footer-desc {\r\n  font-size: 14px !important;\r\n}\r\n.home-sec-6 .plan-txt{\r\n  margin-bottom: 17px;\r\n  justify-content: space-between !important;\r\n}\r\n.home-sec-2 .product-card-slider .sec2-title{\r\n  line-height: 24px !important;\r\n  /* font-size: ; */\r\n}\r\n.eu.destination-sec-2 .dest-yellow-sm{\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.blog-sec-2 .blog-box .date{\r\n  font-size: 14px;\r\n  margin-bottom: 1.2rem;\r\n}\r\n.blog-sec-2 .blog-box .descr1{\r\n  margin-bottom: 10px;\r\n  font-size: 18px;\r\n  line-height: 20px;\r\n}\r\n.blog-sec-2 .blog-box .adventure-text{\r\n  margin-bottom: 10rem !important;\r\n}\r\n\r\n#blog-scroller .product-card-slider .slick-slide{\r\n  width: 300px;\r\n  opacity: 50%;\r\n}\r\n\r\n#blog-scroller .product-card-slider span{\r\n  font-size: 15px;\r\n  line-height: 20px;\r\n}\r\n#blog-scroller .product-card-slider .slick-active{\r\n  opacity: 100%;\r\n}\r\n.dest-contact .contact-arrow{\r\n  position: relative;\r\n  bottom: 2px;\r\n  left: 10px;\r\n}\r\n.home-sec-6 .contact-btn{\r\n  padding: 10px 44px;\r\n}\r\n.home-sec-6 .footer-title {\r\n  font-size: 40px !important;\r\n  line-height: 48px;\r\n}\r\n\r\n}\r\n\r\n/* for destination cards */\r\n@media (max-width:360px){\r\n  .destination-sec-3 .card{\r\n    width: 240px;\r\n  }\r\n  .destination-sec-3 .slick-slide {\r\n    width: 260px !important;\r\n  }\r\n}\r\n\r\n@media (min-width:992px){\r\n  .destination-sec-3 .card-1{\r\n    margin-top: 7rem;\r\n  }\r\n  .amer-sec5{\r\n    margin-bottom: 2rem;\r\n  }\r\n  .eu-sec-5 .dest-sec-2{\r\n    margin-bottom: 2.5rem;\r\n  }\r\n  .blog-sec-2{\r\n    padding-top: 3rem;\r\n  }\r\n  .me-banner-content, .la-banner-content{\r\n    width: 53%;\r\n  }\r\n  /* .dest-contact .contact-arrow{\r\n    position: relative;\r\n    bottom: 2px;\r\n    left: 10px;\r\n  }\r\n  .dest-contact{\r\n    padding: 5px 20px;} */\r\n}\r\n\r\n\r\n@media (min-width:1400px){\r\n  .home.banner p{\r\n    max-width: 75%;\r\n  }\r\n  /* .home-sec-2 .card{\r\n    width: 310px;\r\n    height: 380px;\r\n  } */\r\n  .home-sec-2 .slick-slide{\r\n    width: 320px;\r\n  }\r\n  /* .home-sec-2 .card-img-top{\r\n    height: 410px;\r\n  } */\r\n  /* .home-sec-2 .card:hover{\r\n    height: 470px;\r\n  } */\r\n\r\n  .ad-media-banner-container .text-overlay {\r\n    width: 100%;\r\n    padding-left: 6rem;\r\n  }\r\n  .ad-media-banner-container .banner p {\r\n    max-width: 75%;\r\n  }\r\n  \r\n\r\n  .gallery-sec-2 .row1 img{\r\n    height: 390px;\r\n    max-width: 100%;\r\n  }\r\n  .gallery-sec-2 .row2 img{\r\n    height: 763px;\r\n    max-width: 100%;\r\n  }\r\n  .gallery-sec-2 .row3 img{\r\n    height: 367px;\r\n    max-width: 100%;\r\n  }\r\n  .destination-sec-4 img{\r\n    height: 280px;\r\n  }\r\n  .shopSub-sec-4 .col-2 {\r\n    width: 17rem;\r\n  }\r\n  /* .timeline{\r\n    margin-top: 21rem;\r\n  } */\r\n    .price{\r\n      margin-left: 5.4rem !important;\r\n    }\r\n    .quantity{\r\n      margin-left: 6.3rem !important;\r\n    }\r\n    .total{\r\n      margin-left: 4.2rem !important;\r\n    }\r\n    .cart-sec-2 h3{\r\n      margin-left: 7.6rem\r\n    }\r\n    .checkout-sec-3 .form {\r\n      width: 530px;\r\n    }\r\n    .para{\r\n      max-width: 93% !important;\r\n    }\r\n    .banner h1 ,.shopSub-banner h1, .shopSub-banner h1 span{\r\n      font-size: 40px;\r\n    }\r\n    .blog-banner h1, .blog-banner h1 span{\r\n      font-size: 40px;\r\n    }\r\n    .shopSub-sec-2 .col-5 {\r\n      width: 55rem;\r\n  }\r\n    .gallery-sec-1 h2{\r\n      font-size: 13px;\r\n    }\r\n    .shopSub-sec-4 img{\r\n      margin-left: 55px;\r\n    }\r\n    .shopSub-sec-4 h6 , .shopSub-sec-4 p {\r\n      margin-left: 50px;\r\n    }\r\n    .banner-timeline{\r\n      margin-left: 7rem;\r\n    }\r\n    .line{\r\n      width: 6.45rem;\r\n    }\r\n    .shopSub-banner-container {\r\n      padding-top: 12rem;\r\n  }\r\n  .destination-banner .col-lg-5{\r\n    width: 30.5%;\r\n    }\r\n    .shop-sec-4 .slick-next{\r\n      left: calc( 100vw - 85%);\r\n    }\r\n     .shop-sec-4 .slick-current .card{\r\n      height: 455px;\r\n      width: 410px;\r\n}\r\n/* .blog-sec-2 img {\r\n  width: 380px;\r\n} */\r\n\r\n.home-sec-4 .card:last-child .box:hover .line{\r\n  width: 125px;\r\n  \r\n}\r\n.home-sec-4 .card:last-child .box .line{\r\n  left: 36%;\r\n  \r\n}\r\n.about-sec-2 .padding{\r\n  margin-right: 2rem;\r\n}\r\n\r\n.admedia {\r\n  margin-top: 130px;\r\n}\r\n.admedia-sec-4 .card{\r\n  width: 430px;\r\n}\r\n.cart-sec-2 .col-lg-4{\r\n  margin-left: 6.5rem;\r\n}\r\n.checkout-sec-3 h3{\r\n  margin-left: 7.5rem;\r\n}\r\n.checkout-sec-3 h5{\r\n  margin-left: 8.7rem;\r\n}\r\n.checkout-sec-3 h6{\r\n  margin-left: 10rem;\r\n} \r\n.destination-sec-3 .card{\r\n  left: 10%;\r\n}\r\n.form-section h1{\r\n  margin-right: 32%;\r\n}\r\n.asia .col-lg-7{\r\n  width: 45%;\r\n}\r\n.africa .col-lg-7{\r\n  width: 46%;\r\n}\r\n.europe .col-lg-7{\r\n  width: 49%;\r\n}\r\n/* .blog-sec-2 {\r\n  margin-left: 8rem;\r\n} */\r\n/* .blog-sec-2 .card-sec{\r\n  margin-left: -20px;\r\n} */\r\n.blog-sec-2 .card-sec-2{\r\n  margin-left: -20px;\r\n  margin-top: 5rem;\r\n}\r\n.blog-sec-2 .trending{\r\n  position: relative;\r\n  /* left: -20px; */\r\n}\r\n.admedia-card {\r\n  padding: 2rem;\r\n}\r\n.me-banner-content, .la-banner-content{\r\n  width: 50%;\r\n}\r\n.blog-sec-2 .blog-row{\r\n  margin-bottom: 6rem !important;\r\n}\r\n.blog-sec-2 .card {\r\n  margin-bottom: 6rem\r\n}\r\n\r\n    \r\n}\r\n\r\n/* @media (min-width:1280px){\r\n  .home-sec-2 .slick-next {\r\n    padding-right: 5rem;\r\n  }\r\n} */\r\n\r\n@media (max-width:335px){\r\n  /* .home-sec-4 .yellow-line {\r\n    margin-top: 23rem;\r\n  } */\r\n  .home-sec-3 span {\r\n    font-size: 18px;\r\n  }\r\n  .social-icons-container {\r\n    font-size: 14px !important;\r\n  }\r\n  .abt-exp {\r\n    margin-left: -6rem !important;\r\n}\r\n.asia-sec-3 {\r\n  margin-top: 6rem;\r\n}\r\n.destination-sec-2.middleEast h1  {\r\n  margin-top: 10rem !important;\r\n}\r\n.destination-sec-5 h1 {\r\n  margin-top: 6rem ;\r\n}\r\n.destination-sec-2 h1{\r\n  margin-top: 3rem;\r\n}\r\n.destination-sec-3 h1{\r\n  margin-top: 4rem !important;\r\n}\r\n.home-sec-2 .slick-next{\r\n  right: 11rem;\r\n}\r\n.home-sec-4 .slick-next {\r\n  right: 13rem;\r\n}\r\n.navbar-toggler {\r\n  padding-right: 5px !important;\r\n}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
